import { IObservableValue, observable } from "mobx";

import {
  MAX_GIVE_ALKHATTABAT_IN_DAYS,
  MAX_GIVE_ALKHATTABAT_IN_HOURS,
  MAX_GIVE_ALKHATTABAT_IN_MIN,
  MAX_GIVE_GOLD_IN_DAYS,
  MAX_GIVE_GOLD_IN_HOURS,
  MAX_GIVE_GOLD_IN_MIN,
  MAX_GIVE_PLATINUM_IN_DAYS,
  MAX_GIVE_PLATINUM_IN_HOURS,
  MAX_GIVE_PLATINUM_IN_MIN,
  MAX_GIVE_PLUS_IN_DAYS,
  MAX_GIVE_PLUS_IN_HOURS,
  MAX_GIVE_PLUS_IN_MIN,
  MAX_GIVE_SILVER_IN_DAYS,
  MAX_GIVE_SILVER_IN_HOURS,
  MAX_GIVE_SILVER_IN_MIN,
  MAX_GIVE_VIP_IN_DAYS,
  MAX_GIVE_VIP_IN_HOURS,
  MAX_GIVE_VIP_IN_MIN,
  MAX_PROMOCODE_REWARD_IN_HOURS,
  MAX_PROMOCODE_GENERATION_COUNT,
  MIN_GIVE_GOLD_IN_DAYS,
  MIN_GIVE_PLATINUM_IN_DAYS,
  MIN_GIVE_SILVER_IN_DAYS,
  MAX_GIVE_ADVANCED_IN_DAYS,
  MAX_GIVE_ADVANCED_IN_HOURS,
  MAX_GIVE_ADVANCED_IN_MIN,
  MAX_GIVE_BLACK_IN_DAYS,
  MAX_GIVE_BLACK_IN_HOURS,
  MAX_GIVE_BLACK_IN_MIN,
  MIN_GIVE_BLACK_IN_DAYS,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH
} from "./input-entries-constants";

export type Ti18nKeys =
  | "CHOOSE"
  | "ENVIRONMENT"
  | "DEPLOYED"
  | "ALKHATTABA_ADMIN"
  | "MAIN_NAVIGATION"
  | "ET3ARRAF"
  | "USERNAME"
  | "PASSWORD"
  | "SIGN_IN"
  | "SIGNING_IN"
  | "LOGIN_TAGLINE"
  | "LOGIN_SUBTITLE"
  | "LOGIN_USERNAME_HINT"
  | "ERROR_MESSAGE"
  | "LIMIT"
  | "DATE_MIN"
  | "DATE_MAX"
  | "PLATFORM"
  | "STATUS"
  | "COUNTRY_CREATED_FROM"
  | "TYPE"
  | "COUNTRY"
  | "SENDER_ID"
  | "RECEIVER_ID"
  | "ADMIN"
  | "USER"
  | "MONITOR_USER_MESSAGES"
  | "USER_MESSAGES_TABLE"
  | "USER_ID"
  | "TRANSACTION_ID"
  | "DEVICE_ID"
  | "VIP_DAYS"
  | "VIP_HOURS"
  | "SEARCH_BY"
  | "GET"
  | "VIEW_CONVERSATION"
  | "GET_RESULTS"
  | "EVENTS_LIST"
  | "EVENTS_COUNT"
  | "SEARCH_BY_USER_ID"
  | "SEARCH_BY_TRANSACTION_ID"
  | "ONLY_FOR_SE"
  | "CHANGE_STATUS"
  | "CHANGE_USERNAME"
  | "MAKE_VIP"
  | "FLAG"
  | "RESET_ACCOUNT"
  | "CLEAN_POOL"
  | "PICTURE"
  | "DESCRIPTION"
  | "NO_DESCRIPTION"
  | "APPROVED"
  | "REJECTED"
  | "REJECT_PICTURE"
  | "REJECT_DESCRIPTION"
  | "OLD_PASSWORD"
  | "NEW_PASSWORD"
  | "CONFIRM_PASSWORD"
  | "CHANGE_ROLE"
  | "CHANGE_PASSWORD"
  | "RESOLVE"
  | "WARN"
  | "EMAIL"
  | "BAN"
  | "SILENTLY_BANNED_USERS"
  | "FROM_DATE"
  | "TO_DATE"
  | "SILENT_BAN"
  | "SILENT_BANNED"
  | "REMOVE_SILENT_BAN"
  | "REMOVE_SILENT_BAN_POPUP_TEXT"
  | "SILENT_BAN_REMOVED_SUCCESSFULLY"
  | "USER_IS_NOT_SILENT_BANNED"
  | "TEMPORARY_BAN"
  | "SEARCH"
  | "SEARCH_USER_ID"
  | "SALARY"
  | "WELCOME_SUBTITLE"
  | "YOUR_QUEUES"
  | "OPEN_QUEUE"
  | "LAST_LOGIN_AT"
  | "PASSWORD_REQUIREMENTS"
  | "PASSWORD_RULE_LETTERS"
  | "PASSWORD_RULE_NUMBER"
  | "PASSWORD_RULE_LENGTH"
  | "PASSWORD_RULE_NO_ARABIC"
  | "PASSWORD_RULE_UPPERCASE"
  | "PASSWORD_RULE_LOWERCASE"
  | "PASSWORD_RULE_SYMBOL"
  | "PASSWORD_RULE_NO_ARABIC_OR_SPACES"
  | "PASSWORD_RULE_DIFFERENT_FROM_OLD"
  | "PASSWORD_RULE_MATCH"
  | "SHOW_PASSWORD"
  | "HIDE_PASSWORD"
  | "CHANGE_PASSWORD_SUBTITLE"
  | "SEARCH_NO_RESULT"
  | "SEARCH_SENSITIVE_CASE"
  | "SHAREHOLDER_DASHBOARD"
  | "UPDATED_ON"
  | "REPORTS"
  | "STATS"
  | "REPORTS_USER_TO_USER"
  | "DASHBOARD"
  | "CONTROL_PANEL"
  | "CONVERSATION"
  | "BETWEEN_TWO_USERS"
  | "OH_ITS_ME"
  | "OH_NO"
  | "WARNING"
  | "SUCCESS"
  | "APPROVAL"
  | "APPROVE_USER_DATA"
  | "MONITOR_USER_PAYMENTS"
  | "MONITOR_USER_LOGIN"
  | "USER_LOGIN_TABLE"
  | "USER_ACTION_BUTTONS"
  | "MONITOR_USER_EVENTS"
  | "DEVICES"
  | "ADVANCED_MODE"
  | "INFO_ABOUT_USER_ACTIVITIES"
  | "GET_SIDED_STATISTICS"
  | "VIEW_EDIT_ADMIN_POOL"
  | "POOL_TABLE"
  | "VIEW_EDIT_ADMIN_PERMISSION"
  | "INVESTIGATION_CASES"
  | "ADMIN_EVENTS"
  | "VIEW_ADMIN_EVENTS"
  | "VIEW_ADMIN_EVENTS_CHARTS"
  | "VIEW_ADMIN_AUDITED_EVENTS"
  | "NO_RECEIPT_TOKEN_FOUND"
  | "COPYRIGHT"
  | "ET3ARRAF_SAL"
  | "ALL_RIGHTS_RESERVED"
  | "VERSION"
  | "APPROVE_REJECT_DATA"
  | "SHAREHOLDERS_UPDATE"
  | "USER_MESSAGES"
  | "USER_PAYMENTS"
  | "USER_EVENTS"
  | "COMMUNITY"
  | "ENGAGMENT"
  | "FINANCIALS"
  | "USER_LOCATION_CHART_TITLE"
  | "USER_GENDER_CHART_TITLE"
  | "GCC_COUNTRIES"
  | "LEVANT_COUNTRIES"
  | "NA_COUNTRIES"
  | "OTHER_COUNTRIES"
  | "TOTAL_CONVERSATIONS_CHART_TITLE"
  | "TOTAL_MONTHLY_CONVERSATIONS_CHART_TITLE"
  | "TWO_SIDED_CONVERSATION_RATIO"
  | "TOTAL_USERS_NUMBERS"
  | "TOTAL_MONTHLY_NEW_USERS"
  | "EXPENSES_PER_MONTH"
  | "APPROVE_REJECT"
  | "LAST_LOGIN"
  | "SIGN_OUT"
  | "REASON"
  | "COMMENT"
  | "REPORTER"
  | "REPORTED"
  | "REFRESH"
  | "REPORT_REASON_1"
  | "REPORT_REASON_2"
  | "REPORT_REASON_3"
  | "REPORT_REASON_4"
  | "REPORT_REASON_5"
  | "PAID"
  | "NOT_PAID"
  | "INVALID_CREDENTIALS"
  | "INCORRECT_NEWPASSWORD"
  | "INCORRECT_OLD_PASSWORD"
  | "SERVER_ENCOUNTERED_ERROR"
  | "PASSWORD_CHANGE_SUCCESSFUL"
  | "WRONG_INPUT"
  | "LOADING"
  | "ACCEPT"
  | "INSERT_PROOF"
  | "ACCEPT_DESCRIPTION"
  | "ACCEPT_PICTURE"
  | "USER_STATUS_CHANGED_SUCCESSFULLY"
  | "USER_NAME_CHANGED_SUCCESSFULLY"
  | "USER_VIP_ADDED_SUCCESSFULLY"
  | "USER_FLAGGED_SUCCESSFULLY"
  | "USER_GENDER_CHANGED_SUCCESSFULLY"
  | "DESCRIPTION_REJECTED_SUCCESSFULLY"
  | "PEER_DESCRIPTION_REJECTED_SUCCESSFULLY"
  | "DESCRIPTION_APPROVED_SUCCESSFULLY"
  | "PEER_DESCRIPTION_APPROVED_SUCCESSFULLY"
  | "PICTURE_REJECTED_SUCCESSFULLY"
  | "PICTURE_APPROVED_SUCCESSFULLY"
  | "ORDER"
  | "USER_EVENTS_TABLE"
  | "USER_DEVICES_TABLE"
  | "DEVICE_UNLINKED_SUCCESSFULLY"
  | "PERMISSIONS_TABLE"
  | "MESSAGES_SEND_FROM"
  | "UPDATE_PERMISSIONS"
  | "FROM"
  | "TO"
  | "ACTION_TAKEN"
  | "TBW"
  | "TBW_REASONS"
  | "SELECT_REASONS_OF_ACTION"
  | "ACTIVE"
  | "WRONG_AND_FIX"
  | "CORRECT"
  | "WRONG"
  | "INCORRECT_VIP_DAYS_HOURS"
  | "SELECT_SMALLER_DATE_RANGE"
  | "SELECT_CORRECT_DATE_RANGE"
  | "CHECK_START_EXPIRY_DATE"
  | "GENDER"
  | "EXPAND_SECTION"
  | "COLLAPSE_SECTION"
  | "USER_SUMMARY"
  | "MODERATION_STATE"
  | "NO_OPEN_REPORT"
  | "TESTER_ACCOUNT"
  | "NONE_VALUE"
  | "NOT_ACTIVATED"
  | "ACTIVATED"
  | "ON_VALUE"
  | "OFF_VALUE"
  | "SELFIE_VERIFIED"
  | "NO_DESCRIPTION_SUBMITTED"
  | "APPROVE"
  | "REJECT"
  | "ROW_NUMBER"
  | "VALUE_COLUMN"
  | "DATE_COLUMN"
  | "ADMIN_NAME"
  | "QUESTION_ID"
  | "ALLOWED_ANSWERS"
  | "QUESTION"
  | "ANSWER"
  | "VERIFICATION_ACTIVE"
  | "USER_ACTIVITY_EMAILS_SUBSCRIPTION"
  | "PROMOTIONAL_EMAILS_SUBSCRIPTION"
  | "NEW_MESSAGE_EMAILS_SUBSCRIPTION"
  | "VISIT_PROFILE_EMAILS_SUBSCRIPTION"
  | "LIKE_EMAILS_SUBSCRIPTION"
  | "USER_ACTIVITY_EMAILS_SETTINGS"
  | "PROMOTIONAL_EMAILS_SETTINGS"
  | "NEW_MESSAGE_EMAILS_SETTINGS"
  | "VISIT_PROFILE_EMAILS_SETTINGS"
  | "LIKE_EMAILS_SETTINGS"
  | "PAID_FEATURE_SETS"
  | "CONSUMABLES_LANE"
  | "VIA_FEATURE_SETS"
  | "OPEN_CASE"
  | "YES_VALUE"
  | "NO_VALUE"
  | "IDENTITY_AND_ACCOUNT"
  | "ACTIVATION_AND_VERIFICATION"
  | "DEVICE_AND_SESSION"
  | "SUBRELIGION"
  | "STATUS_CHANGE_DATE"
  | "APP_LANGUAGE"
  | "APPROVED_PICTURES"
  | "SELFIE_COMPLETED_ON"
  | "ACTIVATION_CODE"
  | "SELFIE_VERIFICATION"
  | "NOT_VERIFIED_BADGE"
  | "FACEBOOK_VERIFY"
  | "SMS_VERIFY"
  | "EMAIL_VERIFY"
  | "APPLE_VERIFY"
  | "EMAIL_NOTIFICATION"
  | "PUSH_NOTIFICATION"
  | "PHONE_DETAILS"
  | "IP_ADDRESS"
  | "DEVICE_TOKEN"
  | "WAS_PAYING"
  | "FREEMIUM_GRANTS"
  | "PAID_UNTIL"
  | "KHATTABA_ASSIGNED"
  | "VERIFIED_BADGE"
  | "DESCRIPTIONS"
  | "DEACTIVATED_ON"
  | "USER_PROFILE_AND_DESCRIPTIONS"
  | "SUBSCRIPTIONS_AND_FEATURES"
  | "USER_ALL_FIELDS"
  | "NONE_ACTIVE"
  | "CREATED_ON"
  | "CREATED_FROM"
  | "CITY_NAME"
  | "ORIGIN_COUNTRY"
  | "RESIDENCE_COUNTRY"
  | "ACTIVATION_STATUS"
  | "TEMPORARY_BANS"
  | "WARNINGS"
  | "REPORTS_SENT"
  | "REPORTS_RECEIVED"
  | "LOGIN_COUNT"
  | "REFERRAL_CODE"
  | "APP_VERSION"
  | "USER_ADVANCED_TABLE"
  | "USER_ADVANCED_QUIZ_TABLE"
  | "USER_ADVANCED_EMAIL_TABLE"
  | "VIEW_EDIT_ADMIN_DASHBOARD"
  | "MINOR_ISSUE"
  | "MAJOR_ISSUE"
  | "NO_ISSUE"
  | "USER_WARNED"
  | "REPORT_RESOLVE"
  | "REPORT_EMAIL"
  | "USER_BANNED"
  | "USER_TEMPORARY_BANNED"
  | "AUDIT_PERFORMANCE"
  | "IMAGE_DELETED"
  | "SUPERVISOR"
  | "COMMUNICATIONS"
  | "MARK_SEEN"
  | "SUPERVISE"
  | "SUPERVISE_ADMIN_AUDITS"
  | "VIEW_SUPERVISED_EVENTS"
  | "AUDIT_EFFICIENCY"
  | "Admin_Audit_Helper_Text"
  | "Admin_Audit_Events_Helper_Text"
  | "Supervise_Helper_Text"
  | "Supervise_Events_Helper_Text"
  | "MONITOR_USER_MESSAGE_ID"
  | "MESSAGE_ID"
  | "USER_MESSAGES_ID_TABLE"
  | "WRONG_MESSAGE_ID"
  | "WORKLOAD_DATA"
  | "WORKLOAD_DATA_BETWEEN_TWO_DATES"
  | "WORKLOAD_TABLE"
  | "AUDITING_PERFORMANCE"
  | "AUDITING_PERFORMANCE_DASHBOARD"
  | "ADD_REMOVE"
  | "PROOF_MINOR_MAJOR"
  | "DATE_RANGE"
  | "USER_EDIT_PROFILE"
  | "USER_EDIT_PROFILE_ARCHIVE"
  | "EDIT_USER_DATA"
  | "INVALID_PASSWORD"
  | "INCORRECT_PASSWORD_REPEATED"
  | "REFERRAL_CODE_USAGE"
  | "USER_REFERRAL_CODE_USAGE_TABLE"
  | "WRONG_USER_ID"
  | "USER_DATA_CHANGED"
  | "USER_BANNED_SUCCESSFULLY"
  | "USER_WARNED_SUCCESSFULLY"
  | "PERMISSION_CHANGED"
  | "POOL_CLEANED"
  | "USER_LATEST_RECEIPT"
  | "LOAD_MORE"
  | "TESTER"
  | "OPTIONS"
  | "ADD_TBW"
  | "ISSUE_TYPE"
  | "PAYMENT_PACKAGES_TODAY"
  | "PAYMENT_PACKAGES_PREV_DAY"
  | "ON_CALL"
  | "PACKAGE_NOTIFICATION_TYPE_COUNT"
  | "COPY"
  | "COPIED"
  | "STATS_DASHBOARD"
  | "PERFORMANCE"
  | "EFFECTIVENESS"
  | "REFRESH"
  | "USER_EMAIL_EVENTS_TABLE"
  | "USER_DEACTIVATIONS_TABLE"
  | "FLAGGED_CONNECTIONS_HISTORY"
  | "FLAGGED_CONNECTIONS_DETAILS"
  | "FLAGGED_CONNECTIONS_DASHBOARD"
  | "IOS_PAYMENTS"
  | "ANDROID_PAYMENTS"
  | "LAST_LOGIN_USERS"
  | "EMAIL_USERS"
  | "SENT_EMAILS"
  | "SMS_USERS"
  | "FB_USERS"
  | "NEW_USERS"
  | "TIME_FRAME"
  | "DAILY_STATS"
  | "REPORT_POOL_TABLE"
  | "APPROVAL_POOL_TABLE"
  | "INVESTIGATION_CASES_POOL_TABLE"
  | "UNLINK_DEVICE"
  | "INVESTIGATE"
  | "ALREADY_EXISTING_VALUE"
  | "SORRY_NO_PERMISSION"
  | "MY_CSR_PERFORMANCE"
  | "DEV_ZONE"
  | "SAVE"
  | "EDIT"
  | "DELETE"
  | "HELPER"
  | "EMPTY_STRING"
  | "DIVISION_BY_CSR"
  | "PAYMENT_DATA_HELPER"
  | "USER_NAME_CONDITIONS"
  | "SAME_USER_NAME"
  | "EVENTS_NOT_FOUND"
  | "SESSION_EXPIRED"
  | "WELCOME"
  | "CSR"
  | "AUDITOR"
  | "USER_RATE_US_DATA"
  | "USER_RATE_US_DATA_NOT_FOUND"
  | "USER_RESET_SUCCESSFULLY"
  | "EMAIL_SUBSCRIPTION_STATUS_CHANGHED"
  | "CSRS_PERFORMANCE"
  | "FLUSH_HOSTS"
  | "DANGER_TO_PRESS"
  | "PASSCODE"
  | "ERROR"
  | "OK"
  | "REACTION_HISTORIES"
  | "REACTION_ADDED"
  | "REACTION_CHANGED"
  | "REACTION_REMOVED"
  | "REACTION_CURRENT"
  | "REACTION_SUPPRESSED"
  | "NO_REACTION_HISTORY"
  | "REACTION_SENDER_WITH_ID"
  | "REACTION_RECIPIENT_WITH_ID"
  | "ET3ERROR"
  | "ROUTE_NOT_DEFINED"
  | "INVALID_MISSING_ID_TYPE_NUMBER"
  | "INVALID_PASSWORD_NUM"
  | "INVALID_USER_ID"
  | "INVALID_PLATFORM"
  | "INVALID_CREDENTIALS_NUM"
  | "INVALID_INPUT"
  | "INVALID_EVENT_TYPE"
  | "INVALID_STATUS"
  | "INVALID_TIME_FRAME"
  | "INVALID_COUNTRY"
  | "APPROVAL_DATA_NOT_FOUND"
  | "REPORTS_NOT_FOUND"
  | "ACTIVITIES_NOT_FOUND"
  | "NO_RESULT"
  | "SERVER_ERROR_SHOWING_CONTACT"
  | "USER_NOT_FOUND"
  | "ADMIN_ID_REQUIRED"
  | "ADMIN_NOT_FOUND"
  | "NO_PERMISSION"
  | "DEVICE_NOT_FOUND"
  | "USER_LOGIN_NOT_FOUND"
  | "PAYMENTS_NOT_FOUND"
  | "TRANSACTION_NOT_FOUND"
  | "MESSAGES_NOT_FOUND"
  | "CONVERSATION_NOT_FOUND"
  | "INCORRECT_PASSWORD"
  | "NO_APPROVAL_DATA"
  | "SOMETHING_WRONG"
  | "CANNOT_CHANGE_STATUS_TO_ACTIVE"
  | "POOL_ALREADY_EMPTY"
  | "WRONGKEY"
  | "WRONGBODYCOUNT"
  | "REFERRAL_CODE_NOT_FOUND"
  | "USER_HAS_NO_REFERRAL_CODE"
  | "INVALID_TOKEN"
  | "INVALID_USER_NAME"
  | "PLEASE_SHARE_FACEBOOK"
  | "PLEASE_SHARE_NUMBER"
  | "PLEASE_SHARE_DATA_TABLE"
  | "PLEASE_SHARE_USERS_TABLE"
  | "PLEASE_SHARE_APPLE_ID"
  | "MY_AUDITING_PERFORMANCE"
  | "MY_CSR_MISTAKES"
  | "MY_AUDITING_MISTAKES"
  | "WATCH_ALERTS"
  | "WATCH_ALERT_DASHBOARD"
  | "USERS"
  | "USERS_LOGIN"
  | "USERS_PAYMENTS"
  | "WEB_ANDROID_PAYMENTS"
  | "WEB_IOS_PAYMENTS"
  | "ADVANCED"
  | "CONVERSATIONS"
  | "EVENTS"
  | "LOGIN"
  | "MESSAGES"
  | "MEESAGE_ID"
  | "PAYMENTS"
  | "AUDIT"
  | "AUDITED_EVENTS"
  | "OTHER_CSRS_PERFORMANCE"
  | "EVENTS_CHART"
  | "PERMISSION"
  | "SUPERVISED_EVENTS"
  | "RESET_PASSWORD"
  | "RESET_ADMIN_PASSWORDS"
  | "NEW_GENERATED_PASSWORD"
  | "FLAGGED_CONNECTIONS"
  | "FLUSH"
  | "ALARMS"
  | "PROMO_CODE"
  | "PROMO_CODE_DESCRIPTION"
  | "PROMO_CODE_REWARD_IN_HOURS"
  | "PROMO_CODE_NATIONALITY"
  | "PROMO_CODE_VIP_MAX_USAGE"
  | "PROMO_CODE_ACTIVE"
  | "PROMO_CODE_NUMBER_OF_CODES"
  | "PROMO_CODE_START_DATE"
  | "PROMO_CODE_EXPIRY_DATE"
  | "GENERATE"
  | "PROMO_CODE_GENERATED_SUCCESSFULLY"
  | "PROMO_CODES"
  | "PROMO_CODE_ID"
  | "USER_PROMO_CODE_USAGE_TABLE"
  | "PROMO_CODE_USAGE"
  | "COMMUNICATIONS_PROMO_CODE_GENERATOR"
  | "AUDITOR_WEB_PAYMENTS"
  | "SHOW_WEB_PAYMENTS"
  | "ALL_PROMO_CODES"
  | "UPDATE_PROMO_CODE"
  | "PROMO_CODE_PAID"
  | "PROMO_CODE_UPDATED_SUCCESSFULLY"
  | "PROMO_CODE_IS_NO_UPDATED"
  | "FLAGGED_CONNECTION_ADMIN"
  | "FLAGGED_CONNECTION_WEB"
  | "FLAGGED_CONNECTION_APP"
  | "FLAGGED_CONNECTION"
  | "ON_CALL_TEAM"
  | "USER_ID_PICTURE_REJECT"
  | "VIP_DETAILS"
  | "RATE_LIMIT"
  | "ON_ALERT"
  | "EMPTY_TBW_REASONS_DATA"
  | "PROMOCODE_REWARD_IN_HOURS"
  | "PROMOCODE_NOT_SUPPORTED_FOR_GENDER"
  | "PROMOCODE_NUMBER_OF_CODES_MAX"
  | "PROMO_STATUS_NOT_UPDATED_SUCCESSFULLY"
  | "FLUSH_HOST_ALERT"
  | "MY_CSR_PREV_ACTIONS"
  | "USER_ALBUM_PICTURES"
  | "USERS_DATA"
  | "USERS_PURCHASES_AND_SUBSCRIPTIONS"
  | "USER_BREACHES_TABLE"
  | "TB_DEACTIVATED_USER"
  | "EMAIL_SENT"
  | "USER_NAME"
  | "NATIONALITY"
  | "COUNTRY_OF_RESIDENCE"
  | "CITY_OF_RESIDENCE"
  | "AGE"
  | "HEIGHT"
  | "WEIGHT"
  | "USER_SEARCH_TYPE_REQUIRED"
  | "USER_ALL_COMMENTS"
  | "ADD_COMMENTS_POPUP_TEXT"
  | "ADD_RESET_ACCOUNT_POPUP_TEXT"
  | "ADD_COMMENT"
  | "EMPTY_COMMENT"
  | "UNDER_CSR_INVESTIGATION_STATUS"
  | "INVESTIGATION_CASES_NOT_FOUND"
  | "DESCRIPTION_ABOUT_ME"
  | "DESCRIPTION_ABOUT_MY_PARTNER"
  | "VIEW_ACCOUNTS_DELETION_DATA"
  | "ACCOUNT_DELETION_HELPER_TEXT"
  | "ACCOUNTS_DELETION_DATA"
  | "COMMUNICATIONS_ACCOUNTS_DELETION"
  | "FOUND_PARTNER_OUTSIDE_ET3ARRAF"
  | "NOT_AS_EXPECTED"
  | "OTHER_REASONS"
  | "ER3ARRAF_IS_HARD_TO_USE"
  | "NOT_ABLE_TO_FIND_PARTNER"
  | "FOUND_PARTNER_THROUGH_ET3ARRAF"
  | "ACCOUNTS_DELETION_DATA_NOT_FOUND"
  | "USER_ALREADY_UNDER_CSR_INVESTIGATION"
  | "REPORT_NOT_FOUND"
  | "TURN_OFF_ALARMS"
  | "TURN_OFF_FEATURES"
  | "FEATURES"
  | "KHATTABAT_CAPACITY"
  | "FEATURE_OFF"
  | "FEATURE_ON"
  | "ALARMS_OFF"
  | "ALARMS_NOT_FOUND"
  | "USER_STATUS_DATE"
  | "USER_EMAIL_SUBSCRIPTION"
  | "QA"
  | "CHANGE_EMAIL_SUBSCRIPTION"
  | "USER_STATUS"
  | "QA_CHANGE_STATUS_DATE"
  | "SUBSCRIBE"
  | "UNSUBSCRIBE"
  | "QA_NEW_STATUS_DATE"
  | "UPDATING_TO_VERSION"
  | "EXPORT_TO_CSV_FILE"
  | "PEER_DESCRIPTION_ACTION_ALREADY_DONE"
  | "PICTURE_ACTION_ALREADY_DONE"
  | "DESCRIPTION_ACTION_ALREADY_DONE"
  | "MESSAGE_TYPE"
  | "LIMIT_BY_REPORTED"
  | "PROMO_CODE_KEY"
  | "INVALID_PROMO_CODE_KEY"
  | "PROMO_CODE_ALREADY_EXISTS"
  | "PROMO_CODE_GENERATION_HELPER_TEXT"
  | "VIP_MIN"
  | "AUDIT_EVENTS_POOL_TABLE"
  | "UPDATE_ON_CALL_TABLE"
  | "OBTAIN_IOS_RECEIPT_TOKENS"
  | "IOS_RECEIPT_TOKEN_DATA"
  | "BLOCKED_REQUESTS"
  | "BLOCKED_REQUESTS_HISTORY"
  | "BLOCKED_REQUESTS_DETAILS"
  | "SAFE"
  | "RATE_LIMIT_MOBILE_APP"
  | "RATE_LIMIT_WEBSITE"
  | "RATE_LIMIT_ADMIN"
  | "IP_GEOLOCATION"
  | "ALERT"
  | "DANGER"
  | "GO_TO_USER_ADVANCED"
  | "GO_TO_MESSAGES"
  | "DESCRIPTION_CHANGED"
  | "INVESTIGATION_CASE_ALREADY_RESOLVED"
  | "INVESTIGATION_CASE_EXITS_IN_SOME_POOL"
  | "REPORT_CASE_EXISTS_IN_SOME_POOL"
  | "REPORT_CASES_ALREADY_RESOLVED"
  | "USER_SHOULD_BE_VERIFIED"
  | "SOCIAL_MEDIA_ACCOUNT"
  | "BAD_WORDS"
  | "FLAGGED_DESCRIPTIONS"
  | "GET_FLAGGED_DESCRIPTIONS"
  | "ADD_FLAGGED_DESCRIPTION"
  | "GET_USER_BANNED"
  | "FLAGGED_DESCRIPTION_EMPTY_TABLE"
  | "NO_BANNED_USERS"
  | "FLAGGED_DESCRIPTION"
  | "BANNED_USERS"
  | "SUBMIT"
  | "ADD_DESCRIPTION"
  | "DESCRIPTION_ADDED"
  | "DESCRIPTION_DELETED"
  | "ADD_FLAGGED_DESCRIPTION_INVALID_INPUT"
  | "PLEASE_CONTACT_SE"
  | "TOTAL_USERS"
  | "TOTAL_CONVERSATIONS"
  | "NEW_CONVERSATIONS"
  | "TOTAL_MESSAGES"
  | "NEW_MESSAGES"
  | "SALES_USD"
  | "MARKETING_EXPENSES_USD"
  | "NO_CLEAN_POOL_DATA"
  | "NO_MORE_MESSAGES"
  | "KHATTABA_NAME"
  | "KHATTABA_AGE"
  | "KHATTABA_LOCATION"
  | "KHATTABA_CURRENCY"
  | "KHATTABA_CATEGORY"
  | "KHATTABA_PRICE"
  | "KHATTABA_LANGUAGE"
  | "KHATTABA_DESCRIPTION"
  | "LOCATION_FIELD"
  | "PRICE/EACH PRIDE"
  | "CURRENCY_I_WORK_WITH"
  | "MY_ID_TO_CONNECT"
  | "MORE_INFO_KHATTABAT"
  | "HELLO_MESSAGE"
  | "KHATTABAT"
  | "MALE_CLIENTS"
  | "FEMALE_CLIENTS"
  | "GET_KHATTABAT_CLIENTS"
  | "SUBSCRIPTION_ACTIVE"
  | "SUBSCRIPTION_EXPIRED"
  | "SEND"
  | "BLOCK"
  | "CREATE_ONE_O_TWO"
  | "ONE_O_ONE_C"
  | "ONE_O_TWO_WITH"
  | "COMMENTS"
  | "ONGOING"
  | "EXITED_BY_MATCH"
  | "EXITED_BY_CLIENT"
  | "PENDING_INTERACTION"
  | "ONE_O_ONE_M"
  | "MATCH_IDS"
  | "CLIENT_ID"
  | "SEND"
  | "ADD"
  | "ONE_O_ONE_M_SENT_RESULT"
  | "INCORRECT_CLIENT_ID"
  | "REFUND"
  | "CANCEL"
  | "NO_WEB_PAYMENT_DATA"
  | "NO_ACTIVE_WEB_SUBSCRIPTION"
  | "WEB_PAYMENT_REFUND_FAILED"
  | "WEB_PAYMENT_INVALID_REQUEST_ERROR"
  | "NOT_UPDATED_CHECK_IF_CORRECT_PAYEMTN_INTENT"
  | "NOT_UPDATED_CHECK_IF_CORRECT_SUBSCRIPTION"
  | "ONE_O_TWO_CLIENT_MATCH_SAME_GENDER"
  | "CANNOT_CHANGE_TO_SAME_STATUS"
  | "USER_DOES_NOT_EXIST_OR_INACTIVE"
  | "ONE_O_TWO_CONVERSATION_ALREADY_CREATED"
  | "ALREADY_CANCELLED"
  | "CANCELLED"
  | "USER_DOES_NOT_EXIST_OR_INACTIVE"
  | "ONE_O_TWO_CONVERSATION_IS_NOT_ACTIVE_ANYMORE"
  | "DOUBLE_CLICK_FOR_GOOGLE_LENS"
  | "NO_WEB_USER_PAYMENT_ARCHIVE_DATA"
  | "WRONG_REFFERAL_CODE"
  | "ADMIN_USERS_HAVE_ALREADY_ANOTHER_ACTIVE_POOL"
  | "CLEAN_POOL_CONFIRMATION_POPUP"
  | "USER_HAS_NO_RECEIPTS"
  | "ARE_YOU_SURE_YOU_WANT_TO_CANCEL_WEB_PAYMENT"
  | "ARE_YOU_SURE_YOU_WANT_TO_REFUND_WEB_PAYMENT"
  | "WEB_REFUND_ATTENTION"
  | "ARE_YOU_SURE_YOU_WANT_TO_CONTINUE"
  | "USER_HAS_NO_RECEIPTS"
  | "RECEIPT_ORIGINAL_TRANSACTION_ID"
  | "RECEIPT_PURCHASE_DATE"
  | "RECEIPT_EXPIRES_DATE"
  | "RECEIPT_IN_APP_OWNERSHIP_TYPE"
  | "RECEIPT_QUANTITY"
  | "RECEIPT_PURCHASE_DATE_MS"
  | "RECEIPT_PURCHASE_DATE_PST"
  | "RECEIPT_ORIGINAL_PURCHASE_DATE"
  | "RECEIPT_ORIGINAL_PURCHASE_MS"
  | "RECEIPT_ORIGINAL_PURCHASE_DATE_PST"
  | "RECEIPT_EXPIRES_DATE_MS"
  | "RECEIPT_EXPIRES_DATE_PST"
  | "RECEIPT_WEB_ORDER_LINE_ITEM_ID"
  | "RECEIPT_IS_TRIAL_PERIOD"
  | "RECEIPT_IS_IN_INTRO_OFFER_PERIOD"
  | "RECEIPT_APP_ACCOUNT_TOKEN"
  | "RECEIPT_HAS_PENDING"
  | "RECEIPT_PRODUCT_ID"
  | "LAST_RECEIPT_PRODUCT_ID"
  | "RECEIPT_EXPIRATION_INTENT"
  | "RECEIPT_IS_IN_BILLING_RETRY"
  | "LAST_RECEIPT_ORIGINAL_TRANSACTION_ID"
  | "RECEIPT_AUTO_RENEW_STATUS"
  | "RECEIPT_AUTO_RENEW_PRODUCT_ID"
  | "LAST_RECEIPT"
  | "PENDING_RECEIPTS"
  | "NO_RECEIPT"
  | "APPLE_RECEIPT_ERROR"
  | "ANDROID_RECEIPT_ERROR"
  | "CLIENT_IGNORE"
  | "CLIENT_PAID"
  | "CLIENT_LEAD"
  | "CLIENT_CONTACTED"
  | "CLIENT_NEW_CONTACT"
  | "TYPE_OF_MARIAGE"
  | "REGULAR"
  | "POLY"
  | "MISYAR"
  | "LEAD"
  | "IGNORE"
  | "MOVE_TO"
  | "SELECT_ALL"
  | "USER_HAS_NO_RECEIPTS"
  | "COUNT_SELECTED"
  | "COUNT"
  | "FILTERS"
  | "MIN_AGE"
  | "MAX_AGE"
  | "UNDEFINED"
  | "APPLY"
  | "MAX_AGE_HAS_TO_BE_BIGGER_MIN_AGE"
  | "FILTERS_RESET"
  | "AI_MESSAGES_BOX"
  | "PLEASE_AT_LEAST_ONE_USER"
  | "SENDING"
  | "MARK_AS_READ"
  | "UNREAD_MESSAGES"
  | "MATCHMAKING"
  | "KHATTABAT_MATCHING_SEARCH_AND_1O1M"
  | "KHATTABAT_MATCHING_RESULTS"
  | "NO_PAID_USERS_FOUND"
  | "PAID_USERS"
  | "RESULTS_NUMBER"
  | "CLEAR_RESULTS"
  | "NO_MATCHES_FOUND"
  | "CREATE_ONE_O_ONE_M"
  | "SEND_ONE_O_ONE_M_MESSAGE_PLACE_HOLDER"
  | "GET_CITIES"
  | "NO_CITIES_FOUND"
  | "GET_CONVESATIONS"
  | "NO_APPROVED_MATCHES_FOUND"
  | "CONTACTED"
  | "MATCH_APP_LANGUAGE"
  | "SUPERVISOR_RECEIPT_COMPENSATION"
  | "SUPERVISOR_RECEIPT_COMPENSATION_DATA_INPUT"
  | "SUPERVISOR_RECEIPT_COMPENSATION_ISSUES_ADDED_SUCCESSFULLY"
  | "RECEIPT_FOUND_FOR_THIS_MONTH"
  | "SUBMIT_DATE_IS_SPECIFIC"
  | "SUPERVISOR_RECEIPT_CONFIGURATION"
  | "DESCRIPTION_THRESHOLD"
  | "DESCRIPTION_DISCOUNT"
  | "DESCRIPTION_PRICING"
  | "REPORT_THRESHOLD"
  | "REPORT_DISCOUNT"
  | "REPORT_PRICING"
  | "INVESTIGATION_CASES_THRESHOLD"
  | "INVESTIGATION_CASES_DISCOUNT"
  | "INVESTIGATION_CASES_PRICING"
  | "PICTURE_THRESHOLD"
  | "PICTURE_DISCOUNT"
  | "PICTURE_PRICING"
  | "RECEIPT_CONFIGURATION_INSERTED_SUCCESSFULLY"
  | "NO_RECEIPT_CONFIGURATION_DATA_YET"
  | "PREVIOUS_RECEIPT_MONTH"
  | "CURRENT_RECEIPT_MONTH"
  | "CSR_MY_RECEIPT_EVENT_COUNT"
  | "IMAGE_STATUS_DELETED"
  | "SENDING"
  | "CSR_TIME_ACCESS"
  | "SLOT"
  | "ALL_DAYS"
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY"
  | "CHOOSE_PROPER_TIME_RANGE"
  | "NO_LONGER_ACTIVE_POOL"
  | "UNSUBSCRIBED_USER_ACTIVITY_EMAILS"
  | "UNSUBSCRIBED_PROMOTIONAL_EMAILS"
  | "UNSUBSCRIBED_NEW_MESSAGE_EMAILS"
  | "UNSUBSCRIBED_VISIT_PROFILE_EMAILS"
  | "UNSUBSCRIBED_LIKE_EMAILS"
  | "DISABLE"
  | "ENABLE"
  | "ENABLE_SELECTED_1O1M"
  | "DISABLE_SELECTED_1O1M"
  | "PROFILE_ID"
  | "WRONG_PROFILE_ID"
  | "PROFILE_ID_NOT_FOUND"
  | "VIP_CONFIRMATION_POPUP"
  | "RESET_PASSWORD_CONFIRMATION_POPUP"
  | "USER_DATA"
  | "USER_PROFILE"
  | "NO_SHARED_HOLDER_DATA"
  | "USER_QUIZ"
  | "MARITAL_STATUS"
  | "EDUCATION_LEVEL"
  | "WORK_LEVEL"
  | "SMOKING_LEVEL"
  | "HAVING_KIDS"
  | "FEMALE_WORK_STUDY"
  | "BELONGS_TO_TRIBE"
  | "RELOCATION"
  | "HIGHLIGHT"
  | "THERE_IS_ANOTHER_AVAILABLE_KHATTABA"
  | "KHATTABAT_REMUNERATION"
  | "PER_CYCLE"
  | "KHATTABAT_ADMIN"
  | "NO_KHATTABAT_ADMIN"
  | "ADMIN_KHATTABAT_REMUNERATIONS"
  | "VIP"
  | "PLUS"
  | "KHATTABAT_TAG"
  | "BOOST"
  | "REWIND"
  | "READ"
  | "SCSR"
  | "GIVE_SUBSCRIPTIONS"
  | "PLUS_DAYS"
  | "PLUS_HOURS"
  | "PLUS_MIN"
  | "MAKE_PLUS"
  | "KHATTABAT_DAYS"
  | "KHATTABAT_HOURS"
  | "KHATTABAT_MIN"
  | "MAKE_KHATTABAT"
  | "VIP_IN_HOURS"
  | "VIP_IN_MIN"
  | "VIP_IN_DAYS"
  | "PLUS_IN_HOURS"
  | "PLUS_IN_MIN"
  | "PLUS_IN_DAYS"
  | "KHATTABAT_IN_HOURS"
  | "KHATTABAT_IN_MIN"
  | "KHATTABAT_IN_DAYS"
  | "PLUS_CONFIRMATION_POPUP"
  | "KHATTABAT_CONFIRMATION_POPUP"
  | "USER_IS_NOT_MALE_USER"
  | "USER_NEVER_PAYING_KHATTABAT"
  | "INCORRECT_PLUS_DAYS_HOURS"
  | "USER_PLUS_ADDED_SUCCESSFULLY"
  | "INCORRECT_KHATTABAT_DAYS_HOURS"
  | "USER_KHATTABAT_ADDED_SUCCESSFULLY"
  | "REASSIGN_KHATTABA"
  | "USER_IS_NOT_MATCHED_TO_THIS_KHATTABA"
  | "REASSIGNMENT_IS_COMPLETED"
  | "BAN_UNTIL"
  | "NUMBER_OF_DAYS"
  | "INVESTIGATION_ID"
  | "REPORT_ID"
  | "SUBSCRIPTION"
  | "AUDITOR_EVENTS_DATA"
  | "AUDITORS_EFFICIENCY"
  | "TURN_KHATTABAT_ON_OFF"
  | "UPDATE"
  | "RC_CAPACITY"
  | "REACTIVATE"
  | "ACCOUNT_CREATED_ON"
  | "DELETED_BY_MATCH"
  | "AMOUNT"
  | "FREE_PAID_IN_HOURS_DAYS"
  | "ONE_O_TWO_CONFIRMATION_POPUP"
  | "SKIN_COLOR"
  | "RELIGION"
  | "VEIL"
  | "MESSAGE_ERA"
  | "KHATTABAT_DATA"
  | "GET_LATEST"
  | "DATA_COLLECTION"
  | "NEW_CLIENTS"
  | "CAPACITY"
  | "ASSIGN_CLIENT_TO_ME"
  | "LIMIT_REACHED_KHATTABA_CLIENTS"
  | "NO_NEW_CLIENTS_AVAILABLE"
  | "ASSIGN_NEW_CLIENT_CONFIRMATION_POP_UP"
  | "DEBUG_IMAGE_AI"
  | "DOWNLOAD_CSV"
  | "WAS_STRIPE_USER"
  | "KHATTABA_102_COUNTER"
  | "CLIENT_102_COUNTER"
  | "MATCH_102_COUNTER"
  | "QUALITY"
  | "NOTICE_EMAIL"
  | "REACTIVATE_KHATTABA_CLIENT_CONFIRMATION_POP_UP"
  | "CANNOT_REACTIVATE_KHATTABA_CLIENT_POPUP"
  | "SILVER_SUBSCRIPTION_HISTORY_FOR"
  | "GOLD_SUBSCRIPTION_HISTORY_FOR"
  | "BLACK_SUBSCRIPTION_HISTORY_FOR"
  | "PLATINUM_SUBSCRIPTION_HISTORY_FOR"
  | "POWER_BUNDLE_SUBSCRIPTION_HISTORY_FOR"
  | "READ_SUBSCRIPTION_HISTORY_FOR"
  | "VIP_SUBSCRIPTION_HISTORY_FOR"
  | "PLUS_SUBSCRIPTION_HISTORY_FOR"
  | "KHATTABAT_SUBSCRIPTION_HISTORY_FOR"
  | "BOOST_SUBSCRIPTION_HISTORY_FOR"
  | "REWIND_SUBSCRIPTION_HISTORY_FOR"
  | "COUNT_HINT_SUBTEXT"
  | "SELFIE_VERIFICATION_PHOTOS"
  | "AI_DESCRIPTIONS"
  | "KHATTABA_V3_IS_ALREADY_TURNED_OFF"
  | "SUPERVISOR_KHATTABAT_FUNNEL_STATS"
  | "SUPERVISOR_KHATTABAT_FUNNEL_STATS_DATA"
  | "MATCHMAKING_AUDIT"
  | "MATCHMAKING_AUDIT_DATA"
  | "INCOME"
  | "BP_USERS"
  | "ADMIN_USAGE_DATA"
  | "AI_GENERATED_DESCRIPTION_ALL"
  | "ID"
  | "USAGE"
  | "GPT_MODEL"
  | "CLAUDE_MODEL"
  | "GPT_DESCRIPTION"
  | "CLAUDE_DESCRIPTION"
  | "FINAL_DESCRIPTION"
  | "MATCH_PERCENTAGE_GPT"
  | "MATCH_PERCENTAGE_CLAUDE"
  | "SUB_TAB_ACCESS_SUMMARY"
  | "GENERATED_TABLES_SUMMARY"
  | "USER_UNDER_CSR_INVESTIGATION_BUT_WILL_APPEAR_SOON"
  | "MIN_WEIGHT"
  | "MAX_WEIGHT"
  | "MIN_HEIGHT"
  | "MAX_HEIGHT"
  | "MIN_AGE_LESS_THAN_MAX_AGE"
  | "MIN_WEIGHT_LESS_THAN_MAX_WEIGHT"
  | "MIN_HEIGHT_LESS_THAN_MAX_HEIGHT"
  | "FEATURE_ROLLOUT_PERCENTAGE"
  | "EXCLUDE"
  | "OTHER_AUDITORS_PERFORMANCE"
  | "BAN_SCAMMER"
  | "WARN_SOCIAL_MEDIA_ACCOUNT"
  | "WARN_BAD_LANGUAGE"
  | "ALL_CLIENTS"
  | "REQUIRES_ATTENTION"
  | "OTHER_AUDITORS_PERFORMANCE"
  | "REPORT_ACTIONS_ANALYTICS"
  | "REPORT_ACTIONS"
  | "REPORT_ACTION_REASONS"
  | "KHATTABA_QUIZ_STATUS"
  | "KHATTABA_QUIZ_STATS"
  | "NO_AI_APPLICATIONS_FOUND"
  | "AI_FILTER_USER_ID_DOMINANCE"
  | "INVALID_AGE"
  | "KHATTABA_V3_AI_IS_ALREADY_TURNED_OFF"
  | "PLATINUM"
  | "SILVER"
  | "GOLD"
  | "SILVER_DAYS"
  | "GOLD_DAYS"
  | "PLATINUM_DAYS"
  | "SILVER_HOURS"
  | "GOLD_HOURS"
  | "PLATINUM_HOURS"
  | "SILVER_MIN"
  | "GOLD_MIN"
  | "PLATINUM_MIN"
  | "MAKE_SILVER"
  | "MAKE_GOLD"
  | "MAKE_PLATINUM"
  | "SILVER_IN_DAYS"
  | "SILVER_IN_HOURS"
  | "SILVER_IN_MIN"
  | "GOLD_IN_DAYS"
  | "GOLD_IN_HOURS"
  | "GOLD_IN_MIN"
  | "PLATINUM_IN_DAYS"
  | "PLATINUM_IN_HOURS"
  | "PLATINUM_IN_MIN"
  | "SILVER_IN_DAYS_MIN"
  | "GOLD_IN_DAYS_MIN"
  | "PLATINUM_IN_DAYS_MIN"
  | "USER_SILVER_ADDED_SUCCESSFULLY"
  | "USER_GOLD_ADDED_SUCCESSFULLY"
  | "USER_PLATINUM_ADDED_SUCCESSFULLY"
  | "USER_ADVANCED_ADDED_SUCCESSFULLY"
  | "SILVER_CONFIRMATION_POPUP"
  | "GOLD_CONFIRMATION_POPUP"
  | "BLACK"
  | "BLACK_DAYS"
  | "BLACK_HOURS"
  | "BLACK_MIN"
  | "MAKE_BLACK"
  | "BLACK_IN_DAYS"
  | "BLACK_IN_HOURS"
  | "BLACK_IN_MIN"
  | "BLACK_IN_DAYS_MIN"
  | "USER_BLACK_ADDED_SUCCESSFULLY"
  | "BLACK_CONFIRMATION_POPUP"
  | "SUBSCRIPTION_SECTION_LEGACY_TITLE"
  | "SUBSCRIPTION_SECTION_LEGACY_SUBTITLE"
  | "SUBSCRIPTION_SECTION_TIERS_TITLE"
  | "SUBSCRIPTION_SECTION_TIERS_SUBTITLE"
  | "SUBSCRIPTION_SECTION_REFERRAL_TITLE"
  | "SUBSCRIPTION_SECTION_REFERRAL_SUBTITLE"
  | "SUBSCRIPTION_SECTION_KHATTABAT_TITLE"
  | "SUBSCRIPTION_SECTION_KHATTABAT_SUBTITLE"
  | "PLATINUM_CONFIRMATION_POPUP"
  | "APP_VERSION_BELOW_NINE_POINT_FIVE"
  | "SUBSCRIPTION_TIME_CONFIRMATION"
  | "PROMO_CODE_REWARD_TYPE"
  | "MAKE_ADVANCED"
  | "ADVANCED_DAYS"
  | "ADVANCED_HOURS"
  | "ADVANCED_MIN"
  | "ADVANCED_CONFIRMATION_POPUP"
  | "ADVANCED_IN_DAYS"
  | "ADVANCED_IN_HOURS"
  | "ADVANCED_IN_MIN"
  | "MAX_GIVE_ADVANCED_IN_DAYS"
  | "MAX_GIVE_ADVANCED_IN_HOURS"
  | "MAX_GIVE_ADVANCED_IN_MIN"
  | "ADVANCED_IOS"
  | "BUNDLE"
  | "SILVER_TAG"
  | "GOLD_TAG"
  | "BLACK_TAG"
  | "PLATINUM_TAG"
  | "ACTIVE_FEATURE_SETS"
  | "ACTIVE_FEATURES"
  | "FEATURE_SET_ACTIVE_FEATURES"
  | "CONVERSATION_BADGE"
  | "LIKES"
  | "CONSUMABLES"
  | "OTHER_SUBSCRIPTION_HISTORY_FOR"
  | "TRIAL"
  | "KHATTABA_V3_CANNOT_TURN_ON_COUNTRY_NONE"
  | "TRANSFER_USER_PACKAGE"
  | "TRANSFER_USER_PACKAGE_SUB_TITLE"
  | "TRANSFER_USER_PACKAGE_CONFIRMATION_POPUP"
  | "TRANSFER_USER_PACKAGE_SUCCESS"
  | "TRANSFER_PACKAGE_SAME_USER"
  | "TRANSFER_PACKAGE_NOT_TRANSFERABLE"
  | "TRANSFER_PACKAGE_SOURCE_NO_ACTIVE"
  | "TRANSFER_PACKAGE_TARGET_ALREADY_ACTIVE"
  | "TRANSFER_PACKAGE_GENDER_MISMATCH"
  | "TRANSFER_PACKAGE_UNKNOWN_GENDER"
  | "TRANSFER_PACKAGE_CURRENT_EXPIRY"
  | "TRANSFER_PACKAGE_NEW_EXPIRY"
  | "TRANSFER_PACKAGE_REMAINING_QUOTAS"
  | "TRANSFER_PACKAGE_REMAINING_BALANCES"
  | "TRANSFER_PACKAGE_NO_CONSUMABLES"
  | "FROM_USER_ID"
  | "TO_USER_ID"
  | "PACKAGE_TYPE"
  | "NOT_APPLICABLE"
  | "CRITERIA_DESCRIPTION"
  | "CRITERIA_PEER_DESCRIPTION"
  | "PICTURES"
  | "PENDING"
  | "DELETED"
  | "APPROVAL_NOTHING_TO_REVIEW"
  | "NO_PICTURES_UPLOADED"
  | "APPROVAL_ITEMS_PENDING"
  | "APPROVAL_USERS_WITH_WORK"
  | "APPROVAL_TO_REVIEW_COUNT"
  | "APPROVAL_TOTAL_COUNT"
  | "APPROVAL_OF_POOL"
  | "APPROVAL_DECIDED_THIS_SESSION"
  | "APPROVAL_NOT_LOADED_TITLE"
  | "APPROVAL_NOT_LOADED_BODY"
  | "APPROVE_PICTURE"
  | "ENLARGE_PICTURE"
  | "CLOSE_PICTURE"
  | "DEPRECATED";

export const messageWithExtraData: Ti18nKeys[] = [
  "USER_ID_PICTURE_REJECT",
  "ONE_O_ONE_M_SENT_RESULT",
  "NEW_GENERATED_PASSWORD",
  "PROMO_CODE_GENERATED_SUCCESSFULLY",
  "TRANSFER_PACKAGE_SOURCE_NO_ACTIVE",
  "TRANSFER_PACKAGE_TARGET_ALREADY_ACTIVE"
];

export const messageWithArrayExtraData: Ti18nKeys[] = [
  "VIP_DETAILS",
  "TRANSFER_USER_PACKAGE_SUCCESS"
];

export enum TLanguageEnum {
  ENG = "ENG",
  AR = "AR",
  FR = "FR",
  TR = "TR"
}
export type TLanguage = "ENG" | "AR" | "FR" | "TR";
export type TI18nData = {
  AR: string;
  ENG: string;
  FR: string;
  TR: string;
};
export type TI18n = {
  LG: { [key in Ti18nKeys]: TI18nData };
  get: (message: Ti18nKeys) => string;
  getWithExtraData: (message: string, extraData: string) => string;
  getWithArrayExtraData: (message: string, extraData: string[]) => string;
  language: IObservableValue<TLanguage>;
};

const i18n: TI18n = {
  language: observable.box<TLanguage>("ENG"),

  LG: {
    CHOOSE: {
      ENG: "Choose",
      AR: "Choose",
      FR: "Choose",
      TR: "Choose"
    },
    ENVIRONMENT: {
      ENG: "Environment",
      AR: "Environment",
      FR: "Environment",
      TR: "Environment"
    },
    DEPLOYED: {
      ENG: "Deployed",
      AR: "Deployed",
      FR: "Deployed",
      TR: "Deployed"
    },
    GO_TO_MESSAGES: {
      ENG: "Messages",
      AR: "Messages",
      FR: "Messages",
      TR: "Messages"
    },
    GO_TO_USER_ADVANCED: {
      ENG: "UserAdvanced",
      AR: "UserAdvanced",
      FR: "UserAdvanced",
      TR: "UserAdvanced"
    },
    DANGER: {
      ENG: "Danger",
      AR: "Danger",
      FR: "Danger",
      TR: "Danger"
    },
    ALERT: {
      ENG: "Alert Mode",
      AR: "Alert Mode",
      FR: "Alert Mode",
      TR: "Alert Mode"
    },
    IP_GEOLOCATION: {
      ENG: "Ip geolocation",
      AR: "Ip geolocation",
      FR: "Ip geolocation",
      TR: "Ip geolocation"
    },
    RATE_LIMIT_MOBILE_APP: {
      ENG: "Rate Limit App",
      AR: "Rate Limit App",
      FR: "Rate Limit App",
      TR: "Rate Limit App"
    },

    RATE_LIMIT_WEBSITE: {
      ENG: "Rate Limit Website",
      AR: "Rate Limit Website",
      FR: "Rate Limit Website",
      TR: "Rate Limit Website"
    },

    RATE_LIMIT_ADMIN: {
      ENG: "Rate Limit Admin",
      AR: "Rate Limit Admin",
      FR: "Rate Limit Admin",
      TR: "Rate Limit Admin"
    },
    ALKHATTABA_ADMIN: {
      ENG: "Al-Khattaba Admin",
      AR: "Al-Khattaba Admin",
      FR: "Al-Khattaba Admin",
      TR: "Al-Khattaba Admin"
    },
    MAIN_NAVIGATION: {
      ENG: "Main Navigation",
      AR: "Main Navigation",
      FR: "Main Navigation",
      TR: "Main Navigation"
    },
    ET3ARRAF: {
      ENG: "et3arraf",
      AR: "et3arraf",
      FR: "et3arraf",
      TR: "et3arraf"
    },
    USERNAME: {
      ENG: "Username",
      AR: "Username",
      FR: "Username",
      TR: "Username"
    },
    PASSWORD: {
      ENG: "Password",
      AR: "Password",
      FR: "Password",
      TR: "Password"
    },
    SIGN_IN: {
      ENG: "Sign In",
      AR: "Sign In",
      FR: "Sign In",
      TR: "Sign In"
    },
    SIGNING_IN: {
      ENG: "Signing in...",
      AR: "Signing in...",
      FR: "Signing in...",
      TR: "Signing in..."
    },
    LOGIN_TAGLINE: {
      ENG: "Back-office control panel for the et3arraf platform.",
      AR: "Back-office control panel for the et3arraf platform.",
      FR: "Back-office control panel for the et3arraf platform.",
      TR: "Back-office control panel for the et3arraf platform."
    },
    LOGIN_SUBTITLE: {
      ENG: "Use your et3arraf account to continue",
      AR: "Use your et3arraf account to continue",
      FR: "Use your et3arraf account to continue",
      TR: "Use your et3arraf account to continue"
    },
    LOGIN_USERNAME_HINT: {
      ENG: "Include your @et3arraf.com address",
      AR: "Include your @et3arraf.com address",
      FR: "Include your @et3arraf.com address",
      TR: "Include your @et3arraf.com address"
    },
    ERROR_MESSAGE: {
      ENG: "Unexpected error happened, please try again later",
      AR: "Unexpected error happened, please try again later",
      FR: "Unexpected error happened, please try again later",
      TR: "Unexpected error happened, please try again later"
    },
    LIMIT: {
      ENG: "Limit",
      AR: "Limit",
      FR: "Limit",
      TR: "Limit"
    },
    DATE_MIN: {
      ENG: "Date Min.",
      AR: "Date Min.",
      FR: "Date Min.",
      TR: "Date Min."
    },
    DATE_MAX: {
      ENG: "Date Max.",
      AR: "Date Max.",
      FR: "Date Max.",
      TR: "Date Max."
    },

    PLATFORM: {
      ENG: "Platform",
      AR: "Platform",
      FR: "Platform",
      TR: "Platform"
    },
    STATUS: {
      ENG: "Status",
      AR: "Status",
      FR: "Status",
      TR: "Status"
    },
    COUNTRY_CREATED_FROM: {
      ENG: "Country Created from",
      AR: "Country Created from",
      FR: "Country Created from",
      TR: "Country Created from"
    },
    TYPE: {
      ENG: "Type",
      AR: "Type",
      FR: "Type",
      TR: "Type"
    },
    COUNTRY: {
      ENG: "Country",
      AR: "Country",
      FR: "Country",
      TR: "Country"
    },
    SENDER_ID: {
      ENG: "Sender ID",
      AR: "Sender ID",
      FR: "Sender ID",
      TR: "Sender ID"
    },
    RECEIVER_ID: {
      ENG: "Receiver ID",
      AR: "Receiver ID",
      FR: "Receiver ID",
      TR: "Receiver ID"
    },
    ADMIN: {
      ENG: "Admin",
      AR: "Admin",
      FR: "Admin",
      TR: "Admin"
    },
    USER: {
      ENG: "User",
      AR: "User",
      FR: "User",
      TR: "User"
    },
    MONITOR_USER_MESSAGES: {
      ENG: "Monitor User Messages",
      AR: "Monitor User Messages",
      FR: "Monitor User Messages",
      TR: "Monitor User Messages"
    },
    USER_MESSAGES_TABLE: {
      ENG: "User Messages Table",
      AR: "User Messages Table",
      FR: "User Messages Table",
      TR: "User Messages Table"
    },
    USER_ID: {
      ENG: "User ID",
      AR: "User ID",
      FR: "User ID",
      TR: "User ID"
    },
    TRANSACTION_ID: {
      ENG: "Transaction ID",
      AR: "Transaction ID",
      FR: "Transaction ID",
      TR: "Transaction ID"
    },
    DEVICE_ID: {
      ENG: "Device ID",
      AR: "Device ID",
      FR: "Device ID",
      TR: "Device ID"
    },
    VIP_DAYS: {
      ENG: "Vip Days",
      AR: "Vip Days",
      FR: "Vip Days",
      TR: "Vip Days"
    },
    VIP_HOURS: {
      ENG: "Vip Hours",
      AR: "Vip Hours",
      FR: "Vip Hours",
      TR: "Vip Hours"
    },
    VIP_MIN: {
      ENG: "Vip Min",
      AR: "Vip Min",
      FR: "Vip Min",
      TR: "Vip Min"
    },
    SEARCH_BY: {
      ENG: "Search By",
      AR: "Search By",
      FR: "Search By",
      TR: "Search By"
    },
    GET: {
      ENG: "Get",
      AR: "Get",
      FR: "Get",
      TR: "Get"
    },
    VIEW_CONVERSATION: {
      ENG: "Conversation",
      AR: "Conversation",
      FR: "Conversation",
      TR: "Conversation"
    },
    GET_RESULTS: {
      ENG: "Get Results",
      AR: "Get Results",
      FR: "Get Results",
      TR: "Get Results"
    },
    EVENTS_LIST: {
      ENG: "Events List",
      AR: "Events List",
      FR: "Events List",
      TR: "Events List"
    },
    EVENTS_COUNT: {
      ENG: "Events Count",
      AR: "Events Count",
      FR: "Events Count",
      TR: "Events Count"
    },
    SEARCH_BY_USER_ID: {
      ENG: "By user id",
      AR: "By user id",
      FR: "By user id",
      TR: "By user id"
    },
    SEARCH_BY_TRANSACTION_ID: {
      ENG: "By transaction id",
      AR: "By transaction id",
      FR: "By transaction id",
      TR: "By transaction id"
    },
    ONLY_FOR_SE: {
      ENG: "Only for SE",
      AR: "Only for SE",
      FR: "Only for SE",
      TR: "Only for SE"
    },
    CHANGE_STATUS: {
      ENG: "Change Status",
      AR: "Change Status",
      FR: "Change Status",
      TR: "Change Status"
    },
    CHANGE_USERNAME: {
      ENG: "Change Username",
      AR: "Change Username",
      FR: "Change Username",
      TR: "Change Username"
    },
    MAKE_VIP: {
      ENG: "Make VIP",
      AR: "Make VIP",
      FR: "Make VIP",
      TR: "Make VIP"
    },
    FLAG: {
      ENG: "Flag",
      AR: "Flag",
      FR: "Flag",
      TR: "Flag"
    },
    RESET_ACCOUNT: {
      ENG: "Reset Account",
      AR: "Reset Account",
      FR: "Reset Account",
      TR: "Reset Account"
    },
    CLEAN_POOL: {
      ENG: "Clean Pool",
      AR: "Clean Pool",
      FR: "Clean Pool",
      TR: "Clean Pool"
    },
    PICTURE: {
      ENG: "Picture: ",
      AR: "Picture: ",
      FR: "Picture: ",
      TR: "Picture: "
    },
    DESCRIPTION: {
      ENG: "Description:",
      AR: "Description:",
      FR: "Description:",
      TR: "Description:"
    },
    NO_DESCRIPTION: {
      ENG: "No Description Added",
      AR: "No Description Added",
      FR: "No Description Added",
      TR: "No Description Added"
    },
    APPROVED: {
      ENG: "Approved",
      AR: "Approved",
      FR: "Approved",
      TR: "Approved"
    },
    REJECTED: {
      ENG: "Rejected",
      AR: "Rejected",
      FR: "Rejected",
      TR: "Rejected"
    },
    REJECT_PICTURE: {
      ENG: "Reject Picture",
      AR: "Reject Picture",
      FR: "Reject Picture",
      TR: "Reject Picture"
    },
    REJECT_DESCRIPTION: {
      ENG: "Reject Description",
      AR: "Reject Description",
      FR: "Reject Description",
      TR: "Reject Description"
    },
    OLD_PASSWORD: {
      ENG: "Old Password",
      AR: "Old Password",
      FR: "Old Password",
      TR: "Old Password"
    },
    NEW_PASSWORD: {
      ENG: "New Password",
      AR: "New Password",
      FR: "New Password",
      TR: "New Password"
    },
    CONFIRM_PASSWORD: {
      ENG: "Confirm Password",
      AR: "Confirm Password",
      FR: "Confirm Password",
      TR: "Confirm Password"
    },
    CHANGE_ROLE: {
      ENG: "Change Role",
      AR: "Change Role",
      FR: "Change Role",
      TR: "Change Role"
    },
    CHANGE_PASSWORD: {
      ENG: "Change Password",
      AR: "Change Password",
      FR: "Change Password",
      TR: "Change Password"
    },
    RESOLVE: {
      ENG: "Resolve",
      AR: "Resolve",
      FR: "Resolve",
      TR: "Resolve"
    },
    WARN: {
      ENG: "Warn",
      AR: "Warn",
      FR: "Warn",
      TR: "Warn"
    },
    EMAIL: {
      ENG: "Email",
      AR: "Email",
      FR: "Email",
      TR: "Email"
    },
    BAN: {
      ENG: "Ban",
      AR: "Ban",
      FR: "Ban",
      TR: "Ban"
    },
    TEMPORARY_BAN: {
      ENG: "Temporary Ban",
      AR: "Temporary Ban",
      FR: "Temporary Ban",
      TR: "Temporary Ban"
    },
    SILENT_BAN: {
      ENG: "Silent Ban",
      AR: "Silent Ban",
      FR: "Silent Ban",
      TR: "Silent Ban"
    },
    SILENT_BANNED: {
      ENG: "Silent Banned",
      AR: "Silent Banned",
      FR: "Silent Banned",
      TR: "Silent Banned"
    },
    REMOVE_SILENT_BAN: {
      ENG: "Remove Silent Ban",
      AR: "Remove Silent Ban",
      FR: "Remove Silent Ban",
      TR: "Remove Silent Ban"
    },
    REMOVE_SILENT_BAN_POPUP_TEXT: {
      ENG: "Are you sure you want to remove the silent ban? Every message, like and reaction this user sent while silent banned will become visible to their peers.",
      AR: "Are you sure you want to remove the silent ban? Every message, like and reaction this user sent while silent banned will become visible to their peers.",
      FR: "Are you sure you want to remove the silent ban? Every message, like and reaction this user sent while silent banned will become visible to their peers.",
      TR: "Are you sure you want to remove the silent ban? Every message, like and reaction this user sent while silent banned will become visible to their peers."
    },
    SILENT_BAN_REMOVED_SUCCESSFULLY: {
      ENG: "Silent ban removed successfully",
      AR: "Silent ban removed successfully",
      FR: "Silent ban removed successfully",
      TR: "Silent ban removed successfully"
    },
    USER_IS_NOT_SILENT_BANNED: {
      ENG: "This user is not silent banned",
      AR: "This user is not silent banned",
      FR: "This user is not silent banned",
      TR: "This user is not silent banned"
    },
    SILENTLY_BANNED_USERS: {
      ENG: "Silently Banned Users",
      AR: "Silently Banned Users",
      FR: "Silently Banned Users",
      TR: "Silently Banned Users"
    },
    FROM_DATE: {
      ENG: "From Date",
      AR: "From Date",
      FR: "From Date",
      TR: "From Date"
    },
    TO_DATE: {
      ENG: "To Date",
      AR: "To Date",
      FR: "To Date",
      TR: "To Date"
    },
    SEARCH: {
      ENG: "Search",
      AR: "Search",
      FR: "Search",
      TR: "Search"
    },
    SEARCH_USER_ID: {
      ENG: "Search user ID",
      AR: "Search user ID",
      FR: "Search user ID",
      TR: "Search user ID"
    },
    SALARY: {
      ENG: "Salary",
      AR: "Salary",
      FR: "Salary",
      TR: "Salary"
    },
    WELCOME_SUBTITLE: {
      ENG: "Here is what needs your attention today",
      AR: "Here is what needs your attention today",
      FR: "Here is what needs your attention today",
      TR: "Here is what needs your attention today"
    },
    YOUR_QUEUES: {
      ENG: "Your queues",
      AR: "Your queues",
      FR: "Your queues",
      TR: "Your queues"
    },
    OPEN_QUEUE: {
      ENG: "Open",
      AR: "Open",
      FR: "Open",
      TR: "Open"
    },
    LAST_LOGIN_AT: {
      ENG: "Last login",
      AR: "Last login",
      FR: "Last login",
      TR: "Last login"
    },
    PASSWORD_REQUIREMENTS: {
      ENG: "Your new password must have",
      AR: "Your new password must have",
      FR: "Your new password must have",
      TR: "Your new password must have"
    },
    PASSWORD_RULE_LETTERS: {
      ENG: "At least one letter",
      AR: "At least one letter",
      FR: "At least one letter",
      TR: "At least one letter"
    },
    PASSWORD_RULE_NUMBER: {
      ENG: "At least one number",
      AR: "At least one number",
      FR: "At least one number",
      TR: "At least one number"
    },
    PASSWORD_RULE_LENGTH: {
      ENG: `Between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters`,
      AR: `Between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters`,
      FR: `Between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters`,
      TR: `Between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters`
    },
    PASSWORD_RULE_NO_ARABIC: {
      ENG: "No Arabic characters",
      AR: "No Arabic characters",
      FR: "No Arabic characters",
      TR: "No Arabic characters"
    },
    PASSWORD_RULE_UPPERCASE: {
      ENG: "At least one uppercase letter",
      AR: "At least one uppercase letter",
      FR: "At least one uppercase letter",
      TR: "At least one uppercase letter"
    },
    PASSWORD_RULE_LOWERCASE: {
      ENG: "At least one lowercase letter",
      AR: "At least one lowercase letter",
      FR: "At least one lowercase letter",
      TR: "At least one lowercase letter"
    },
    PASSWORD_RULE_SYMBOL: {
      ENG: "At least one symbol",
      AR: "At least one symbol",
      FR: "At least one symbol",
      TR: "At least one symbol"
    },
    PASSWORD_RULE_NO_ARABIC_OR_SPACES: {
      ENG: "No Arabic characters and no spaces",
      AR: "No Arabic characters and no spaces",
      FR: "No Arabic characters and no spaces",
      TR: "No Arabic characters and no spaces"
    },
    PASSWORD_RULE_DIFFERENT_FROM_OLD: {
      ENG: "Different from your old password",
      AR: "Different from your old password",
      FR: "Different from your old password",
      TR: "Different from your old password"
    },
    PASSWORD_RULE_MATCH: {
      ENG: "Both new passwords match",
      AR: "Both new passwords match",
      FR: "Both new passwords match",
      TR: "Both new passwords match"
    },
    SHOW_PASSWORD: {
      ENG: "Show password",
      AR: "Show password",
      FR: "Show password",
      TR: "Show password"
    },
    HIDE_PASSWORD: {
      ENG: "Hide password",
      AR: "Hide password",
      FR: "Hide password",
      TR: "Hide password"
    },
    CHANGE_PASSWORD_SUBTITLE: {
      ENG: "Update the password for your admin account",
      AR: "Update the password for your admin account",
      FR: "Update the password for your admin account",
      TR: "Update the password for your admin account"
    },
    SEARCH_NO_RESULT: {
      ENG: "No Search Result",
      AR: "No Search Result",
      FR: "No Search Result",
      TR: "No Search Result"
    },
    SEARCH_SENSITIVE_CASE: {
      ENG: "Sensitive Case",
      AR: "Sensitive Case",
      FR: "Sensitive Case",
      TR: "Sensitive Case"
    },
    SHAREHOLDER_DASHBOARD: {
      ENG: "Shareholder ",
      AR: "Shareholder ",
      FR: "Shareholder ",
      TR: "Shareholder "
    },
    UPDATED_ON: {
      ENG: "updated on: ",
      AR: "updated on: ",
      FR: "updated on: ",
      TR: "updated on: "
    },
    REPORTS: {
      ENG: "Reports",
      AR: "Reports",
      FR: "Reports",
      TR: "Reports"
    },
    STATS: {
      ENG: "Stats",
      AR: "Stats",
      FR: "Stats",
      TR: "Stats"
    },
    REPORTS_USER_TO_USER: {
      ENG: "reports from user to another",
      AR: "reports from user to another",
      FR: "reports from user to another",
      TR: "reports from user to another"
    },
    DASHBOARD: {
      ENG: "Dashboard",
      AR: "Dashboard",
      FR: "Dashboard",
      TR: "Dashboard"
    },
    CONTROL_PANEL: {
      ENG: "control panel",
      AR: "control panel",
      FR: "control panel",
      TR: "control panel"
    },
    CONVERSATION: {
      ENG: "Conversation",
      AR: "Conversation",
      FR: "Conversation",
      TR: "Conversation"
    },
    BETWEEN_TWO_USERS: {
      ENG: "between 2 users",
      AR: "between 2 users",
      FR: "between 2 users",
      TR: "between 2 users"
    },
    OH_ITS_ME: {
      ENG: "Oh, this is me. ",
      AR: "Oh, this is me. ",
      FR: "Oh, this is me. ",
      TR: "Oh, this is me. "
    },
    OH_NO: {
      ENG: "OH NO!",
      AR: "OH NO!",
      FR: "OH NO!",
      TR: "OH NO!"
    },
    WARNING: {
      ENG: "Warning!",
      AR: "Warning!",
      FR: "Warning!",
      TR: "Warning!"
    },
    SUCCESS: {
      ENG: "Success!",
      AR: "Success!",
      FR: "Success!",
      TR: "Success!"
    },
    APPROVAL: {
      ENG: "Approval",
      AR: "Approval",
      FR: "Approval",
      TR: "Approval"
    },
    APPROVE_USER_DATA: {
      ENG: "approve user pictures/descriptions",
      AR: "approve user pictures/descriptions",
      FR: "approve user pictures/descriptions",
      TR: "approve user pictures/descriptions"
    },
    MONITOR_USER_PAYMENTS: {
      ENG: "monitor user payments",
      AR: "monitor user payments",
      FR: "monitor user payments",
      TR: "monitor user payments"
    },
    MONITOR_USER_LOGIN: {
      ENG: "monitor user login",
      AR: "monitor user login",
      FR: "monitor user login",
      TR: "monitor user login"
    },
    USER_LOGIN_TABLE: {
      ENG: "User Login Table",
      AR: "User Login Table",
      FR: "User Login Table",
      TR: "User Login Table"
    },
    USER_ACTION_BUTTONS: {
      ENG: "User Action Buttons",
      AR: "User Action Buttons",
      FR: "User Action Buttons",
      TR: "User Action Buttons"
    },
    MONITOR_USER_EVENTS: {
      ENG: "monitor user events",
      AR: "monitor user events",
      FR: "monitor user events",
      TR: "monitor user events"
    },
    DEVICES: {
      ENG: "Devices",
      AR: "Devices",
      FR: "Devices",
      TR: "Devices"
    },
    ADVANCED_MODE: {
      ENG: "advanced mode",
      AR: "advanced mode",
      FR: "advanced mode",
      TR: "advanced mode"
    },

    INFO_ABOUT_USER_ACTIVITIES: {
      ENG: "info. about user activities",
      AR: "info. about user activities",
      FR: "info. about user activities",
      TR: "info. about user activities"
    },

    GET_SIDED_STATISTICS: {
      ENG: "get sided statistics",
      AR: "get sided statistics",
      FR: "get sided statistics",
      TR: "get sided statistics"
    },
    VIEW_EDIT_ADMIN_POOL: {
      ENG: "view/edit admin pool",
      AR: "view/edit admin pool",
      FR: "view/edit admin pool",
      TR: "view/edit admin pool"
    },
    POOL_TABLE: {
      ENG: "Pool Table",
      AR: "Pool Table",
      FR: "Pool Table",
      TR: "Pool Table"
    },
    VIEW_EDIT_ADMIN_PERMISSION: {
      ENG: "view/edit admin permission",
      AR: "view/edit admin permission",
      FR: "view/edit admin permission",
      TR: "view/edit admin permission"
    },
    INVESTIGATION_CASES: {
      ENG: "Investigation Cases",
      AR: "Investigation Cases",
      FR: "Investigation Cases",
      TR: "Investigation Cases"
    },
    ADMIN_EVENTS: {
      ENG: "Admin Events",
      AR: "Admin Events",
      FR: "Admin Events",
      TR: "Admin Events"
    },
    VIEW_ADMIN_EVENTS: {
      ENG: "view/audit admin events",
      AR: "view/audit admin events",
      FR: "view/audit admin events",
      TR: "view/audit admin events"
    },
    VIEW_ADMIN_EVENTS_CHARTS: {
      ENG: "view admin events charts",
      AR: "view admin events charts",
      FR: "view admin events charts",
      TR: "view admin events charts"
    },
    VIEW_ADMIN_AUDITED_EVENTS: {
      ENG: "view admin events Audited",
      AR: "view admin events Audited",
      FR: "view admin events Audited",
      TR: "view admin events Audited"
    },
    COPYRIGHT: {
      ENG: "Copyright © 2012-2025 ",
      AR: "Copyright © 2012-2025 ",
      FR: "Copyright © 2012-2025 ",
      TR: "Copyright © 2012-2025 "
    },
    ET3ARRAF_SAL: {
      ENG: "et3arraf SAL. ",
      AR: "et3arraf SAL. ",
      FR: "et3arraf SAL. ",
      TR: "et3arraf SAL. "
    },
    ALL_RIGHTS_RESERVED: {
      ENG: "All rights reserved",
      AR: "All rights reserved",
      FR: "All rights reserved",
      TR: "All rights reserved"
    },
    VERSION: {
      ENG: "Version",
      AR: "Version",
      FR: "Version",
      TR: "Version"
    },
    APPROVE_REJECT_DATA: {
      ENG: "Approve / Reject data",
      AR: "Approve / Reject data",
      FR: "Approve / Reject data",
      TR: "Approve / Reject data"
    },
    SHAREHOLDERS_UPDATE: {
      ENG: "ShareHolder's Update",
      AR: "ShareHolder's Update",
      FR: "ShareHolder's Update",
      TR: "ShareHolder's Update"
    },
    USER_MESSAGES: {
      ENG: "User Messages",
      AR: "User Messages",
      FR: "User Messages",
      TR: "User Messages"
    },
    USER_PAYMENTS: {
      ENG: "User Payments",
      AR: "User Payments",
      FR: "User Payments",
      TR: "User Payments"
    },
    USER_EVENTS: {
      ENG: "User Events",
      AR: "User Events",
      FR: "User Events",
      TR: "User Events"
    },
    COMMUNITY: {
      ENG: "1- Community",
      AR: "1- Community",
      FR: "1- Community",
      TR: "1- Community"
    },
    ENGAGMENT: {
      ENG: "2- Engagment",
      AR: "2- Engagment",
      FR: "2- Engagment",
      TR: "2- Engagment"
    },
    FINANCIALS: {
      ENG: "3- Financials",
      AR: "3- Financials",
      FR: "3- Financials",
      TR: "3- Financials"
    },
    USER_LOCATION_CHART_TITLE: {
      ENG: "Geographical repartition of active users for last month",
      AR: "Geographical repartition of active users for last month",
      FR: "Geographical repartition of active users for last month",
      TR: "Geographical repartition of active users for last month"
    },
    USER_GENDER_CHART_TITLE: {
      ENG: "Geographical repartition of active users for last month",
      AR: "Geographical repartition of active users for last month",
      FR: "Geographical repartition of active users for last month",
      TR: "Geographical repartition of active users for last month"
    },
    GCC_COUNTRIES: {
      ENG: "GCC=UAE,Qatar,Bahrain and Kuwait",
      AR: "GCC=UAE,Qatar,Bahrain and Kuwait",
      FR: "GCC=UAE,Qatar,Bahrain and Kuwait",
      TR: "GCC=UAE,Qatar,Bahrain and Kuwait"
    },
    LEVANT_COUNTRIES: {
      ENG: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon",
      AR: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon",
      FR: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon",
      TR: "Levant=Iraq, Jordan,Syria,Palestine and Lebanon"
    },
    NA_COUNTRIES: {
      ENG: "NA=Morocco,Algeria and Tunisia",
      AR: "NA=Morocco,Algeria and Tunisia",
      FR: "NA=Morocco,Algeria and Tunisia",
      TR: "NA=Morocco,Algeria and Tunisia"
    },
    OTHER_COUNTRIES: {
      ENG: "Others=Over 100 countries",
      AR: "Others=Over 100 countries",
      FR: "Others=Over 100 countries",
      TR: "Others=Over 100 countries"
    },
    TOTAL_CONVERSATIONS_CHART_TITLE: {
      ENG: "Total number of conversations created",
      AR: "Total number of conversations created",
      FR: "Total number of conversations created",
      TR: "Total number of conversations created"
    },
    TOTAL_MONTHLY_CONVERSATIONS_CHART_TITLE: {
      ENG: "Total number of conversations created per month",
      AR: "Total number of conversations created per month",
      FR: "Total number of conversations created per month",
      TR: "Total number of conversations created per month"
    },
    TWO_SIDED_CONVERSATION_RATIO: {
      ENG: "Ratio of 2 sided conversations per month",
      AR: "Ratio of 2 sided conversations per month",
      FR: "Ratio of 2 sided conversations per month",
      TR: "Ratio of 2 sided conversations per month"
    },
    TOTAL_USERS_NUMBERS: {
      ENG: "Total number of users",
      AR: "Total number of users",
      FR: "Total number of users",
      TR: "Total number of users"
    },
    TOTAL_MONTHLY_NEW_USERS: {
      ENG: "Total number of new users per month",
      AR: "Total number of new users per month",
      FR: "Total number of new users per month",
      TR: "Total number of new users per month"
    },
    EXPENSES_PER_MONTH: {
      ENG: "Expenses per month",
      AR: "Expenses per month",
      FR: "Expenses per month",
      TR: "Expenses per month"
    },
    APPROVE_REJECT: {
      ENG: "Approve Reject",
      AR: "Approve Reject",
      FR: "Approve Reject",
      TR: "Approve Reject"
    },
    LAST_LOGIN: {
      ENG: "Last login",
      AR: "Last login",
      FR: "Last login",
      TR: "Last login"
    },
    SIGN_OUT: {
      ENG: "Sign out",
      AR: "Sign out",
      FR: "Sign out",
      TR: "Sign out"
    },
    REASON: {
      ENG: "Reason: ",
      AR: "Reason: ",
      FR: "Reason: ",
      TR: "Reason: "
    },
    COMMENT: {
      ENG: "Comment: ",
      AR: "Comment: ",
      FR: "Comment: ",
      TR: "Comment: "
    },
    REPORTER: {
      ENG: "Reporter",
      AR: "Reporter",
      FR: "Reporter",
      TR: "Reporter"
    },
    REPORTED: {
      ENG: "Reported",
      AR: "Reported",
      FR: "Reported",
      TR: "Reported"
    },
    REFRESH: {
      ENG: "Refresh",
      AR: "Refresh",
      FR: "Refresh",
      TR: "Refresh"
    },
    REPORT_REASON_1: {
      ENG: "Bad Language",
      AR: "Bad Language",
      FR: "Bad Language",
      TR: "Bad Language"
    },
    REPORT_REASON_2: {
      ENG: "Fake profile",
      AR: "Fake profile",
      FR: "Fake profile",
      TR: "Fake profile"
    },
    REPORT_REASON_3: {
      ENG: "Impersonation",
      AR: "Impersonation",
      FR: "Impersonation",
      TR: "Impersonation"
    },
    REPORT_REASON_4: {
      ENG: "Inappropriate Picture",
      AR: "Inappropriate Picture",
      FR: "Inappropriate Picture",
      TR: "Inappropriate Picture"
    },
    REPORT_REASON_5: {
      ENG: "Other",
      AR: "Other",
      FR: "Other",
      TR: "Other"
    },
    PAID: {
      ENG: "Paid",
      AR: "Paid",
      FR: "Paid",
      TR: "Paid"
    },
    NOT_PAID: {
      ENG: "Not Paid",
      AR: "Not Paid",
      FR: "Not Paid",
      TR: "Not Paid"
    },
    INVALID_CREDENTIALS: {
      ENG: "Invalid credentials",
      AR: "Invalid credentials",
      FR: "Invalid credentials",
      TR: "Invalid credentials"
    },
    INCORRECT_NEWPASSWORD: {
      ENG: "New password doesn't match",
      AR: "New password doesn't match",
      FR: "New password doesn't match",
      TR: "New password doesn't match"
    },
    INCORRECT_OLD_PASSWORD: {
      ENG: "Old password is incorrect",
      AR: "Old password is incorrect",
      FR: "Old password is incorrect",
      TR: "Old password is incorrect"
    },
    SERVER_ENCOUNTERED_ERROR: {
      ENG: "An error occurred, please try again",
      AR: "An error occurred, please try again",
      FR: "An error occurred, please try again",
      TR: "An error occurred, please try again"
    },
    PASSWORD_CHANGE_SUCCESSFUL: {
      ENG: "Password changed successfully",
      AR: "Password changed successfully",
      FR: "Password changed successfully",
      TR: "Password changed successfully"
    },
    WRONG_INPUT: {
      ENG: "Wrong Input",
      AR: "Wrong Input",
      FR: "Wrong Input",
      TR: "Wrong Input"
    },
    LOADING: {
      ENG: "Loading ...",
      AR: "Loading ...",
      FR: "Loading ...",
      TR: "Loading ..."
    },
    ACCEPT: { ENG: "Accept", AR: "Accept", FR: "Accept", TR: "Accept" },
    ACCEPT_DESCRIPTION: {
      ENG: "Accept Description",
      AR: "Accept Description",
      FR: "Accept Description",
      TR: "Accept Description"
    },
    ACCEPT_PICTURE: {
      ENG: "Accept Picture",
      AR: "Accept Picture",
      FR: "Accept Picture",
      TR: "Accept Picture"
    },
    USER_STATUS_CHANGED_SUCCESSFULLY: {
      ENG: "User status changed successfully",
      AR: "User status changed successfully",
      FR: "User status changed successfully",
      TR: "User status changed successfully"
    },
    USER_NAME_CHANGED_SUCCESSFULLY: {
      ENG: "Username changed successfully",
      AR: "Username changed successfully",
      FR: "Username changed successfully",
      TR: "Username changed successfully"
    },
    USER_VIP_ADDED_SUCCESSFULLY: {
      ENG: "User VIP added successfully",
      AR: "User VIP added successfully",
      FR: "User VIP added successfully",
      TR: "User VIP added successfully"
    },
    USER_FLAGGED_SUCCESSFULLY: {
      ENG: "User flagged successfully",
      AR: "User flagged successfully",
      FR: "User flagged successfully",
      TR: "User flagged successfully"
    },
    USER_GENDER_CHANGED_SUCCESSFULLY: {
      ENG: "User gender changed successfully to new user id : %EXTRA_DATA%",
      AR: "User gender changed successfully to new user id : %EXTRA_DATA%",
      FR: "User gender changed successfully to new user id : %EXTRA_DATA%",
      TR: "User gender changed successfully to new user id : %EXTRA_DATA%"
    },
    DESCRIPTION_REJECTED_SUCCESSFULLY: {
      ENG: "Description Rejected Successfully",
      AR: "Description Rejected Successfully",
      FR: "Description Rejected Successfully",
      TR: "Description Rejected Successfully"
    },
    PEER_DESCRIPTION_REJECTED_SUCCESSFULLY: {
      ENG: "Peer Description Rejected Successfully",
      AR: "Peer Description Rejected Successfully",
      FR: "Peer Description Rejected Successfully",
      TR: "Peer Description Rejected Successfully"
    },
    DESCRIPTION_APPROVED_SUCCESSFULLY: {
      ENG: "Description Approved Successfully",
      AR: "Description Approved Successfully",
      FR: "Description Approved Successfully",
      TR: "Description Approved Successfully"
    },
    PEER_DESCRIPTION_APPROVED_SUCCESSFULLY: {
      ENG: "Peer Description Approved Successfully",
      AR: "Peer Description Approved Successfully",
      FR: "Peer Description Approved Successfully",
      TR: "Peer Description Approved Successfully"
    },
    PICTURE_REJECTED_SUCCESSFULLY: {
      ENG: "Picture Rejected Successfully",
      AR: "Picture Rejected Successfully",
      FR: "Picture Rejected Successfully",
      TR: "Picture Rejected Successfully"
    },
    PICTURE_APPROVED_SUCCESSFULLY: {
      ENG: "Picture Approved Successfully",
      AR: "Picture Approved Successfully",
      FR: "Picture Approved Successfully",
      TR: "Picture Approved Successfully"
    },
    ORDER: {
      ENG: "Order",
      AR: "Order",
      FR: "Order",
      TR: "Order"
    },
    USER_EVENTS_TABLE: {
      ENG: "User Events Table",
      AR: "User Events Table",
      FR: "User Events Table",
      TR: "User Events Table"
    },
    USER_DEVICES_TABLE: {
      ENG: "User Devices Table",
      AR: "User Devices Table",
      FR: "User Devices Table",
      TR: "User Devices Table"
    },
    DEVICE_UNLINKED_SUCCESSFULLY: {
      ENG: "Device Unlinked Successfully",
      AR: "Device Unlinked Successfully",
      FR: "Device Unlinked Successfully",
      TR: "Device Unlinked Successfully"
    },
    PERMISSIONS_TABLE: {
      ENG: "Admin Permissions Table",
      AR: "Admin Permissions Table",
      FR: "Admin Permissions Table",
      TR: "Admin Permissions Table"
    },
    MESSAGES_SEND_FROM: {
      ENG: "Messages Sent between %EXTRA_DATA%",
      AR: "Messages Sent between %EXTRA_DATA%",
      FR: "Messages Sent between %EXTRA_DATA%",
      TR: "Messages Sent between %EXTRA_DATA%"
    },
    UPDATE_PERMISSIONS: {
      ENG: "Update Permissions",
      AR: "Update Permissions",
      FR: "Update Permissions",
      TR: "Update Permissions"
    },
    FROM: {
      ENG: "From: ",
      AR: "From: ",
      FR: "From: ",
      TR: "From: "
    },
    TO: {
      ENG: "To: ",
      AR: "To: ",
      FR: "To: ",
      TR: "To: "
    },
    ACTION_TAKEN: {
      ENG: "Action Taken",
      AR: "Action Taken",
      FR: "Action Taken",
      TR: "Action Taken"
    },

    TBW: {
      ENG: "TBW",
      AR: "TBW",
      FR: "TBW",
      TR: "TBW"
    },
    TBW_REASONS: {
      ENG: "T.B.W Reasons ",
      AR: "T.B.W Reasons ",
      FR: "T.B.W Reasons ",
      TR: "T.B.W Reasons "
    },
    SELECT_REASONS_OF_ACTION: {
      ENG: "Please select the reasons for %EXTRA_DATA%",
      AR: "Please select the reasons for %EXTRA_DATA%",
      FR: "Please select the reasons for %EXTRA_DATA%",
      TR: "Please select the reasons for %EXTRA_DATA%"
    },
    ACTIVE: {
      ENG: "Active",
      AR: "Active",
      FR: "Active",
      TR: "Active"
    },
    WRONG_AND_FIX: {
      ENG: "Fix Wrong",
      AR: "Fix Wrong",
      FR: "Fix Wrong",
      TR: "Fix Wrong"
    },
    CORRECT: {
      ENG: "Correct",
      AR: "Correct",
      FR: "Correct",
      TR: "Correct"
    },
    WRONG: {
      ENG: "Wrong",
      AR: "Wrong",
      FR: "Wrong",
      TR: "Wrong"
    },
    INCORRECT_VIP_DAYS_HOURS: {
      ENG: "Cannot give less than one day vip and lass than one hour to a user",
      AR: "Cannot give less than one day vip and lass than one hour to a user",
      FR: "Cannot give less than one day vip and lass than one hour to a user",
      TR: "Cannot give less than one day vip and lass than one hour to a user"
    },
    SELECT_SMALLER_DATE_RANGE: {
      ENG: "Select smaller date range (max. 1 month)",
      AR: "Select smaller date range (max. 1 month)",
      FR: "Select smaller date range (max. 1 month)",
      TR: "Select smaller date range (max. 1 month)"
    },
    SELECT_CORRECT_DATE_RANGE: {
      ENG: "Select correct date range",
      AR: "Select correct date range",
      FR: "Select correct date range",
      TR: "Select correct date range"
    },
    CHECK_START_EXPIRY_DATE: {
      AR: "Check your start date or expiry date",
      ENG: "Check your start date or expiry date",
      FR: "Check your start date or expiry date",
      TR: "Check your start date or expiry date"
    },
    GENDER: {
      ENG: "Gender",
      AR: "Gender",
      FR: "Gender",
      TR: "Gender"
    },
    EXPAND_SECTION: {
      ENG: "Expand",
      AR: "Expand",
      FR: "Expand",
      TR: "Expand"
    },
    COLLAPSE_SECTION: {
      ENG: "Collapse",
      AR: "Collapse",
      FR: "Collapse",
      TR: "Collapse"
    },
    VERIFIED_BADGE: {
      ENG: "Verified",
      AR: "Verified",
      FR: "Verified",
      TR: "Verified"
    },
    IDENTITY_AND_ACCOUNT: {
      ENG: "Identity & Account",
      AR: "Identity & Account",
      FR: "Identity & Account",
      TR: "Identity & Account"
    },
    ACTIVATION_AND_VERIFICATION: {
      ENG: "Activation & Verification",
      AR: "Activation & Verification",
      FR: "Activation & Verification",
      TR: "Activation & Verification"
    },
    DEVICE_AND_SESSION: {
      ENG: "Device & Session",
      AR: "Device & Session",
      FR: "Device & Session",
      TR: "Device & Session"
    },
    SUBRELIGION: {
      ENG: "Subreligion",
      AR: "Subreligion",
      FR: "Subreligion",
      TR: "Subreligion"
    },
    STATUS_CHANGE_DATE: {
      ENG: "Status Changed",
      AR: "Status Changed",
      FR: "Status Changed",
      TR: "Status Changed"
    },
    APP_LANGUAGE: {
      ENG: "App Language",
      AR: "App Language",
      FR: "App Language",
      TR: "App Language"
    },
    APPROVED_PICTURES: {
      ENG: "Approved verified photos",
      AR: "Approved verified photos",
      FR: "Approved verified photos",
      TR: "Approved verified photos"
    },
    SELFIE_COMPLETED_ON: {
      ENG: "Selfie Completed",
      AR: "Selfie Completed",
      FR: "Selfie Completed",
      TR: "Selfie Completed"
    },
    ACTIVATION_CODE: {
      ENG: "Activation Code",
      AR: "Activation Code",
      FR: "Activation Code",
      TR: "Activation Code"
    },
    SELFIE_VERIFICATION: {
      ENG: "Selfie Verification",
      AR: "Selfie Verification",
      FR: "Selfie Verification",
      TR: "Selfie Verification"
    },
    NOT_VERIFIED_BADGE: {
      ENG: "Not Verified",
      AR: "Not Verified",
      FR: "Not Verified",
      TR: "Not Verified"
    },
    FACEBOOK_VERIFY: {
      ENG: "Facebook",
      AR: "Facebook",
      FR: "Facebook",
      TR: "Facebook"
    },
    SMS_VERIFY: {
      ENG: "SMS",
      AR: "SMS",
      FR: "SMS",
      TR: "SMS"
    },
    EMAIL_VERIFY: {
      ENG: "Email",
      AR: "Email",
      FR: "Email",
      TR: "Email"
    },
    APPLE_VERIFY: {
      ENG: "Apple",
      AR: "Apple",
      FR: "Apple",
      TR: "Apple"
    },
    EMAIL_NOTIFICATION: {
      ENG: "Email Notifications",
      AR: "Email Notifications",
      FR: "Email Notifications",
      TR: "Email Notifications"
    },
    PUSH_NOTIFICATION: {
      ENG: "Push Notifications",
      AR: "Push Notifications",
      FR: "Push Notifications",
      TR: "Push Notifications"
    },
    PHONE_DETAILS: {
      ENG: "Phone",
      AR: "Phone",
      FR: "Phone",
      TR: "Phone"
    },
    IP_ADDRESS: {
      ENG: "IP Address",
      AR: "IP Address",
      FR: "IP Address",
      TR: "IP Address"
    },
    DEVICE_TOKEN: {
      ENG: "Device Token",
      AR: "Device Token",
      FR: "Device Token",
      TR: "Device Token"
    },
    WAS_PAYING: {
      ENG: "Ever Paid",
      AR: "Ever Paid",
      FR: "Ever Paid",
      TR: "Ever Paid"
    },
    FREEMIUM_GRANTS: {
      ENG: "Freemium grants",
      AR: "Freemium grants",
      FR: "Freemium grants",
      TR: "Freemium grants"
    },
    PAID_UNTIL: {
      ENG: "Paid subscriptions",
      AR: "Paid subscriptions",
      FR: "Paid subscriptions",
      TR: "Paid subscriptions"
    },
    KHATTABA_ASSIGNED: {
      ENG: "Khattaba Assigned",
      AR: "Khattaba Assigned",
      FR: "Khattaba Assigned",
      TR: "Khattaba Assigned"
    },
    OPEN_CASE: {
      ENG: "Open case",
      AR: "Open case",
      FR: "Open case",
      TR: "Open case"
    },
    YES_VALUE: {
      ENG: "Yes",
      AR: "Yes",
      FR: "Yes",
      TR: "Yes"
    },
    NO_VALUE: {
      ENG: "No",
      AR: "No",
      FR: "No",
      TR: "No"
    },
    PAID_FEATURE_SETS: {
      ENG: "Paid feature sets",
      AR: "Paid feature sets",
      FR: "Paid feature sets",
      TR: "Paid feature sets"
    },
    CONSUMABLES_LANE: {
      ENG: "Consumables",
      AR: "Consumables",
      FR: "Consumables",
      TR: "Consumables"
    },
    VIA_FEATURE_SETS: {
      ENG: "Via feature sets",
      AR: "Via feature sets",
      FR: "Via feature sets",
      TR: "Via feature sets"
    },
    ROW_NUMBER: {
      ENG: "No.",
      AR: "No.",
      FR: "No.",
      TR: "No."
    },
    VALUE_COLUMN: {
      ENG: "Value",
      AR: "Value",
      FR: "Value",
      TR: "Value"
    },
    DATE_COLUMN: {
      ENG: "Date",
      AR: "Date",
      FR: "Date",
      TR: "Date"
    },
    ADMIN_NAME: {
      ENG: "Admin Name",
      AR: "Admin Name",
      FR: "Admin Name",
      TR: "Admin Name"
    },
    QUESTION_ID: {
      ENG: "Question Id",
      AR: "Question Id",
      FR: "Question Id",
      TR: "Question Id"
    },
    ALLOWED_ANSWERS: {
      ENG: "Allowed Answers",
      AR: "Allowed Answers",
      FR: "Allowed Answers",
      TR: "Allowed Answers"
    },
    QUESTION: {
      ENG: "Question",
      AR: "Question",
      FR: "Question",
      TR: "Question"
    },
    ANSWER: {
      ENG: "Answer",
      AR: "Answer",
      FR: "Answer",
      TR: "Answer"
    },
    VERIFICATION_ACTIVE: {
      ENG: "Verification Active",
      AR: "Verification Active",
      FR: "Verification Active",
      TR: "Verification Active"
    },
    USER_ACTIVITY_EMAILS_SUBSCRIPTION: {
      ENG: "User Activity Emails Subscription",
      AR: "User Activity Emails Subscription",
      FR: "User Activity Emails Subscription",
      TR: "User Activity Emails Subscription"
    },
    PROMOTIONAL_EMAILS_SUBSCRIPTION: {
      ENG: "Promotional Emails Subscription",
      AR: "Promotional Emails Subscription",
      FR: "Promotional Emails Subscription",
      TR: "Promotional Emails Subscription"
    },
    NEW_MESSAGE_EMAILS_SUBSCRIPTION: {
      ENG: "New Message Emails Subscription",
      AR: "New Message Emails Subscription",
      FR: "New Message Emails Subscription",
      TR: "New Message Emails Subscription"
    },
    VISIT_PROFILE_EMAILS_SUBSCRIPTION: {
      ENG: "Visit Profile Emails Subscription",
      AR: "Visit Profile Emails Subscription",
      FR: "Visit Profile Emails Subscription",
      TR: "Visit Profile Emails Subscription"
    },
    LIKE_EMAILS_SUBSCRIPTION: {
      ENG: "Like Emails Subscription",
      AR: "Like Emails Subscription",
      FR: "Like Emails Subscription",
      TR: "Like Emails Subscription"
    },
    USER_ACTIVITY_EMAILS_SETTINGS: {
      ENG: "User Activity Emails Settings",
      AR: "User Activity Emails Settings",
      FR: "User Activity Emails Settings",
      TR: "User Activity Emails Settings"
    },
    PROMOTIONAL_EMAILS_SETTINGS: {
      ENG: "Promotional Emails Settings",
      AR: "Promotional Emails Settings",
      FR: "Promotional Emails Settings",
      TR: "Promotional Emails Settings"
    },
    NEW_MESSAGE_EMAILS_SETTINGS: {
      ENG: "New Message Emails Settings",
      AR: "New Message Emails Settings",
      FR: "New Message Emails Settings",
      TR: "New Message Emails Settings"
    },
    VISIT_PROFILE_EMAILS_SETTINGS: {
      ENG: "Visit Profile Emails Settings",
      AR: "Visit Profile Emails Settings",
      FR: "Visit Profile Emails Settings",
      TR: "Visit Profile Emails Settings"
    },
    LIKE_EMAILS_SETTINGS: {
      ENG: "Like Emails Settings",
      AR: "Like Emails Settings",
      FR: "Like Emails Settings",
      TR: "Like Emails Settings"
    },
    NO_OPEN_REPORT: {
      ENG: "No open report",
      AR: "No open report",
      FR: "No open report",
      TR: "No open report"
    },
    TESTER_ACCOUNT: {
      ENG: "Tester account",
      AR: "Tester account",
      FR: "Tester account",
      TR: "Tester account"
    },
    NONE_VALUE: {
      ENG: "None",
      AR: "None",
      FR: "None",
      TR: "None"
    },
    NOT_ACTIVATED: {
      ENG: "Not Activated",
      AR: "Not Activated",
      FR: "Not Activated",
      TR: "Not Activated"
    },
    ACTIVATED: {
      ENG: "Activated",
      AR: "Activated",
      FR: "Activated",
      TR: "Activated"
    },
    ON_VALUE: {
      ENG: "On",
      AR: "On",
      FR: "On",
      TR: "On"
    },
    OFF_VALUE: {
      ENG: "Off",
      AR: "Off",
      FR: "Off",
      TR: "Off"
    },
    SELFIE_VERIFIED: {
      ENG: "Selfie verified",
      AR: "Selfie verified",
      FR: "Selfie verified",
      TR: "Selfie verified"
    },
    NO_DESCRIPTION_SUBMITTED: {
      ENG: "No description submitted.",
      AR: "No description submitted.",
      FR: "No description submitted.",
      TR: "No description submitted."
    },
    APPROVE: {
      ENG: "Approve",
      AR: "Approve",
      FR: "Approve",
      TR: "Approve"
    },
    REJECT: {
      ENG: "Reject",
      AR: "Reject",
      FR: "Reject",
      TR: "Reject"
    },
    MODERATION_STATE: {
      ENG: "Moderation State",
      AR: "Moderation State",
      FR: "Moderation State",
      TR: "Moderation State"
    },
    DESCRIPTIONS: {
      ENG: "Descriptions",
      AR: "Descriptions",
      FR: "Descriptions",
      TR: "Descriptions"
    },
    DEACTIVATED_ON: {
      ENG: "Deactivated On",
      AR: "Deactivated On",
      FR: "Deactivated On",
      TR: "Deactivated On"
    },
    USER_SUMMARY: {
      ENG: "User Summary",
      AR: "User Summary",
      FR: "User Summary",
      TR: "User Summary"
    },
    USER_PROFILE_AND_DESCRIPTIONS: {
      ENG: "Profile & Descriptions",
      AR: "Profile & Descriptions",
      FR: "Profile & Descriptions",
      TR: "Profile & Descriptions"
    },
    SUBSCRIPTIONS_AND_FEATURES: {
      ENG: "Subscriptions & Features",
      AR: "Subscriptions & Features",
      FR: "Subscriptions & Features",
      TR: "Subscriptions & Features"
    },
    USER_ALL_FIELDS: {
      ENG: "All Fields",
      AR: "All Fields",
      FR: "All Fields",
      TR: "All Fields"
    },
    NONE_ACTIVE: {
      ENG: "None active",
      AR: "None active",
      FR: "None active",
      TR: "None active"
    },
    CREATED_ON: {
      ENG: "Created On",
      AR: "Created On",
      FR: "Created On",
      TR: "Created On"
    },
    CREATED_FROM: {
      ENG: "Created From",
      AR: "Created From",
      FR: "Created From",
      TR: "Created From"
    },
    CITY_NAME: {
      ENG: "City",
      AR: "City",
      FR: "City",
      TR: "City"
    },
    ORIGIN_COUNTRY: {
      ENG: "Origin Country",
      AR: "Origin Country",
      FR: "Origin Country",
      TR: "Origin Country"
    },
    RESIDENCE_COUNTRY: {
      ENG: "Residence Country",
      AR: "Residence Country",
      FR: "Residence Country",
      TR: "Residence Country"
    },
    ACTIVATION_STATUS: {
      ENG: "Activation",
      AR: "Activation",
      FR: "Activation",
      TR: "Activation"
    },
    TEMPORARY_BANS: {
      ENG: "Temporary Bans",
      AR: "Temporary Bans",
      FR: "Temporary Bans",
      TR: "Temporary Bans"
    },
    WARNINGS: {
      ENG: "Warnings",
      AR: "Warnings",
      FR: "Warnings",
      TR: "Warnings"
    },
    REPORTS_SENT: {
      ENG: "Reports Sent",
      AR: "Reports Sent",
      FR: "Reports Sent",
      TR: "Reports Sent"
    },
    REPORTS_RECEIVED: {
      ENG: "Reports Received",
      AR: "Reports Received",
      FR: "Reports Received",
      TR: "Reports Received"
    },
    LOGIN_COUNT: {
      ENG: "Logins",
      AR: "Logins",
      FR: "Logins",
      TR: "Logins"
    },
    REFERRAL_CODE: {
      ENG: "Referral Code",
      AR: "Referral Code",
      FR: "Referral Code",
      TR: "Referral Code"
    },
    APP_VERSION: {
      ENG: "App Version",
      AR: "App Version",
      FR: "App Version",
      TR: "App Version"
    },
    USER_ADVANCED_TABLE: {
      ENG: "User Advanced Table",
      AR: "User Advanced Table",
      FR: "User Advanced Table",
      TR: "User Advanced Table"
    },
    USER_ADVANCED_QUIZ_TABLE: {
      ENG: "User Advanced Quiz Table",
      AR: "User Advanced Quiz Table",
      FR: "User Advanced Quiz Table",
      TR: "User Advanced Quiz Table"
    },
    USER_QUIZ: {
      ENG: "User Quiz",
      AR: "User Quiz",
      FR: "User Quiz",
      TR: "User Quiz"
    },
    USER_ADVANCED_EMAIL_TABLE: {
      ENG: "Emails",
      AR: "Emails",
      FR: "Emails",
      TR: "Emails"
    },
    VIEW_EDIT_ADMIN_DASHBOARD: {
      ENG: "View/Edit admin dashboard",
      AR: "View/Edit admin dashboard",
      FR: "View/Edit admin dashboard",
      TR: "View/Edit admin dashboard"
    },
    MINOR_ISSUE: {
      ENG: "Minor Issue",
      AR: "Minor Issue",
      FR: "Minor Issue",
      TR: "Minor Issue"
    },
    MAJOR_ISSUE: {
      ENG: "Major Issue",
      AR: "Major Issue",
      FR: "Major Issue",
      TR: "Major Issue"
    },
    NO_ISSUE: {
      ENG: "No Issue",
      AR: "No Issue",
      FR: "No Issue",
      TR: "No Issue"
    },
    USER_WARNED: {
      ENG: "User Warned",
      AR: "User Warned",
      FR: "User Warned",
      TR: "User Warned"
    },
    REPORT_RESOLVE: {
      ENG: "Report Resolved",
      AR: "Report Resolved",
      FR: "Report Resolved",
      TR: "Report Resolved"
    },
    REPORT_EMAIL: {
      ENG: "Report Email",
      AR: "Report Email",
      FR: "Report Email",
      TR: "Report Email"
    },
    USER_BANNED: {
      ENG: "User Banned",
      AR: "User Banned",
      FR: "User Banned",
      TR: "User Banned"
    },
    USER_TEMPORARY_BANNED: {
      ENG: "User Temporary banned",
      AR: "User Temporary banned",
      FR: "User Temporary banned",
      TR: "User Temporary banned"
    },
    AUDIT_PERFORMANCE: {
      ENG: "Auditing Performance",
      AR: "Auditing Performance",
      FR: "Auditing Performance",
      TR: "Auditing Performance"
    },
    IMAGE_DELETED: {
      ENG: "DELETED BY USER",
      AR: "DELETED BY USER",
      FR: "DELETED BY USER",
      TR: "DELETED BY USER"
    },
    SUPERVISOR: {
      ENG: "Supervisor",
      AR: "Supervisor",
      FR: "Supervisor",
      TR: "Supervisor"
    },
    MARK_SEEN: {
      ENG: "Mark Seen",
      AR: "Mark Seen",
      FR: "Mark Seen",
      TR: "Mark Seen"
    },
    SUPERVISE: {
      ENG: "Supervise",
      AR: "Supervise",
      FR: "Supervise",
      TR: "Supervise"
    },
    SUPERVISE_ADMIN_AUDITS: {
      ENG: "Supervise Admin Audits",
      AR: "Supervise Admin Audits",
      FR: "Supervise Admin Audits",
      TR: "Supervise Admin Audits"
    },
    VIEW_SUPERVISED_EVENTS: {
      ENG: "View Supervised Audit Events",
      AR: "View Supervised Audit Events",
      FR: "View Supervised Audit Events",
      TR: "View Supervised Audit Events"
    },
    AUDIT_EFFICIENCY: {
      ENG: "Auditing Efficiency",
      AR: "Auditing Efficiency",
      FR: "Auditing Efficiency",
      TR: "Auditing Efficiency"
    },
    Admin_Audit_Helper_Text: {
      ENG: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page.",
      AR: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page.",
      FR: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page.",
      TR: "-This section displays the events for chosen CSR to be audit by the admin.\n-The displayed events are retrieved from date min to date max, which is undertaken on those dates.\n-The admin will choose action towards every event done by CSR.\n-But, if the admin marks a specific event as Major Issue, and if this event has an approved (description or picture) type, it will be changed to rejected (description or picture) type.\n-To see audit events, visit the audited events page."
    },
    Admin_Audit_Events_Helper_Text: {
      ENG: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR.",
      AR: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR.",
      FR: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR.",
      TR: "-This page shows the audited events that happened on the audit page.\n-The page retrieves events(approval, reports) undertaken by the selected CSR in the Admin Picker Field, which are audited by any Senior CSR."
    },
    Supervise_Helper_Text: {
      ENG: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab.",
      AR: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab.",
      FR: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab.",
      TR: "-This Page retrieves Audit events for chosen admin to be supervised by the supervisor.\n-The displayed audit events are retrieved from date min to date max, which is audited on those dates.\n-The supervisor will choose action towards every audited event, which will assess the performance of chosen admin.\n-When retrieving data again, the supervised records will not be shown again.\n-To see supervised events, refer to the Supervised Events Tab."
    },
    Supervise_Events_Helper_Text: {
      ENG: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR.",
      AR: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR.",
      FR: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR.",
      TR: "-This page shows the supervised events that happened on the supervise page.\n-The page retrieves supervised Audit events(for approval, reports) undertaken by the selected Senior CSR, in the Admin Picker Field, which are undertaken on any other CSR."
    },
    MONITOR_USER_MESSAGE_ID: {
      ENG: "monitor user messages by id",
      AR: "monitor user messages by id",
      FR: "monitor user messages by id",
      TR: "monitor user messages by id"
    },
    MESSAGE_ID: {
      ENG: "Message Id",
      AR: "Message Id",
      FR: "Message Id",
      TR: "Message Id"
    },
    USER_MESSAGES_ID_TABLE: {
      ENG: "User Message Id Table",
      AR: "User Message Id Table",
      FR: "User Message Id Table",
      TR: "User Message Id Table"
    },
    WRONG_MESSAGE_ID: {
      ENG: "Wrong Message Id",
      AR: "Wrong Message Id",
      FR: "Wrong Message Id",
      TR: "Wrong Message Id"
    },
    WORKLOAD_DATA: {
      ENG: "Workload Data",
      AR: "Workload Data",
      FR: "Workload Data",
      TR: "Workload Data"
    },
    WORKLOAD_DATA_BETWEEN_TWO_DATES: {
      ENG: "Workload data between two dates",
      AR: "Workload data between two dates",
      FR: "Workload data between two dates",
      TR: "Workload data between two dates"
    },
    WORKLOAD_TABLE: {
      ENG: "Workload Table",
      AR: "Workload Table",
      FR: "Workload Table",
      TR: "Workload Table"
    },
    AUDITING_PERFORMANCE: {
      ENG: "Auditing Performance",
      AR: "Auditing Performance",
      FR: "Auditing Performance",
      TR: "Auditing Performance"
    },
    AUDITING_PERFORMANCE_DASHBOARD: {
      ENG: "Auditing Performance Table",
      AR: "Auditing Performance Table",
      FR: "Auditing Performance Table",
      TR: "Auditing Performance Table"
    },
    ADD_REMOVE: {
      ENG: "Add/Remove",
      AR: "Add/Remove",
      FR: "Add/Remove",
      TR: "Add/Remove"
    },
    PROOF_MINOR_MAJOR: {
      ENG: "Please Insert Proof for Minor or Major",
      AR: "Please Insert Proof for Minor or Major",
      FR: "Please Insert Proof for Minor or Major",
      TR: "Please Insert Proof for Minor or Major"
    },
    INSERT_PROOF: {
      AR: "Insert Proof",
      FR: "Insert Proof",
      ENG: "Insert Proof",
      TR: "Insert Proof"
    },
    DATE_RANGE: {
      ENG: "Date Range",
      AR: "Date Range",
      FR: "Date Range",
      TR: "Date Range"
    },
    USER_EDIT_PROFILE: {
      ENG: "Edit profile",
      AR: "Edit profile",
      FR: "Edit profile",
      TR: "Edit profile"
    },
    USER_EDIT_PROFILE_ARCHIVE: {
      ENG: "Edit profile history",
      AR: "Edit profile history",
      FR: "Edit profile history",
      TR: "Edit profile history"
    },
    EDIT_USER_DATA: {
      ENG: "Edit Profile",
      AR: "Edit Profile",
      FR: "Edit Profile",
      TR: "Edit Profile"
    },
    INVALID_PASSWORD: {
      ENG: `Password must be ${PASSWORD_MIN_LENGTH} to ${PASSWORD_MAX_LENGTH} latin characters and include at least one uppercase letter, one lowercase letter, one number and one symbol, with no Arabic characters and no spaces`,
      AR: `Password must be ${PASSWORD_MIN_LENGTH} to ${PASSWORD_MAX_LENGTH} latin characters and include at least one uppercase letter, one lowercase letter, one number and one symbol, with no Arabic characters and no spaces`,
      FR: `Password must be ${PASSWORD_MIN_LENGTH} to ${PASSWORD_MAX_LENGTH} latin characters and include at least one uppercase letter, one lowercase letter, one number and one symbol, with no Arabic characters and no spaces`,
      TR: `Password must be ${PASSWORD_MIN_LENGTH} to ${PASSWORD_MAX_LENGTH} latin characters and include at least one uppercase letter, one lowercase letter, one number and one symbol, with no Arabic characters and no spaces`
    },
    INCORRECT_PASSWORD_REPEATED: {
      ENG: "You cannot use your old password!",
      AR: "You cannot use your old password!",
      FR: "You cannot use your old password!",
      TR: "You cannot use your old password!"
    },
    REFERRAL_CODE_USAGE: {
      ENG: "Referral Code Usage",
      AR: "Referral Code Usage",
      FR: "Referral Code Usage",
      TR: "Referral Code Usage"
    },
    USER_REFERRAL_CODE_USAGE_TABLE: {
      ENG: "User Referral Code Usage Table",
      AR: "User Referral Code Usage Table",
      FR: "User Referral Code Usage Table",
      TR: "User Referral Code Usage Table"
    },
    WRONG_USER_ID: {
      ENG: "Wrong User Id",
      AR: "Wrong User Id",
      FR: "Wrong User Id",
      TR: "Wrong User Id"
    },
    USER_DATA_CHANGED: {
      AR: "User Data Changed",
      ENG: "User Data Changed",
      FR: "User Data Changed",
      TR: "User Data Changed"
    },
    USER_BANNED_SUCCESSFULLY: {
      AR: "User Banned Successfully",
      ENG: "User Banned Successfully",
      FR: "User Banned Successfully",
      TR: "User Banned Successfully"
    },
    USER_WARNED_SUCCESSFULLY: {
      AR: "User Warned Successfully",
      ENG: "User Warned Successfully",
      FR: "User Warned Successfully",
      TR: "User Warned Successfully"
    },
    PERMISSION_CHANGED: {
      AR: "Permission Changed",
      ENG: "Permission Changed",
      FR: "Permission Changed",
      TR: "Permission Changed"
    },
    POOL_CLEANED: {
      AR: "Pool Cleaned",
      ENG: "Pool Cleaned",
      FR: "Pool Cleaned",
      TR: "Pool Cleaned"
    },
    USER_LATEST_RECEIPT: {
      AR: "User Latest Receipt",
      ENG: "User Latest Receipt",
      FR: "User Latest Receipt",
      TR: "User Latest Receipt"
    },
    LOAD_MORE: {
      AR: "Load More",
      ENG: "Load More",
      FR: "Load More",
      TR: "Load More"
    },
    TESTER: {
      AR: "Tester",
      ENG: "Tester",
      FR: "Tester",
      TR: "Tester"
    },
    OPTIONS: {
      AR: "Options",
      ENG: "Options",
      FR: "Options",
      TR: "Options"
    },
    ADD_TBW: {
      AR: "Add TBW",
      ENG: "Add TBW",
      FR: "Add TBW",
      TR: "Add TBW"
    },
    ISSUE_TYPE: {
      AR: "Issue Type",
      ENG: "Issue Type",
      FR: "Issue Type",
      TR: "Issue Type"
    },
    ON_CALL: {
      AR: "On Call",
      ENG: "On Call",
      FR: "On Call",
      TR: "On Call"
    },
    PAYMENT_PACKAGES_TODAY: {
      AR: "Payment Packages For ToDay",
      ENG: "Payment Packages For ToDay",
      FR: "Payment Packages For ToDay",
      TR: "Payment Packages For ToDay"
    },
    PAYMENT_PACKAGES_PREV_DAY: {
      AR: "Payment Packages For Prev Day",
      ENG: "Payment Packages For Prev Day",
      FR: "Payment Packages For Prev Day",
      TR: "Payment Packages For Prev Day"
    },
    PACKAGE_NOTIFICATION_TYPE_COUNT: {
      AR: "Packages Notifications Type Count For Last Day",
      ENG: "Packages Notifications Type Count For Last Day",
      FR: "Packages Notifications Type Count For Last Day",
      TR: "Packages Notifications Type Count For Last Day"
    },
    COPY: {
      AR: "Copy",
      ENG: "Copy",
      FR: "Copy",
      TR: "Copy"
    },
    COPIED: {
      AR: "Copied",
      ENG: "Copied",
      FR: "Copied",
      TR: "Copied"
    },
    STATS_DASHBOARD: {
      AR: "Stats Dashboard",
      ENG: "Stats Dashboard",
      FR: "Stats Dashboard",
      TR: "Stats Dashboard"
    },
    PERFORMANCE: {
      AR: "Performance",
      ENG: "Performance",
      FR: "Performance",
      TR: "Performance"
    },
    EFFECTIVENESS: {
      AR: "Effectiveness",
      ENG: "Effectiveness",
      FR: "Effectiveness",
      TR: "Effectiveness"
    },

    USER_EMAIL_EVENTS_TABLE: {
      AR: "User Email Events Table",
      ENG: "User Email Events Table",
      FR: "User Email Events Table",
      TR: "User Email Events Table"
    },
    USER_DEACTIVATIONS_TABLE: {
      AR: "Deactivation Activity",
      ENG: "Deactivation Activity",
      FR: "Deactivation Activity",
      TR: "Deactivation Activity"
    },
    FLAGGED_CONNECTIONS: {
      AR: "Flagged Connections",
      ENG: "Flagged Connections",
      FR: "Flagged Connections",
      TR: "Flagged Connections"
    },
    FLAGGED_CONNECTIONS_HISTORY: {
      AR: "Flagged Connections History",
      ENG: "Flagged Connections History",
      FR: "Flagged Connections History",
      TR: "Flagged Connections History"
    },
    FLAGGED_CONNECTIONS_DETAILS: {
      AR: "Flagged Connections Details",
      ENG: "Flagged Connections Details",
      FR: "Flagged Connections Details",
      TR: "Flagged Connections Details"
    },

    FLAGGED_CONNECTIONS_DASHBOARD: {
      AR: "Flagged Connections Dashboard",
      ENG: "Flagged Connections Dashboard",
      FR: "Flagged Connections Dashboard",
      TR: "Flagged Connections Dashboard"
    },

    IOS_PAYMENTS: {
      AR: "IOS Payments",
      ENG: "IOS Payments",
      FR: "IOS Payments",
      TR: "IOS Payments"
    },
    ANDROID_PAYMENTS: {
      AR: "Android Payments",
      ENG: "Android Payments",
      FR: "Android Payments",
      TR: "Android Payments"
    },
    LAST_LOGIN_USERS: {
      AR: "Last Login Users",
      ENG: "Last Login Users",
      FR: "Last Login Users",
      TR: "Last Login Users"
    },
    EMAIL_USERS: {
      AR: "Email Users",
      ENG: "Email Users",
      FR: "Email Users",
      TR: "Email Users"
    },
    EMAIL_SENT: {
      AR: "Email Sent",
      ENG: "Email Sent",
      FR: "Email Sent",
      TR: "Email Sent"
    },
    SENT_EMAILS: {
      AR: "Sent Emails",
      ENG: "Sent Emails",
      FR: "Sent Emails",
      TR: "Sent Emails"
    },
    UNSUBSCRIBED_USER_ACTIVITY_EMAILS: {
      AR: "Unsubscribed User Activity Emails",
      ENG: "Unsubscribed User Activity Emails",
      FR: "Unsubscribed User Activity Emails",
      TR: "Unsubscribed User Activity Emails"
    },
    UNSUBSCRIBED_PROMOTIONAL_EMAILS: {
      AR: "Unsubscribed Promotional Emails",
      ENG: "Unsubscribed Promotional Emails",
      FR: "Unsubscribed Promotional Emails",
      TR: "Unsubscribed Promotional Emails"
    },
    UNSUBSCRIBED_NEW_MESSAGE_EMAILS: {
      AR: "Unsubscribed New Message Emails",
      ENG: "Unsubscribed New Message Emails",
      FR: "Unsubscribed New Message Emails",
      TR: "Unsubscribed New Message Emails"
    },
    UNSUBSCRIBED_VISIT_PROFILE_EMAILS: {
      AR: "Unsubscribed Visit Profile Emails",
      ENG: "Unsubscribed Visit Profile Emails",
      FR: "Unsubscribed Visit Profile Emails",
      TR: "Unsubscribed Visit Profile Emails"
    },
    UNSUBSCRIBED_LIKE_EMAILS: {
      AR: "Unsubscribed Like Emails",
      ENG: "Unsubscribed Like Emails",
      FR: "Unsubscribed Like Emails",
      TR: "Unsubscribed Like Emails"
    },
    SMS_USERS: {
      AR: "Sms Users",
      ENG: "Sms Users",
      FR: "Sms Users",
      TR: "Sms Users"
    },
    FB_USERS: {
      AR: "Fb Users",
      ENG: "Fb Users",
      FR: "Fb Users",
      TR: "Fb Users"
    },
    NEW_USERS: {
      AR: "New Users",
      ENG: "New Users",
      FR: "New Users",
      TR: "New Users"
    },

    TIME_FRAME: {
      AR: "Time Frame",
      ENG: "Time Frame",
      FR: "Time Frame",
      TR: "Time Frame"
    },

    DAILY_STATS: {
      AR: "Daily Stats",
      ENG: "Daily Stats",
      FR: "Daily Stats",
      TR: "Daily Stats"
    },
    REPORT_POOL_TABLE: {
      AR: "Report Pool Table",
      ENG: "Report Pool Table",
      FR: "Report Pool Table",
      TR: "Report Pool Table"
    },
    APPROVAL_POOL_TABLE: {
      AR: "Approval Pool Table",
      ENG: "Approval Pool Table",
      FR: "Approval Pool Table",
      TR: "Approval Pool Table"
    },
    INVESTIGATION_CASES_POOL_TABLE: {
      AR: "Investigation Cases Pool Table",
      ENG: "Investigation Cases Pool Table",
      FR: "Investigation Cases Pool Table",
      TR: "Investigation Cases Pool Table"
    },
    UNLINK_DEVICE: {
      AR: "Unlink Device",
      ENG: "Unlink Device",
      FR: "Unlink Device",
      TR: "Unlink Device"
    },
    INVESTIGATE: {
      AR: "Investigate",
      ENG: "Investigate",
      FR: "Investigate",
      TR: "Investigate"
    },
    ALREADY_EXISTING_VALUE: {
      AR: "Already Existing Value",
      ENG: "Already Existing Value",
      FR: "Already Existing Value",
      TR: "Already Existing Value"
    },
    SORRY_NO_PERMISSION: {
      AR: "Sorry No Permission",
      ENG: "Sorry No Permission",
      FR: "Sorry No Permission",
      TR: "Sorry No Permission"
    },
    MY_CSR_PERFORMANCE: {
      AR: "My CSR Performance",
      ENG: "My CSR Performance",
      FR: "My CSR Performance",
      TR: "My CSR Performance"
    },
    DEV_ZONE: {
      AR: "Developer",
      ENG: "Developer",
      FR: "Developer",
      TR: "Developer"
    },
    SAVE: {
      AR: "Save",
      ENG: "Save",
      FR: "Save",
      TR: "Save"
    },
    EDIT: {
      AR: "Edit",
      ENG: "Edit",
      FR: "Edit",
      TR: "Edit"
    },
    DELETE: {
      AR: "Delete",
      ENG: "Delete",
      FR: "Delete",
      TR: "Delete"
    },

    HELPER: {
      AR: "Helper!",
      ENG: "Helper!",
      FR: "Helper!",
      TR: "Helper!"
    },
    EMPTY_STRING: {
      AR: "",
      ENG: "",
      FR: "",
      TR: ""
    },
    DIVISION_BY_CSR: {
      AR: "Division By CSR ",
      ENG: "Division By CSR ",
      FR: "Division By CSR ",
      TR: "Division By CSR "
    },
    WELCOME: {
      AR: "Welcome",
      ENG: "Welcome",
      FR: "Welcome",
      TR: "Welcome"
    },
    PAYMENT_DATA_HELPER: {
      AR: "",
      ENG: `
      A. For IOS:

        - Some user purchases don't have ID linked to them, it will have the field userID: -99999
        - Apple doesn't return user country with purchase, thus it will have country code NO_COUNTRY


      B. IOS Event Types:

        - INITIAL_BUY: First Purchase
        - RENEWAL: Renewal of subscription
        - DID_RENEW: Renewal of subscription
        - DID_CHANGE_RENEWAL_PREF: Change subscription preference(upgrade or downgrade)
        - DID_CHANGE_RENEWAL_STATUS: Change auto renew status of subscription in the settings
        - INTERACTIVE_RENEWAL: when subscription expired, and user resubscribed
        - DID_FAIL_TO_RENEW: Renewal failed due to a biling issue; here user enters biling retry phase in apple servers
        - DID_RECOVER: When a user subscription auto renews successfully from retries after it failed due to billing issue and the issue was resolved
        - CANCEL: When apple refunds purchase to user
      

      C. Android Event Types: 

        - SUBSCRIP??TION_PURCHASED: First Purchase 
        - SUBSCRIPTION_RENEWED: Renewal of subscription
        - SUBSCRIPTION_ON_HOLD:  A subscription has entered account hold
        - SUBSCRIPTION_RECOVERED: A subscription was recovered from account hold.
        - SUBSCRIPTION_IN_GRACE_PERIOD: Subscription failed to renew, enters grace period while renewal is retried to check if billing issue fixed
        - SUBSCRIPTION_RESTARTED: User has restored their subscription from Play > Account > Subscriptions. The subscription was canceled but had not expired yet when the user restores. 
        - SUBSCRIPTION_PAUSED: subscription renewal was paused
        - SUBSCRIPTION_PAUSE_SCHEDULE_CHANGED: subscription renewal pause date changed
        - SUBSCRIPTION_EXPIRED: Subscription ended
        - SUBSCRIPTION_REVOKED: Subscription refuneded
        - SUBSCRIPTION_CANCELED: Subscription Renewal Cancelled
        - NO_PURCHASE_TYPE: SUBSCRIPTION_PAUSED or SUBSCRIPTION_PAUSE_SCHEDULE_CHANGED, due to issue in google, fixed in next releases
        
      `,
      FR: "",
      TR: ""
    },
    USER_NAME_CONDITIONS: {
      AR: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols",
      ENG: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols",
      FR: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols",
      TR: "Username must be between 3 and 14 letters with a maximum of 4 digits and without spaces or symbols"
    },
    SAME_USER_NAME: {
      AR: "Enter New Username",
      ENG: "Enter New Username",
      FR: "Enter New Username",
      TR: "Enter New Username"
    },
    EVENTS_NOT_FOUND: {
      AR: "Events Not Found",
      ENG: "Events Not Found",
      FR: "Events Not Found",
      TR: "Events Not Found"
    },
    SESSION_EXPIRED: {
      AR: "Session Expired",
      ENG: "Session Expired",
      FR: "Session Expired",
      TR: "Session Expired"
    },
    CSR: {
      AR: "CSR",
      ENG: "CSR",
      FR: "CSR",
      TR: "CSR"
    },
    AUDITOR: {
      AR: "Auditor",
      ENG: "Auditor",
      FR: "Auditor",
      TR: "Auditor"
    },
    USER_RATE_US_DATA: {
      AR: "User Rate Us Data",
      ENG: "User Rate Us Data",
      FR: "User Rate Us Data",
      TR: "User Rate Us Data"
    },
    USER_RATE_US_DATA_NOT_FOUND: {
      AR: "User Rate Us Data Not Found",
      ENG: "User Rate Us Data Not Found",
      FR: "User Rate Us Data Not Found",
      TR: "User Rate Us Data Not Found"
    },
    CSRS_PERFORMANCE: {
      AR: "CSRs Performance",
      ENG: "CSRs Performance",
      FR: "CSRs Performance",
      TR: "CSRs Performance"
    },
    USER_RESET_SUCCESSFULLY: {
      AR: "User Reset Successfully",
      ENG: "User Reset Successfully",
      FR: "User Reset Successfully",
      TR: "User Reset Successfully"
    },
    EMAIL_SUBSCRIPTION_STATUS_CHANGHED: {
      ENG: "Email subscription status changed, check it on User Advanced",
      FR: "Email subscription status changed, check it on User Advanced",
      TR: "Email subscription status changed, check it on User Advanced",
      AR: "Email subscription status changed, check it on User Advanced"
    },
    FLUSH_HOSTS: {
      AR: "Flush hosts",
      ENG: "Flush hosts",
      FR: "Flush hosts",
      TR: "Flush hosts"
    },
    DANGER_TO_PRESS: {
      AR: "Danger To press",
      ENG: "Danger To press",
      FR: "Danger To press",
      TR: "Danger To press"
    },
    PASSCODE: {
      AR: "Pass Code",
      ENG: "Pass Code",
      FR: "Pass Code",
      TR: "Pass Code"
    },
    ERROR: {
      AR: "ERROR",
      ENG: "ERROR",
      FR: "ERROR",
      TR: "ERROR"
    },
    OK: {
      AR: "OK",
      ENG: "OK",
      FR: "OK",
      TR: "OK"
    },
    REACTION_HISTORIES: {
      AR: "Histories",
      ENG: "Histories",
      FR: "Histories",
      TR: "Histories"
    },
    REACTION_ADDED: {
      AR: "Added",
      ENG: "Added",
      FR: "Added",
      TR: "Added"
    },
    REACTION_CHANGED: {
      AR: "Changed",
      ENG: "Changed",
      FR: "Changed",
      TR: "Changed"
    },
    REACTION_REMOVED: {
      AR: "Removed",
      ENG: "Removed",
      FR: "Removed",
      TR: "Removed"
    },
    REACTION_CURRENT: {
      AR: "Current",
      ENG: "Current",
      FR: "Current",
      TR: "Current"
    },
    REACTION_SUPPRESSED: {
      AR: "Sent while silent banned, the peer never saw it",
      ENG: "Sent while silent banned, the peer never saw it",
      FR: "Sent while silent banned, the peer never saw it",
      TR: "Sent while silent banned, the peer never saw it"
    },
    NO_REACTION_HISTORY: {
      AR: "No reaction history",
      ENG: "No reaction history",
      FR: "No reaction history",
      TR: "No reaction history"
    },
    REACTION_SENDER_WITH_ID: {
      AR: "Sender (%EXTRA_DATA%)",
      ENG: "Sender (%EXTRA_DATA%)",
      FR: "Sender (%EXTRA_DATA%)",
      TR: "Sender (%EXTRA_DATA%)"
    },
    REACTION_RECIPIENT_WITH_ID: {
      AR: "Recipient (%EXTRA_DATA%)",
      ENG: "Recipient (%EXTRA_DATA%)",
      FR: "Recipient (%EXTRA_DATA%)",
      TR: "Recipient (%EXTRA_DATA%)"
    },
    ET3ERROR: {
      ENG: "ET3error OR Wrong Admin ID",
      AR: "ET3error OR Wrong Admin ID",
      FR: "ET3error OR Wrong Admin ID",
      TR: "ET3error OR Wrong Admin ID"
    },
    ROUTE_NOT_DEFINED: {
      ENG: "Route Not Defined",
      AR: "Route Not Defined",
      FR: "Route Not Defined",
      TR: "Route Not Defined"
    },
    INVALID_MISSING_ID_TYPE_NUMBER: {
      ENG: "Invalid or Missing id of type number",
      AR: "Invalid or Missing id of type number",
      FR: "Invalid or Missing id of type number",
      TR: "Invalid or Missing id of type number"
    },
    INVALID_PASSWORD_NUM: {
      ENG: "Invalid Password",
      AR: "Invalid Password",
      FR: "Invalid Password",
      TR: "Invalid Password"
    },
    INVALID_USER_ID: {
      ENG: "Invalid User ID",
      AR: "Invalid User ID",
      FR: "Invalid User ID",
      TR: "Invalid User ID"
    },
    INVALID_PLATFORM: {
      ENG: "Invalid Platform",
      AR: "Invalid Platform",
      FR: "Invalid Platform",
      TR: "Invalid Platform"
    },
    INVALID_CREDENTIALS_NUM: {
      ENG: "Invalid Credentials",
      AR: "Invalid Credentials",
      FR: "Invalid Credentials",
      TR: "Invalid Credentials"
    },
    INVALID_INPUT: {
      ENG: "Invalid Input",
      AR: "Invalid Input",
      FR: "Invalid Input",
      TR: "Invalid Input"
    },
    INVALID_EVENT_TYPE: {
      ENG: "Invalid Event type",
      AR: "Invalid Event type",
      FR: "Invalid Event type",
      TR: "Invalid Event type"
    },
    INVALID_STATUS: {
      ENG: "Invalid Status",
      AR: "Invalid Status",
      FR: "Invalid Status",
      TR: "Invalid Status"
    },
    INVALID_TIME_FRAME: {
      ENG: "Invalid Time Frame",
      AR: "Invalid Time Frame",
      FR: "Invalid Time Frame",
      TR: "Invalid Time Frame"
    },
    INVALID_COUNTRY: {
      ENG: "Invalid Country",
      AR: "Invalid Country",
      FR: "Invalid Country",
      TR: "Invalid Country"
    },
    APPROVAL_DATA_NOT_FOUND: {
      ENG: "Approval Data Not Found",
      AR: "Approval Data Not Found",
      FR: "Approval Data Not Found",
      TR: "Approval Data Not Found"
    },
    REPORTS_NOT_FOUND: {
      ENG: "Reports Not Found",
      AR: "Reports Not Found",
      FR: "Reports Not Found",
      TR: "Reports Not Found"
    },
    ACTIVITIES_NOT_FOUND: {
      ENG: "Activities Not Found",
      AR: "Activities Not Found",
      FR: "Activities Not Found",
      TR: "Activities Not Found"
    },
    NO_RESULT: {
      ENG: "No Result",
      AR: "No Result",
      FR: "No Result",
      TR: "No Result"
    },
    SERVER_ERROR_SHOWING_CONTACT: {
      ENG: "Server Error, if it keeps showing contact your team leader",
      AR: "Server Error, if it keeps showing contact your team leader",
      FR: "Server Error, if it keeps showing contact your team leader",
      TR: "Server Error, if it keeps showing contact your team leader"
    },
    USER_NOT_FOUND: {
      ENG: "User Not Found",
      AR: "User Not Found",
      FR: "User Not Found",
      TR: "User Not Found"
    },
    ADMIN_ID_REQUIRED: {
      ENG: "Admin Id Required",
      AR: "Admin Id Required",
      FR: "Admin Id Required",
      TR: "Admin Id Required"
    },
    ADMIN_NOT_FOUND: {
      ENG: "Admin Not Found",
      AR: "Admin Not Found",
      FR: "Admin Not Found",
      TR: "Admin Not Found"
    },
    NO_PERMISSION: {
      ENG: "No Permission",
      AR: "No Permission",
      FR: "No Permission",
      TR: "No Permission"
    },
    DEVICE_NOT_FOUND: {
      ENG: "Device Not Found",
      AR: "Device Not Found",
      FR: "Device Not Found",
      TR: "Device Not Found"
    },
    USER_LOGIN_NOT_FOUND: {
      ENG: "User Login Not Found",
      AR: "User Login Not Found",
      FR: "User Login Not Found",
      TR: "User Login Not Found"
    },
    PAYMENTS_NOT_FOUND: {
      ENG: "Payments Not Found",
      AR: "Payments Not Found",
      FR: "Payments Not Found",
      TR: "Payments Not Found"
    },
    TRANSACTION_NOT_FOUND: {
      ENG: "Transaction Not Found",
      AR: "Transaction Not Found",
      FR: "Transaction Not Found",
      TR: "Transaction Not Found"
    },
    MESSAGES_NOT_FOUND: {
      ENG: "Messages Not Found",
      AR: "Messages Not Found",
      FR: "Messages Not Found",
      TR: "Messages Not Found"
    },
    CONVERSATION_NOT_FOUND: {
      ENG: "Conversation Not Found",
      AR: "Conversation Not Found",
      FR: "Conversation Not Found",
      TR: "Conversation Not Found"
    },
    INCORRECT_PASSWORD: {
      ENG: "Incorrect Password",
      AR: "Incorrect Password",
      FR: "Incorrect Password",
      TR: "Incorrect Password"
    },
    NO_APPROVAL_DATA: {
      ENG: "No Approval Data",
      AR: "No Approval Data",
      FR: "No Approval Data",
      TR: "No Approval Data"
    },
    SOMETHING_WRONG: {
      ENG: "Something Wrong !!!",
      AR: "Something Wrong !!!",
      FR: "Something Wrong !!!",
      TR: "Something Wrong !!!"
    },
    CANNOT_CHANGE_STATUS_TO_ACTIVE: {
      ENG: "Cannot Change Status To active",
      AR: "Cannot Change Status To active",
      FR: "Cannot Change Status To active",
      TR: "Cannot Change Status To active"
    },
    POOL_ALREADY_EMPTY: {
      ENG: "Pool already empty",
      AR: "Pool already empty",
      FR: "Pool already empty",
      TR: "Pool already empty"
    },
    WRONGKEY: {
      ENG: "Wrong Key",
      AR: "Wrong Key",
      FR: "Wrong Key",
      TR: "Wrong Key"
    },
    WRONGBODYCOUNT: {
      ENG: "Wrong Body Count",
      AR: "Wrong Body Count",
      FR: "Wrong Body Count",
      TR: "Wrong Body Count"
    },
    REFERRAL_CODE_NOT_FOUND: {
      ENG: "Referral Code Not Found",
      AR: "Referral Code Not Found",
      FR: "Referral Code Not Found",
      TR: "Referral Code Not Found"
    },
    USER_HAS_NO_REFERRAL_CODE: {
      ENG: "User Has No Referral Code",
      AR: "User Has No Referral Code",
      FR: "User Has No Referral Code",
      TR: "User Has No Referral Code"
    },
    INVALID_TOKEN: {
      ENG: "Invalid Token",
      AR: "Invalid Token",
      FR: "Invalid Token",
      TR: "Invalid Token"
    },
    INVALID_USER_NAME: {
      ENG: "Invalid User Name",
      AR: "Invalid User Name",
      FR: "Invalid User Name",
      TR: "Invalid User Name"
    },

    PLEASE_SHARE_FACEBOOK: {
      ENG: "Please share with QA :  Cannot change user status because there is an active user with same facebook id",
      AR: "Please share with QA : Cannot change user status because there is an active user with same facebook id",
      FR: "Please share with QA : Cannot change user status because there is an active user with same facebook id",
      TR: "Please share with QA : Cannot change user status because there is an active user with same facebook id"
    },

    PLEASE_SHARE_NUMBER: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same phone number",
      AR: "Please share with QA : Cannot change user status because there is an active user with same phone number",
      FR: "Please share with QA : Cannot change user status because there is an active user with same phone number",
      TR: "Please share with QA : Cannot change user status because there is an active user with same phone number"
    },
    PLEASE_SHARE_DATA_TABLE: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same email in email data table",
      AR: "Please share with QA : Cannot change user status because there is an active user with same email in email data table",
      FR: "Please share with QA : Cannot change user status because there is an active user with same email in email data table",
      TR: "Please share with QA : Cannot change user status because there is an active user with same email in email data table"
    },
    PLEASE_SHARE_USERS_TABLE: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same email in users table ",
      AR: "Please share with QA : Cannot change user status because there is an active user with same email in users table",
      FR: "Please share with QA : Cannot change user status because there is an active user with same email in users table",
      TR: "Please share with QA : Cannot change user status because there is an active user with same email in users table"
    },
    PLEASE_SHARE_APPLE_ID: {
      ENG: "Please share with QA : Cannot change user status because there is an active user with same apple id ",
      AR: "Please share with QA : Cannot change user status because there is an active user with same apple id",
      FR: "Please share with QA : Cannot change user status because there is an active user with same apple id",
      TR: "Please share with QA : Cannot change user status because there is an active user with same apple id"
    },
    MY_AUDITING_PERFORMANCE: {
      ENG: "My Auditing Performance",
      AR: "My Auditing Performance",
      FR: "My Auditing Performance",
      TR: "My Auditing Performance"
    },
    MY_CSR_MISTAKES: {
      ENG: "My CSR Mistakes",
      AR: "My CSR Mistakes",
      FR: "My CSR Mistakes",
      TR: "My CSR Mistakes"
    },
    MY_AUDITING_MISTAKES: {
      ENG: "My Auditing Mistakes",
      AR: "My Auditing Mistakes",
      FR: "My Auditing Mistakes",
      TR: "My Auditing Mistakes"
    },
    WATCH_ALERTS: {
      AR: "Watch Alerts",
      ENG: "Watch Alerts",
      FR: "Watch Alerts",
      TR: "Watch Alerts"
    },
    WATCH_ALERT_DASHBOARD: {
      AR: "Watch Alert Dashboard",
      ENG: "Watch Alert Dashboard",
      FR: "Watch Alert Dashboard",
      TR: "Watch Alert Dashboard"
    },
    USERS: {
      AR: "Users",
      ENG: "Users",
      FR: "Users",
      TR: "Users"
    },
    USERS_LOGIN: {
      AR: "Users LogIn",
      ENG: "Users LogIn",
      FR: "Users LogIn",
      TR: "Users LogIn"
    },
    USERS_PAYMENTS: {
      AR: "Users Payments",
      ENG: "Users Payments",
      FR: "Users Payments",
      TR: "Users Payments"
    },
    WEB_ANDROID_PAYMENTS: {
      AR: "Web Android Payments",
      ENG: "Web Android Payments",
      FR: "Web Android Payments",
      TR: "Web Android Payments"
    },
    WEB_IOS_PAYMENTS: {
      AR: "Web IOS Payments",
      ENG: "Web IOS Payments",
      FR: "Web IOS Payments",
      TR: "Web IOS Payments"
    },
    ADVANCED: {
      AR: "Advanced",
      ENG: "Advanced",
      FR: "Advanced",
      TR: "Advanced"
    },
    CONVERSATIONS: {
      AR: "Conversations",
      ENG: "Conversations",
      FR: "Conversations",
      TR: "Conversations"
    },
    EVENTS: {
      AR: "Events",
      ENG: "Events",
      FR: "Events",
      TR: "Events"
    },
    LOGIN: {
      AR: "Login",
      ENG: "Login",
      FR: "Login",
      TR: "Login"
    },
    MESSAGES: {
      AR: "Messages",
      ENG: "Messages",
      FR: "Messages",
      TR: "Messages"
    },
    MEESAGE_ID: {
      AR: "Message Id",
      ENG: "Message Id",
      FR: "Message Id",
      TR: "Message Id"
    },
    PAYMENTS: {
      AR: "Payments",
      ENG: "Payments",
      FR: "Payments",
      TR: "Payments"
    },
    AUDIT: {
      AR: "Audit",
      ENG: "Audit",
      FR: "Audit",
      TR: "Audit"
    },
    AUDITED_EVENTS: {
      AR: "Audited Events",
      ENG: "Audited Events",
      FR: "Audited Events",
      TR: "Audited Events"
    },
    OTHER_CSRS_PERFORMANCE: {
      AR: "Other CSRs Performance",
      ENG: "Other CSRs Performance",
      FR: "Other CSRs Performance",
      TR: "Other CSRs Performance"
    },
    EVENTS_CHART: {
      AR: "Events Chart",
      ENG: "Events Chart",
      FR: "Events Chart",
      TR: "Events Chart"
    },
    PERMISSION: {
      AR: "Permission",
      ENG: "Permission",
      FR: " Permission",
      TR: "Permission"
    },
    SUPERVISED_EVENTS: {
      AR: "Supervised Events",
      ENG: "Supervised Events",
      FR: " Supervised Events",
      TR: "Supervised Events"
    },
    RESET_PASSWORD: {
      AR: "Reset Password",
      ENG: "Reset Password",
      FR: "Reset Password",
      TR: "Reset Password"
    },
    RESET_ADMIN_PASSWORDS: {
      AR: "Reset Admin Passwords",
      ENG: "Reset Admin Passwords",
      FR: "Reset Admin Passwords",
      TR: "Reset Admin Passwords"
    },
    NEW_GENERATED_PASSWORD: {
      AR: "New Password: %EXTRA_DATA%",
      ENG: "New Password: %EXTRA_DATA%",
      FR: "New Password: %EXTRA_DATA%",
      TR: "New Password: %EXTRA_DATA%"
    },

    FLUSH: {
      AR: "Flush",
      ENG: "Flush",
      FR: " Flush",
      TR: "Flush"
    },
    ALARMS: {
      AR: "Alarms",
      ENG: "Alarms",
      FR: " Alarms",
      TR: "Alarms"
    },
    PROMO_CODE: {
      AR: "Promo Code",
      ENG: "Promo Code",
      FR: " Promo Code",
      TR: "Promo Code"
    },
    PROMO_CODE_DESCRIPTION: {
      AR: "Code Description",
      ENG: "Code Description",
      FR: "Code Description",
      TR: "Code Description"
    },
    PROMO_CODE_START_DATE: {
      AR: "Code Start Date",
      ENG: "Code Start Date",
      FR: "Code Start Date",
      TR: "Code Start Date"
    },
    PROMO_CODE_EXPIRY_DATE: {
      AR: "Code Expiry Date",
      ENG: "Code Expiry Date",
      FR: "Code Expiry Date",
      TR: "Code Expiry Date"
    },
    PROMO_CODE_ACTIVE: {
      AR: "Code Is Active",
      ENG: "Code Is Active",
      FR: "Code Is Active",
      TR: "Code Is Active"
    },
    PROMO_CODE_NUMBER_OF_CODES: {
      AR: "Number of Promo Codes",
      ENG: "Number of Promo Codes",
      FR: "Number of Promo Codes",
      TR: "Number of Promo Codes"
    },
    PROMO_CODE_VIP_MAX_USAGE: {
      AR: "Code Max Usage",
      ENG: "Code Max Usage",
      FR: "Code Max Usage",
      TR: "Code Max Usage"
    },
    PROMO_CODE_REWARD_IN_HOURS: {
      AR: "Reward In Hours",
      ENG: "Reward In Hours",
      FR: "Reward In Hours",
      TR: "Reward In Hours"
    },
    PROMO_CODE_NATIONALITY: {
      AR: "Code For Nationalities",
      ENG: "Code For Nationalities",
      FR: "Code For Nationalities",
      TR: "Code For Nationalities"
    },
    GENERATE: {
      AR: "Generate",
      ENG: "Generate",
      FR: "Generate",
      TR: "Generate"
    },
    PROMO_CODE_GENERATED_SUCCESSFULLY: {
      AR: "This promocode has been generated - Promocode Key %EXTRA_DATA%",
      ENG: "This promocode has been generated - Promocode Key %EXTRA_DATA%",
      FR: "This promocode has been generated - Promocode Key %EXTRA_DATA%",
      TR: "This promocode has been generated - Promocode Key %EXTRA_DATA%"
    },
    PROMO_CODES: {
      AR: "Promo codes ",
      ENG: "Promo codes ",
      FR: "Promo codes ",
      TR: "Promo codes "
    },
    PROMO_CODE_ID: {
      AR: "Promo code ID ",
      ENG: "Promo code ID",
      FR: "Promo code ID ",
      TR: "Promo code ID "
    },
    USER_PROMO_CODE_USAGE_TABLE: {
      ENG: "User Promo Code Usage Table",
      AR: "User Promo Code Usage Table",
      FR: "User Promo Code Usage Table",
      TR: "User Promo Code Usage Table"
    },
    PROMO_CODE_USAGE: {
      ENG: "Promo Code Usage",
      AR: "Promo Code Usage",
      FR: "Promo Code Usage",
      TR: "Promo Code Usage"
    },
    COMMUNICATIONS_PROMO_CODE_GENERATOR: {
      ENG: "Generate Promo Code ",
      AR: "Generate Promo Code ",
      FR: "Generate Promo Code ",
      TR: "Generate Promo Code "
    },
    AUDITOR_WEB_PAYMENTS: {
      AR: "Web Payments",
      ENG: "Web Payments",
      FR: "Web Payments",
      TR: "Web Payments"
    },
    SHOW_WEB_PAYMENTS: {
      AR: "Show Web Payments",
      ENG: "Show Web Payments",
      FR: "Show Web Payments",
      TR: "Show Web Payments"
    },
    ALL_PROMO_CODES: {
      ENG: "All Promo Codes ",
      AR: "All Promo Codes",
      FR: "All Promo Codes ",
      TR: "All Promo Codes "
    },
    UPDATE_PROMO_CODE: {
      ENG: "Update Promo Codes ",
      AR: "Update Promo Codes",
      FR: "Update Promo Codes ",
      TR: "Update Promo Codes "
    },
    PROMO_CODE_PAID: {
      ENG: "Code For Paid Users ",
      AR: "Code For Paid Users",
      FR: "Code For Paid Users ",
      TR: "Code For Paid Users "
    },
    PROMO_CODE_UPDATED_SUCCESSFULLY: {
      ENG: "Promo Code Updated Successfully ",
      AR: "Promo Code Updated Successfully",
      FR: "Promo Code Updated Successfully ",
      TR: "Promo Code Updated Successfully "
    },
    PROMO_STATUS_NOT_UPDATED_SUCCESSFULLY: {
      ENG: "The Current Status of the Code is same , change the status to complete ",
      AR: "The Current Status of the Code is same , change the status to complete",
      FR: "The Current Status of the Code is same , change the status to complete ",
      TR: "The Current Status of the Code is same , change the status to complete "
    },
    PROMO_CODE_IS_NO_UPDATED: {
      ENG: "Promo Code is not updated check you add the correct promocode and its correct id",
      AR: "Promo Code is not updated check you add the correct promocode and its correct id",
      FR: "Promo Code is not updated check you add the correct promocode and its correct id",
      TR: "Promo Code is not updated check you add the correct promocode and its correct id"
    },

    FLAGGED_CONNECTION: {
      ENG: "Flagged Connections",
      AR: "Flagged Connections",
      FR: "Flagged Connections",
      TR: "Flagged Connections"
    },

    FLAGGED_CONNECTION_APP: {
      ENG: "App Flagged Connections",
      AR: "App Flagged Connections",
      FR: "App Flagged Connections",
      TR: "App Flagged Connections"
    },
    FLAGGED_CONNECTION_WEB: {
      ENG: "Web Flagged Connections",
      AR: "Web Flagged Connections",
      FR: "Web Flagged Connections",
      TR: "Web Flagged Connections"
    },
    FLAGGED_CONNECTION_ADMIN: {
      ENG: "Admin Flagged Connections",
      AR: "Admin Flagged Connections",
      FR: "Admin Flagged Connections",
      TR: "Admin Flagged Connections"
    },
    ON_CALL_TEAM: {
      ENG: "On Call Team",
      AR: "On Call Team",
      FR: "On Call Team",
      TR: "On Call Team"
    },
    USER_ID_PICTURE_REJECT: {
      ENG: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please ",
      AR: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please ",
      FR: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please ",
      TR: "Picture is not rejected for userId : %EXTRA_DATA% Do it manually please "
    },
    VIP_DETAILS: {
      ENG: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`,
      AR: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`,
      FR: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`,
      TR: `id: %EXTRA_DATA_0%\n\npackageID: %EXTRA_DATA_1%\n\ncreatedOn: %EXTRA_DATA_2%\n\nexpiryDate: %EXTRA_DATA_3%\n\nstatus: %EXTRA_DATA_4%\n\nhasPending: %EXTRA_DATA_5%\n\npendingPackage: %EXTRA_DATA_6%\n\npendingReason: %EXTRA_DATA_7%\n\n`
    },
    RATE_LIMIT: {
      ENG: "Rate Limit",
      AR: "Rate Limit",
      FR: "Rate Limit",
      TR: "Rate Limit"
    },
    ON_ALERT: {
      ENG: "Alert Mode",
      AR: "Alert Mode",
      FR: "Alert Mode",
      TR: "Alert Mode"
    },
    EMPTY_TBW_REASONS_DATA: {
      ENG: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!",
      AR: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!",
      FR: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!",
      TR: "Something Went Wrong With Your Internet Service. Please Repeat your process again.Thank You!"
    },
    PROMOCODE_REWARD_IN_HOURS: {
      ENG: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`,
      AR: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`,
      FR: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`,
      TR: `Promocode  in hours should maximum be ${MAX_PROMOCODE_REWARD_IN_HOURS}`
    },
    PROMOCODE_NOT_SUPPORTED_FOR_GENDER: {
      ENG: `Reward doesn't exist for gender`,
      AR: `Reward doesn't exist for gender`,
      FR: `Reward doesn't exist for gender`,
      TR: `Reward doesn't exist for gender`
    },
    PROMOCODE_NUMBER_OF_CODES_MAX: {
      ENG: `Number of Promo Codes should maximum be ${MAX_PROMOCODE_GENERATION_COUNT}`,
      AR: `Number of Promo Codes should maximum be ${MAX_PROMOCODE_GENERATION_COUNT}`,
      FR: `Number of Promo Codes should maximum be ${MAX_PROMOCODE_GENERATION_COUNT}`,
      TR: `Number of Promo Codes should maximum be ${MAX_PROMOCODE_GENERATION_COUNT}`
    },
    FLUSH_HOST_ALERT: {
      ENG: "make sure that email, password and passcode are set correctly",
      FR: "assurez-vous que l’adresse e-mail, le mot de passe et le mot de passe sont correctement définis",
      AR: "تأكد من تعيين البريد الإلكتروني وكلمة المرور ورمز المرور بشكل صحيح",
      TR: "e-posta, parola ve geçiş kodunun doğru ayarlandığından emin olun"
    },
    USER_ALBUM_PICTURES: {
      ENG: "User Pictures Album",
      AR: "User Pictures Album",
      FR: "User Pictures Album",
      TR: "User Pictures Album"
    },

    USERS_DATA: {
      ENG: "Users Data",
      AR: "Users Data",
      FR: "Users Data",
      TR: "Users Data"
    },
    USERS_PURCHASES_AND_SUBSCRIPTIONS: {
      ENG: "Users Purchase and Subscriptions",
      AR: "Users Purchase and Subscriptions",
      FR: "Users Purchase and Subscriptions",
      TR: "Users Purchase and Subscriptions"
    },
    MY_CSR_PREV_ACTIONS: {
      ENG: "My CSR Prev Actions",
      AR: "My CSR Prev Actions",
      FR: "My CSR Prev Actions",
      TR: "My CSR Prev Actions"
    },
    USER_BREACHES_TABLE: {
      ENG: "User Breaches Tables",
      AR: "User Breaches Tables",
      FR: "User Breaches Tables",
      TR: "User Breaches Tables"
    },
    TB_DEACTIVATED_USER: {
      ENG: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!",
      AR: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!",
      FR: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!",
      TR: "A Deactivated User can not be temporary banned. So the status will remain as Deactivated but the TB event will be saved in the user events. Thank You!"
    },
    USER_NAME: {
      ENG: "User Name",
      AR: "User Name",
      FR: "User Name",
      TR: "User Name"
    },
    NATIONALITY: {
      ENG: "Nationality",
      AR: "Nationality",
      FR: "Nationality",
      TR: "Nationality"
    },
    COUNTRY_OF_RESIDENCE: {
      ENG: "Country of residence",
      AR: "Country of residence",
      FR: "Country of residence",
      TR: "Country of residence"
    },
    AGE: {
      ENG: "Age",
      AR: "Age",
      FR: "Age",
      TR: "Age"
    },
    HEIGHT: {
      ENG: "Height",
      AR: "Height",
      FR: "Height",
      TR: "Height"
    },
    WEIGHT: {
      ENG: "Weight",
      AR: "Weight",
      FR: "Weight",
      TR: "Weight"
    },
    USER_SEARCH_TYPE_REQUIRED: {
      ENG: "Wrong User Search Type",
      AR: "Wrong User Search Type",
      FR: "Wrong User Search Type",
      TR: "Wrong User Search Type"
    },
    USER_ALL_COMMENTS: {
      ENG: "All Comments :",
      AR: "All Comments :",
      FR: "All Comments :",
      TR: "All Comments :"
    },
    ADD_COMMENTS_POPUP_TEXT: {
      ENG: "Are you sure you want to leave this comment?",
      AR: "Are you sure you want to leave this comment?",
      FR: "Are you sure you want to leave this comment?",
      TR: "Are you sure you want to leave this comment?"
    },
    ADD_RESET_ACCOUNT_POPUP_TEXT: {
      ENG: "Are you sure you want to reset your account?",
      AR: "Are you sure you want to reset your account?",
      TR: "Are you sure you want to reset your account?",
      FR: "Are you sure you want to reset your account?"
    },
    ADD_COMMENT: {
      ENG: "Add Comment",
      AR: "Add Comment",
      FR: "Add Comment",
      TR: "Add Comment"
    },
    EMPTY_COMMENT: {
      ENG: "Empty Comment",
      AR: "Empty Comment",
      FR: "Empty Comment",
      TR: "Empty Comment"
    },

    UNDER_CSR_INVESTIGATION_STATUS: {
      ENG: "Under CSR Investigation",
      AR: "Under CSR Investigation",
      FR: "Under CSR Investigation",
      TR: "Under CSR Investigation"
    },
    INVESTIGATION_CASES_NOT_FOUND: {
      ENG: "Investigation Cases not found!",
      AR: "Investigation Cases not found!",
      FR: "Investigation Cases not found!",
      TR: "Investigation Cases not found!"
    },
    DESCRIPTION_ABOUT_ME: {
      ENG: "About Me",
      AR: "About Me",
      FR: "About Me",
      TR: "About Me"
    },
    DESCRIPTION_ABOUT_MY_PARTNER: {
      ENG: "About my Partner",
      AR: "About my Partner",
      FR: "About my Partner",
      TR: "About my Partner"
    },

    COMMUNICATIONS: {
      ENG: "Communications",
      AR: "Communications",
      FR: "Communications",
      TR: "Communications"
    },
    VIEW_ACCOUNTS_DELETION_DATA: {
      ENG: "View Accounts Deletion data",
      AR: "View Accounts Deletion data",
      FR: "View Accounts Deletion data",
      TR: "View Accounts Deletion data"
    },
    ACCOUNT_DELETION_HELPER_TEXT: {
      ENG: "This page displays data on the users deleted accounts for analysis.",
      AR: "This page displays data on the users deleted accounts for analysis.",
      FR: "This page displays data on the users deleted accounts for analysis.",
      TR: "This page displays data on the users deleted accounts for analysis."
    },
    ACCOUNTS_DELETION_DATA: {
      ENG: "Accounts Deletion data",
      AR: "Accounts Deletion data",
      FR: "Accounts Deletion data",
      TR: "Accounts Deletion data"
    },
    COMMUNICATIONS_ACCOUNTS_DELETION: {
      ENG: "Accounts Deletion",
      AR: "Accounts Deletion",
      FR: "Accounts Deletion",
      TR: "Accounts Deletion"
    },
    FOUND_PARTNER_OUTSIDE_ET3ARRAF: {
      ENG: "Found my soulmate out of the app",
      AR: "Found my soulmate out of the app",
      FR: "Found my soulmate out of the app",
      TR: "Found my soulmate out of the app"
    },
    NOT_AS_EXPECTED: {
      ENG: "Different expectations",
      AR: "Different expectations",
      FR: "Different expectations",
      TR: "Different expectations"
    },
    OTHER_REASONS: {
      ENG: "Other reasons",
      AR: "Other reasons",
      FR: "Other reasons",
      TR: "Other reasons"
    },
    ER3ARRAF_IS_HARD_TO_USE: {
      ENG: "Difficulty of use",
      AR: "Difficulty of use",
      FR: "Difficulty of use",
      TR: "Difficulty of use"
    },
    NOT_ABLE_TO_FIND_PARTNER: {
      ENG: "I didn't find good matches",
      AR: "I didn't find good matches",
      FR: "I didn't find good matches",
      TR: "I didn't find good matches"
    },
    FOUND_PARTNER_THROUGH_ET3ARRAF: {
      ENG: "Found my soulmate on the app",
      AR: "Found my soulmate on the app",
      FR: "Found my soulmate on the app",
      TR: "Found my soulmate on the app"
    },
    ACCOUNTS_DELETION_DATA_NOT_FOUND: {
      ENG: "Deleted Accounts Data has been not found!",
      AR: "Deleted Accounts Data has been not found!",
      FR: "Deleted Accounts Data has been not found!",
      TR: "Deleted Accounts Data has been not found!"
    },
    USER_ALREADY_UNDER_CSR_INVESTIGATION: {
      ENG: "User Already Under Csr Investigation!",
      AR: "User Already Under Csr Investigation!",
      FR: "User Already Under Csr Investigation!",
      TR: "User Already Under Csr Investigation!"
    },
    REPORT_NOT_FOUND: {
      ENG: "Report Not Found, Please press 'Get Reports'",
      AR: "Report Not Found, Please press 'Get Reports'",
      FR: "Report Not Found, Please press 'Get Reports'",
      TR: "Report Not Found, Please press 'Get Reports'"
    },
    USER_STATUS_DATE: {
      ENG: "user status Date",
      AR: "user status Date",
      FR: "user status Date",
      TR: "user status Date"
    },
    USER_EMAIL_SUBSCRIPTION: {
      ENG: "user email subscription status",
      AR: "user email subscription status",
      FR: "user email subscription status",
      TR: "user email subscription status"
    },
    QA: {
      ENG: "QA",
      AR: "QA",
      FR: "QA",
      TR: "QA"
    },
    USER_STATUS: {
      ENG: "User Status :",
      AR: "User Status :",
      FR: "User Status :",
      TR: "User Status :"
    },
    QA_NEW_STATUS_DATE: {
      ENG: "Status New Date",
      AR: "Status New Date",
      FR: "Status New Date",
      TR: "Status New Date"
    },
    QA_CHANGE_STATUS_DATE: {
      ENG: "Change Date",
      AR: "Change Date",
      FR: "Change Date",
      TR: "Change Date"
    },
    SUBSCRIBE: {
      ENG: "Subscribe",
      AR: "Subscribe",
      FR: "Subscribe",
      TR: "Subscribe"
    },
    UNSUBSCRIBE: {
      ENG: "Unsubscribe",
      AR: "Unsubscribe",
      FR: "Unsubscribe",
      TR: "Unsubscribe"
    },
    UPDATING_TO_VERSION: {
      ENG: "Updating to version ",
      AR: "Updating to version ",
      FR: "Updating to version ",
      TR: "Updating to version "
    },

    EXPORT_TO_CSV_FILE: {
      ENG: "CSV",
      AR: "CSV",
      FR: "CSV",
      TR: "CSV"
    },

    PEER_DESCRIPTION_ACTION_ALREADY_DONE: {
      ENG: "Action On Peer Description Already Done, Please press 'Get'",
      AR: "Action On Peer Description Already Done, Please press 'Get'",
      FR: "Action On Peer Description Already Done, Please press 'Get'",
      TR: "Action On Peer Description Already Done, Please press 'Get'"
    },
    PICTURE_ACTION_ALREADY_DONE: {
      ENG: "Action On Album Picture Already Done, Please press 'Get'",
      AR: "Action On Album Picture Already Done, Please press 'Get'",
      FR: "Action On Album Picture Already Done, Please press 'Get'",
      TR: "Action On Album Picture Already Done, Please press 'Get'"
    },

    DESCRIPTION_ACTION_ALREADY_DONE: {
      ENG: "Action On Description Already Done, Please press 'Get'",
      AR: "Action On Description Already Done, Please press 'Get'",
      FR: "Action On Description Already Done, Please press 'Get'",
      TR: "Action On Description Already Done, Please press 'Get'"
    },
    TURN_OFF_ALARMS: {
      ENG: "Turn Off Alarms",
      AR: "Turn Off Alarms",
      FR: "Turn Off Alarms",
      TR: "Turn Off Alarms"
    },
    TURN_OFF_FEATURES: {
      ENG: "Turn Off Features",
      AR: "Turn Off Features",
      FR: "Turn Off Features",
      TR: "Turn Off Features"
    },
    FEATURES: {
      ENG: "Features",
      AR: "Features",
      FR: "Features",
      TR: "Features"
    },
    KHATTABAT_CAPACITY: {
      ENG: "Khattabat capacity",
      AR: "Khattabat capacity",
      FR: "Khattabat capacity",
      TR: "Khattabat capacity"
    },
    FEATURE_OFF: {
      ENG: "Turn OFF",
      AR: "Turn OFF",
      FR: "Turn OFF",
      TR: "Turn OFF"
    },
    FEATURE_ON: {
      ENG: "Turn ON",
      AR: "Turn ON",
      FR: "Turn ON",
      TR: "Turn ON"
    },

    ALARMS_OFF: {
      AR: "Alarm Off",
      ENG: "Alarm Off",
      FR: "Alarm Off",
      TR: "Alarm Off"
    },
    ALARMS_NOT_FOUND: {
      AR: "Alarms Not Found",
      ENG: "Alarms Not Found",
      FR: "Alarms Not Found",
      TR: "Alarms Not Found"
    },

    MESSAGE_TYPE: {
      ENG: "Message Type",
      AR: "Message Type",
      FR: "Message Type",
      TR: "Message Type"
    },
    LIMIT_BY_REPORTED: {
      ENG: "Limit by Reported",
      AR: "Limit by Reported",
      FR: "Limit by Reported",
      TR: "Limit by Reported"
    },
    PROMO_CODE_KEY: {
      ENG: "Promo Code Key",
      AR: "Promo Code Key",
      FR: "Promo Code Key",
      TR: "Promo Code Key"
    },
    INVALID_PROMO_CODE_KEY: {
      ENG: "Invalid Promo Code Key ",
      AR: "Invalid Promo Code Key",
      FR: "Invalid Promo Code Key ",
      TR: "Invalid Promo Code Key "
    },
    PROMO_CODE_ALREADY_EXISTS: {
      ENG: "Promo Code Already Found",
      AR: "Promo Code Already Found",
      FR: "Promo Code Already Found",
      TR: "Promo Code Already Found"
    },
    PROMO_CODE_GENERATION_HELPER_TEXT: {
      ENG: "This page allows promo code generation by communication department, where the generation conditions are (should be unique / maximum 6 characters / characters should be only alpha and numeric characters).",
      AR: "This page allows promo code generation by communication department, where the generation conditions are (should be unique / maximum 6 characters / characters should be only alpha and numeric characters).",
      FR: "This page allows promo code generation by communication department, where the generation conditions are (should be unique / maximum 6 characters / characters should be only alpha and numeric characters).",
      TR: "This page allows promo code generation by communication department, where the generation conditions are (should be unique / maximum 6 characters / characters should be only alpha and numeric characters)."
    },
    CHANGE_EMAIL_SUBSCRIPTION: {
      ENG: "Change Email Subscription",
      AR: "Change Email Subscription",
      FR: "Change Email Subscription",
      TR: "Change Email Subscription"
    },
    AUDIT_EVENTS_POOL_TABLE: {
      AR: "Audit Events Pool Table",
      ENG: "Audit Events Pool Table",
      FR: "Audit Events Pool Table",
      TR: "Audit Events Pool Table"
    },
    UPDATE_ON_CALL_TABLE: {
      AR: "Update On Call",
      ENG: "Update On Call",
      FR: "Update On Call",
      TR: "Update On Call"
    },

    OBTAIN_IOS_RECEIPT_TOKENS: {
      ENG: "Obtain Ios Receipt Tokens",
      AR: "Obtain Ios Receipt Tokens",
      FR: "Obtain Ios Receipt Tokens",
      TR: "Obtain Ios Receipt Tokens"
    },
    IOS_RECEIPT_TOKEN_DATA: {
      ENG: "Ios Receipt Token Data",
      AR: "Ios Receipt Token Data",
      FR: "Ios Receipt Token Data",
      TR: "Ios Receipt Token Data"
    },
    BLOCKED_REQUESTS: {
      ENG: "Blocked Requests",
      AR: "Blocked Requests",
      FR: "Blocked Requests",
      TR: "Blocked Requests"
    },
    BLOCKED_REQUESTS_HISTORY: {
      ENG: "Blocked Requests History",
      AR: "Blocked Requests History",
      FR: "Blocked Requests History",
      TR: "Blocked Requests History"
    },
    BLOCKED_REQUESTS_DETAILS: {
      ENG: "Blocked Requests Details",
      AR: "Blocked Requests Details",
      FR: "Blocked Requests Details",
      TR: "Blocked Requests Details"
    },
    SAFE: {
      ENG: "Safe",
      AR: "Safe",
      FR: "Safe",
      TR: "Safe"
    },
    DESCRIPTION_CHANGED: {
      ENG: "Description Changed From user on APP, please press Get",
      AR: "Description Changed From user on APP, please press Get",
      FR: "Description Changed From user on APP, please press Get",
      TR: "Description Changed From user on APP, please press Get"
    },
    INVESTIGATION_CASE_ALREADY_RESOLVED: {
      ENG: "Investigation Case is already resolved or on other admin pool",
      AR: "Investigation Case is already resolved or on other admin pool",
      FR: "Investigation Case is already resolved or on other admin pool",
      TR: "Investigation Case is already resolved or on other admin pool"
    },
    INVESTIGATION_CASE_EXITS_IN_SOME_POOL: {
      ENG: "The investigation case is already in a pool",
      AR: "The investigation case is already in a pool",
      FR: "The investigation case is already in a pool",
      TR: "The investigation case is already in a pool"
    },
    REPORT_CASE_EXISTS_IN_SOME_POOL: {
      ENG: "The report case is already in a pool",
      AR: "The report case is already in a pool",
      FR: "The report case is already in a pool",
      TR: "The report case is already in a pool"
    },
    REPORT_CASES_ALREADY_RESOLVED: {
      ENG: "Report Cases are already resolved",
      AR: "Report Cases are already resolved",
      FR: "Report Cases are already resolved",
      TR: "Report Cases are already resolved"
    },
    USER_SHOULD_BE_VERIFIED: {
      ENG: "User needs to verify their account",
      AR: "User needs to verify their account",
      FR: "User needs to verify their account",
      TR: "User needs to verify their account"
    },
    SOCIAL_MEDIA_ACCOUNT: {
      ENG: "Social Media:",
      AR: "Social Media:",
      FR: "Social Media:",
      TR: "Social Media:"
    },
    BAD_WORDS: {
      ENG: "Bad Words:",
      AR: "Bad Words:",
      FR: "Bad Words:",
      TR: "Bad Words:"
    },
    FLAGGED_DESCRIPTIONS: {
      ENG: "Flagged Descriptions",
      AR: "Flagged Descriptions",
      FR: "Flagged Descriptions",
      TR: "Flagged Descriptions"
    },
    GET_FLAGGED_DESCRIPTIONS: {
      ENG: "Get flagged descriptions",
      AR: "Get flagged descriptions",
      FR: "Get flagged descriptions",
      TR: "Get flagged descriptions"
    },
    ADD_FLAGGED_DESCRIPTION: {
      ENG: "Add flagged descriptions",
      AR: "Add flagged descriptions",
      FR: "Add flagged descriptions",
      TR: "Add flagged descriptions"
    },
    GET_USER_BANNED: {
      ENG: "Get user banned",
      AR: "Get user banned",
      FR: "Get user banned",
      TR: "Get user banned"
    },
    FLAGGED_DESCRIPTION_EMPTY_TABLE: {
      ENG: "Flagged Description Table Is Empty",
      AR: "Flagged Description Table Is Empty",
      FR: "Flagged Description Table Is Empty",
      TR: "Flagged Description Table Is Empty"
    },
    NO_BANNED_USERS: {
      ENG: "No Banned Users",
      AR: "No Banned Users",
      FR: "No Banned Users",
      TR: "No Banned Users"
    },
    FLAGGED_DESCRIPTION: {
      ENG: "Flagged Descriptions Table",
      AR: "Flagged Descriptions Table",
      FR: "Flagged Descriptions Table",
      TR: "Flagged Descriptions Table"
    },
    BANNED_USERS: {
      ENG: "Banned Users Table",
      AR: "Banned Users Table",
      FR: "Banned Users Table",
      TR: "Banned Users Table"
    },
    SUBMIT: {
      ENG: "Submit",
      AR: "Submit",
      FR: "Submit",
      TR: "Submit"
    },
    ADD_DESCRIPTION: {
      ENG: "Add Input Description",
      AR: "Add Input Description",
      FR: "Add Input Description",
      TR: "Add Input Description"
    },
    DESCRIPTION_ADDED: {
      ENG: "Description Added",
      AR: "Description Added",
      FR: "Description Added",
      TR: "Description Added"
    },
    DESCRIPTION_DELETED: {
      ENG: "Description Deleted",
      AR: "Description Deleted",
      FR: "Description Deleted",
      TR: "Description Deleted"
    },
    ADD_FLAGGED_DESCRIPTION_INVALID_INPUT: {
      ENG: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100).",
      AR: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100).",
      FR: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100).",
      TR: "Description should be between (25 and 250 characters), and percentage value should be between (70 >= && <= 100)."
    },
    PLEASE_CONTACT_SE: {
      ENG: "Please contact SE department",
      AR: "Please contact SE department",
      FR: "Please contact SE department",
      TR: "Please contact SE department"
    },
    TOTAL_USERS: {
      ENG: "Total Users",
      AR: "Total Users",
      FR: "Total Users",
      TR: "Total Users"
    },
    TOTAL_CONVERSATIONS: {
      ENG: "Total Conversations",
      AR: "Total Conversations",
      FR: "Total Conversations",
      TR: "Total Conversations"
    },
    NEW_CONVERSATIONS: {
      ENG: "New Conversations",
      AR: "New Conversations",
      FR: "New Conversations",
      TR: "New Conversations"
    },
    TOTAL_MESSAGES: {
      ENG: "Total Messages",
      AR: "Total Messages",
      TR: "Total Messages",
      FR: "Total Messages"
    },
    NEW_MESSAGES: {
      ENG: "New Messages",
      AR: "New Messages",
      FR: "New Messages",
      TR: "New Messages"
    },
    SALES_USD: {
      ENG: "Sales (USD)",
      AR: "Sales (USD)",
      FR: "Sales (USD)",
      TR: "Sales (USD)"
    },
    MARKETING_EXPENSES_USD: {
      ENG: "Marketing Expenses (USD)",
      AR: "Marketing Expenses (USD)",
      FR: "Marketing Expenses (USD)",
      TR: "Marketing Expenses (USD)"
    },
    NO_CLEAN_POOL_DATA: {
      AR: "No pool was found, already cleaned",
      ENG: "No pool was found, already cleaned",
      FR: "No pool was found, already cleaned",
      TR: "No pool was found, already cleaned"
    },
    NO_MORE_MESSAGES: {
      AR: "No more messages",
      ENG: "No more messages",
      FR: "No more messages",
      TR: "No more messages"
    },
    KHATTABA_NAME: {
      AR: "Name ",
      ENG: "Name ",
      FR: "Name ",
      TR: "Name "
    },
    KHATTABA_CATEGORY: {
      AR: "Category ",
      ENG: "Category ",
      FR: "Category ",
      TR: "Category "
    },
    KHATTABA_PRICE: {
      AR: "Price ",
      ENG: "Price ",
      FR: "Price ",
      TR: "Price "
    },
    KHATTABA_DESCRIPTION: {
      AR: "Description ",
      ENG: "Description ",
      FR: "Description ",
      TR: "Description "
    },
    KHATTABA_LANGUAGE: {
      AR: "Language ",
      ENG: "Language ",
      FR: "Language ",
      TR: "Language "
    },
    KHATTABA_AGE: {
      AR: "Age ",
      ENG: "Age ",
      FR: "Age ",
      TR: "Age "
    },
    KHATTABA_LOCATION: {
      AR: "Location",
      ENG: "Location",
      FR: "Location",
      TR: "Location"
    },
    KHATTABA_CURRENCY: {
      AR: "Currency",
      ENG: "Currency",
      FR: "Currency",
      TR: "Currency"
    },
    LOCATION_FIELD: {
      AR: "My Location Field",
      ENG: "My Location Field",
      FR: "My Location Field",
      TR: "My Location Field"
    },
    CURRENCY_I_WORK_WITH: {
      AR: "Currency I Work With",
      ENG: "Currency I Work With",
      FR: "Currency I Work With",
      TR: "Currency I Work With"
    },
    MY_ID_TO_CONNECT: {
      AR: "My ID To Connect",
      ENG: "My ID To Connect",
      FR: "My ID To Connect",
      TR: "My ID To Connect"
    },
    "PRICE/EACH PRIDE": {
      AR: "My Price/Each Pride",
      ENG: "My Price/Each Pride",
      FR: "My Price/Each Pride",
      TR: "My Price/Each Pride"
    },
    MORE_INFO_KHATTABAT: {
      AR: "Click here for more info",
      ENG: "Click here for more info",
      FR: "Click here for more info",
      TR: "Click here for more info"
    },
    HELLO_MESSAGE: {
      ENG: "Hello %EXTRA_DATA_0% 👋🏻 this is %EXTRA_DATA_1% Also Known As Em Noura, I am %EXTRA_DATA_2% years old and Currently based in Lebanon %EXTRA_DATA_3%. I'm here to connect you with our beautiful Prides that are searching for their dream man and help you find your future partner and here's a little description about me %EXTRA_DATA_4% and I talk only in %EXTRA_DATA_5% Language",
      AR: "مرحبا %EXTRA_DATA_0% 👋🏻 هذا %EXTRA_DATA_1% المعروفة أيضًا باسم إم نورا، عمري %EXTRA_DATA_2% عامًا وأنا مقيمة حاليًا في لبنان %EXTRA_DATA_3%. أنا هنا لربطك بالعرائس الجميلات اللواتي يبحثن عن رجل أحلامهن ومساعدتك في العثور على شريكك المستقبلي وهنا وصف قصير عني %EXTRA_DATA_4% وأتحدث فقط باللغة %EXTRA_DATA_5%",
      FR: "Bonjour %EXTRA_DATA_0% 👋🏻 c'est %EXTRA_DATA_1% également connue sous le nom d'Em Noura, j'ai %EXTRA_DATA_2% ans et je suis actuellement basée au Liban %EXTRA_DATA_3%. Je suis ici pour vous connecter avec nos belles mariées qui cherchent leur homme idéal et vous aider à trouver votre futur partenaire et voici une petite description de moi %EXTRA_DATA_4% et je parle seulement en %EXTRA_DATA_5% Langue",
      TR: "Merhaba %EXTRA_DATA_0% 👋🏻 bu %EXTRA_DATA_1% Ayrıca Em Noura olarak da bilinir, %EXTRA_DATA_2% yaşındayım ve şu anda Lübnan'da yaşıyorum %EXTRA_DATA_3%. Burada sizleri hayallerindeki erkeklerini arayan güzel gelinlerimizle bağlantı kurmak ve gelecekteki partnerinizi bulmanıza yardımcı olmak için buradayım ve işte benim hakkımda küçük bir açıklama %EXTRA_DATA_4% ve sadece %EXTRA_DATA_5% Dilinde konuşuyorum"
    },
    KHATTABAT: {
      ENG: "Khattabat",
      AR: "Khattabat",
      FR: "Khattabat",
      TR: "Khattabat"
    },
    MALE_CLIENTS: {
      ENG: "Male Clients",
      AR: "Male Clients",
      FR: "Male Clients",
      TR: "Male Clients"
    },
    FEMALE_CLIENTS: {
      ENG: "Female Clients",
      AR: "Female Clients",
      FR: "Female Clients",
      TR: "Female Clients"
    },
    MATCHMAKING: {
      ENG: "Matchmaking",
      AR: "Matchmaking",
      FR: "Matchmaking",
      TR: "Matchmaking"
    },
    KHATTABAT_MATCHING_SEARCH_AND_1O1M: {
      ENG: "Search & 101M",
      AR: "Search & 101M",
      FR: "Search & 101M",
      TR: "Search & 101M"
    },
    KHATTABAT_MATCHING_RESULTS: {
      ENG: "Results 101M",
      AR: "Results 101M",
      FR: "Results 101M",
      TR: "Results 101M"
    },
    CLIENT_IGNORE: {
      ENG: "Ignore",
      AR: "Ignore",
      FR: "Ignore",
      TR: "Ignore"
    },
    CLIENT_PAID: {
      ENG: "Paid",
      AR: "Paid",
      FR: "Paid",
      TR: "Paid"
    },
    CLIENT_LEAD: {
      ENG: "Lead",
      AR: "Lead",
      FR: "Lead",
      TR: "Lead"
    },
    CLIENT_CONTACTED: {
      ENG: "Contacted",
      AR: "Contacted",
      FR: "Contacted",
      TR: "Contacted"
    },
    CLIENT_NEW_CONTACT: {
      ENG: "New Contacts",
      AR: "New Contacts",
      FR: "New Contacts",
      TR: "New Contacts"
    },
    SUBSCRIPTION_ACTIVE: {
      ENG: "Sub Ac",
      AR: "Sub Ac",
      FR: "Sub Ac",
      TR: "Sub Ac"
    },
    SUBSCRIPTION_EXPIRED: {
      ENG: "Sub Ex",
      AR: "Sub Ex",
      FR: "Sub Ex",
      TR: "Sub Ex"
    },
    GET_KHATTABAT_CLIENTS: {
      ENG: "Get Khatabat Clients",
      AR: "Get Khatabat Clients",
      FR: "Get Khatabat Clients",
      TR: "Get Khatabat Clients"
    },
    SEND: {
      AR: "Send",
      ENG: "Send",
      FR: "Send",
      TR: "Send"
    },
    ADD: {
      AR: "Add",
      ENG: "Add",
      FR: "Add",
      TR: "Add"
    },
    BLOCK: {
      AR: "Block",
      ENG: "Block",
      FR: "Block",
      TR: "Block"
    },
    CREATE_ONE_O_TWO: {
      AR: "Create 1O2",
      ENG: "Create 1O2",
      FR: "Create 1O2",
      TR: "Create 1O2"
    },
    ONE_O_ONE_C: {
      AR: "1O1C",
      ENG: "1O1C",
      FR: "1O1C",
      TR: "1O1C"
    },
    HIGHLIGHT: {
      AR: "Highlight",
      ENG: "Highlight",
      FR: "Highlight",
      TR: "Highlight"
    },
    ONE_O_TWO_WITH: {
      AR: "1O2 With",
      ENG: "1O2 With",
      FR: "1O2 With",
      TR: "1O2 With"
    },
    COMMENTS: {
      AR: "Comments",
      ENG: "Comments",
      FR: "Comments",
      TR: "Comments"
    },
    ONGOING: {
      AR: "Ongoing",
      ENG: "Ongoing",
      FR: "Ongoing",
      TR: "Ongoing"
    },
    EXITED_BY_MATCH: {
      AR: "Exited by match",
      ENG: "Exited by match",
      FR: "Exited by match",
      TR: "Exited by match"
    },
    EXITED_BY_CLIENT: {
      AR: "Exited by client",
      ENG: "Exited by client",
      FR: "Exited by client",
      TR: "Exited by client"
    },
    PENDING_INTERACTION: {
      AR: "Pending Interaction",
      ENG: "Pending Interaction",
      FR: "Pending Interaction",
      TR: "Pending Interaction"
    },
    ONE_O_ONE_M: {
      ENG: "OneOOneM",
      AR: "OneOOneM",
      FR: "OneOOneM",
      TR: "OneOOneM"
    },

    MATCH_IDS: {
      ENG: "MatchIDs",
      AR: "MatchIDs",
      FR: "MatchIDs",
      TR: "MatchIDs"
    },
    CLIENT_ID: {
      ENG: "ClientID",
      AR: "ClientID",
      FR: "ClientID",
      TR: "ClientID"
    },

    ONE_O_ONE_M_SENT_RESULT: {
      ENG: "OneOOneM Sent result \n %EXTRA_DATA%",
      AR: "OneOOneM Sent result \n %EXTRA_DATA%",
      FR: "OneOOneM Sent result \n %EXTRA_DATA%",
      TR: "OneOOneM Sent result \n %EXTRA_DATA%"
    },
    INCORRECT_CLIENT_ID: {
      ENG: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba",
      AR: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba",
      FR: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba",
      TR: "Incorrect ClientID. Make sure that the clientID is that of a user having an existing 101C conversation with a khattaba"
    },
    REFUND: {
      AR: "Refund",
      ENG: "Refund",
      FR: "Refund",
      TR: "Refund"
    },
    CANCEL: {
      AR: "Cancel",
      ENG: "Cancel",
      FR: "Cancel",
      TR: "Cancel"
    },
    NO_WEB_PAYMENT_DATA: {
      AR: "No web payment data",
      ENG: "No web payment data",
      TR: "No web payment data",
      FR: "No web payment data"
    },
    NO_ACTIVE_WEB_SUBSCRIPTION: {
      AR: "No active web subscription",
      ENG: "No active web subscription",
      TR: "No active web subscription",
      FR: "No active web subscription"
    },
    WEB_PAYMENT_REFUND_FAILED: {
      AR: "Web payment refund failed",
      ENG: "Web payment refund failed",
      TR: "Web payment refund failed",
      FR: "Web payment refund failed"
    },
    WEB_PAYMENT_INVALID_REQUEST_ERROR: {
      AR: "Web Payment Invalid Request Error",
      ENG: "Web Payment Invalid Request Error",
      FR: "Web Payment Invalid Request Error",
      TR: "Web Payment Invalid Request Error"
    },
    NOT_UPDATED_CHECK_IF_CORRECT_PAYEMTN_INTENT: {
      AR: "Not Updated Check If Correct Payment Intent",
      ENG: "Not Updated Check If Correct Payment Intent",
      FR: "Not Updated Check If Correct Payment Intent",
      TR: "Not Updated Check If Correct Payment Intent"
    },
    NOT_UPDATED_CHECK_IF_CORRECT_SUBSCRIPTION: {
      AR: "Not Updated Check If Correct Subscription",
      ENG: "Not Updated Check If Correct Subscription",
      TR: "Not Updated Check If Correct Subscription",
      FR: "Not Updated Check If Correct Subscription"
    },
    ONE_O_TWO_CLIENT_MATCH_SAME_GENDER: {
      ENG: "Client and Match have same Gender for this One O Two conversation!!",
      AR: "Client and Match have same Gender for this One O Two conversation!!",
      FR: "Client and Match have same Gender for this One O Two conversation!!",
      TR: "Client and Match have same Gender for this One O Two conversation!!"
    },
    CANNOT_CHANGE_TO_SAME_STATUS: {
      AR: "Cannot change to same user status, please press Get",
      ENG: "Cannot change to same user status, please press Get",
      FR: "Cannot change to same user status, please press Get",
      TR: "Cannot change to same user status, please press Get"
    },
    USER_DOES_NOT_EXIST_OR_INACTIVE: {
      ENG: "User does not exist or inactive",
      AR: "User does not exist or inactive",
      FR: "User does not exist or inactive",
      TR: "User does not exist or inactive"
    },
    ONE_O_TWO_CONVERSATION_ALREADY_CREATED: {
      ENG: "1O2 conversation already created!",
      AR: "1O2 conversation already created!",
      FR: "1O2 conversation already created!",
      TR: "1O2 conversation already created!"
    },
    RECEIPT_ORIGINAL_TRANSACTION_ID: {
      ENG: "Receipt Original Transaction ID",
      AR: "Receipt Original Transaction ID",
      FR: "Receipt Original Transaction ID",
      TR: "Receipt Original Transaction ID"
    },
    RECEIPT_PURCHASE_DATE: {
      ENG: "Purchase Date",
      AR: "Purchase Date",
      FR: "Purchase Date",
      TR: "Purchase Date"
    },
    RECEIPT_EXPIRES_DATE: {
      ENG: "Expires Date",
      AR: "Expires Date",
      FR: "Expires Date",
      TR: "Expires Date"
    },

    RECEIPT_IN_APP_OWNERSHIP_TYPE: {
      ENG: "Status",
      AR: "Status",
      FR: "Status",
      TR: "Status"
    },
    RECEIPT_QUANTITY: {
      ENG: "Quantity",
      AR: "Quantity",
      FR: "Quantity",
      TR: "Quantity"
    },
    RECEIPT_EXPIRES_DATE_MS: {
      ENG: "Expires Date Ms",
      AR: "Expires Date Ms",
      FR: "Expires Date Ms",
      TR: "Expires Date Ms"
    },
    RECEIPT_EXPIRES_DATE_PST: {
      ENG: "Expires Date Pst",
      AR: "Expires Date Pst",
      FR: "Expires Date Pst",
      TR: "Expires Date Pst"
    },
    RECEIPT_PURCHASE_DATE_MS: {
      ENG: "Purchase Date Ms",
      AR: "Purchase Date Ms",
      FR: "Purchase Date Ms",
      TR: "Purchase Date Ms"
    },
    RECEIPT_PURCHASE_DATE_PST: {
      ENG: "Purchase Date Pst",
      AR: "Purchase Date Pst",
      FR: "Purchase Date Pst",
      TR: "Purchase Date Pst"
    },
    RECEIPT_ORIGINAL_PURCHASE_DATE: {
      ENG: "Original Purchase Date",
      AR: "Original Purchase Date",
      FR: "Original Purchase Date",
      TR: "Original Purchase Date"
    },
    RECEIPT_ORIGINAL_PURCHASE_MS: {
      ENG: "Original Purchase Date Ms",
      AR: "Original Purchase Date Ms",
      FR: "Original Purchase Date Ms",
      TR: "Original Purchase Date Ms"
    },
    RECEIPT_ORIGINAL_PURCHASE_DATE_PST: {
      ENG: "Original Purchase Date Pst",
      AR: "Original Purchase Date Pst",
      FR: "Original Purchase Date Pst",
      TR: "Original Purchase Date Pst"
    },
    RECEIPT_WEB_ORDER_LINE_ITEM_ID: {
      ENG: "Web Order Line Item Id",
      AR: "Web Order Line Item Id",
      FR: "Web Order Line Item Id",
      TR: "Web Order Line Item Id"
    },
    RECEIPT_IS_IN_INTRO_OFFER_PERIOD: {
      ENG: "Is In Intro Offer Period",
      AR: "Is In Intro Offer Period",
      FR: "Is In Intro Offer Period",
      TR: "Is In Intro Offer Period"
    },
    RECEIPT_IS_TRIAL_PERIOD: {
      ENG: "Is Trial Period",
      AR: "Is Trial Period",
      FR: "Is Trial Period",
      TR: "Is Trial Period"
    },
    RECEIPT_APP_ACCOUNT_TOKEN: {
      ENG: "App Account Token",
      AR: "App Account Token",
      FR: "App Account Token",
      TR: "App Account Token"
    },
    RECEIPT_HAS_PENDING: {
      ENG: "Has Pending",
      AR: "Has Pending",
      FR: "Has Pending",
      TR: "Has Pending"
    },
    RECEIPT_IS_IN_BILLING_RETRY: {
      ENG: "Is In Billing Retry",
      AR: "Is In Billing Retry",
      FR: "Is In Billing Retry",
      TR: "Is In Billing Retry"
    },
    LAST_RECEIPT_ORIGINAL_TRANSACTION_ID: {
      ENG: "Original Transaction Id",
      AR: "Original Transaction Id",
      FR: "Original Transaction Id",
      TR: "Original Transaction Id"
    },
    RECEIPT_PRODUCT_ID: {
      ENG: "Product Id",
      AR: "Product Id",
      FR: "Product Id",
      TR: "Product Id"
    },
    LAST_RECEIPT_PRODUCT_ID: {
      ENG: "Product Id",
      AR: "Product Id",
      FR: "Product Id",
      TR: "Product Id"
    },
    RECEIPT_EXPIRATION_INTENT: {
      ENG: "Expiration Intent",
      AR: "Expiration Intent",
      FR: "Expiration Intent",
      TR: "Expiration Intent"
    },
    RECEIPT_AUTO_RENEW_STATUS: {
      ENG: "Auto Renew Status",
      AR: "Auto Renew Status",
      FR: "Auto Renew Status",
      TR: "Auto Renew Status"
    },
    RECEIPT_AUTO_RENEW_PRODUCT_ID: {
      ENG: "Auto Renew Product Id",
      AR: "Auto Renew Product Id",
      FR: "Auto Renew Product Id",
      TR: "Auto Renew Product Id"
    },
    LAST_RECEIPT: {
      ENG: "Last Receipt",
      AR: "Last Receipt",
      FR: "Last Receipt",
      TR: "Last Receipt"
    },
    PENDING_RECEIPTS: {
      ENG: "Pending Receipts",
      AR: "Pending Receipts",
      FR: "Pending Receipts",
      TR: "Pending Receipts"
    },
    NO_RECEIPT: {
      ENG: "No Receipt",
      AR: "No Receipt",
      FR: "No Receipt",
      TR: "No Receipt"
    },
    APPLE_RECEIPT_ERROR: {
      ENG: "Apple Receipt Error",
      AR: "Apple Receipt Error",
      FR: "Apple Receipt Error",
      TR: "Apple Receipt Error"
    },
    ANDROID_RECEIPT_ERROR: {
      ENG: "Android Receipt Error",
      AR: "Android Receipt Error",
      FR: "Android Receipt Error",
      TR: "Android Receipt Error"
    },
    NO_RECEIPT_TOKEN_FOUND: {
      ENG: "No Receipt Token Found",
      AR: "No Receipt Token Found",
      FR: "No Receipt Token Found",
      TR: "No Receipt Token Found"
    },
    ALREADY_CANCELLED: {
      AR: "Already Cancelled",
      ENG: "Already Cancelled",
      FR: "Already Cancelled",
      TR: "Already Cancelled"
    },
    CANCELLED: {
      AR: "Cancelled",
      ENG: "Cancelled",
      FR: "Cancelled",
      TR: "Cancelled"
    },
    ONE_O_TWO_CONVERSATION_IS_NOT_ACTIVE_ANYMORE: {
      ENG: "ONE O TWO Conversation is not active anymore",
      AR: "ONE O TWO Conversation is not active anymore",
      FR: "ONE O TWO Conversation is not active anymore",
      TR: "ONE O TWO Conversation is not active anymore"
    },
    DOUBLE_CLICK_FOR_GOOGLE_LENS: {
      ENG: "Double click for Google lens",
      AR: "Double click for Google lens",
      FR: "Double click for Google lens",
      TR: "Double click for Google lens"
    },
    NO_WEB_USER_PAYMENT_ARCHIVE_DATA: {
      AR: "No Data In User Payment Server Archive",
      ENG: "No Data In User Payment Server Archive",
      TR: "No Data In User Payment Server Archive",
      FR: "No Data In User Payment Server Archive"
    },
    WRONG_REFFERAL_CODE: {
      AR: " Wrong referral code",
      FR: " Wrong referral code",
      ENG: " Wrong referral code",
      TR: " Wrong referral code"
    },
    ADMIN_USERS_HAVE_ALREADY_ANOTHER_ACTIVE_POOL: {
      AR: "You currently have an active pool!",
      TR: "You currently have an active pool!",
      FR: "You currently have an active pool!",
      ENG: "You currently have an active pool!"
    },
    TYPE_OF_MARIAGE: {
      AR: "Mariage Type",
      ENG: "Mariage Type",
      TR: "Mariage Type",
      FR: "Mariage Type"
    },
    MARITAL_STATUS: {
      AR: "Marital status",
      ENG: "Marital status",
      TR: "Marital status",
      FR: "Marital status"
    },
    EDUCATION_LEVEL: {
      AR: "Education",
      ENG: "Education",
      TR: "Education",
      FR: "Education"
    },
    WORK_LEVEL: {
      AR: "Work",
      ENG: "Work",
      TR: "Work",
      FR: "Work"
    },
    SMOKING_LEVEL: {
      AR: "Smoking",
      ENG: "Smoking",
      TR: "Smoking",
      FR: "Smoking"
    },
    SKIN_COLOR: {
      AR: "Skin Color",
      ENG: "Skin Color",
      TR: "Skin Color",
      FR: "Skin Color"
    },
    VEIL: {
      AR: "Veil",
      ENG: "Veil",
      TR: "Veil",
      FR: "Veil"
    },
    RELIGION: {
      AR: "Religion",
      ENG: "Religion",
      TR: "Religion",
      FR: "Religion"
    },
    HAVING_KIDS: {
      AR: "Having kids",
      ENG: "Having kids",
      TR: "Having kids",
      FR: "Having kids"
    },
    FEMALE_WORK_STUDY: {
      AR: "Female work or study",
      ENG: "Female work or study",
      TR: "Female work or study",
      FR: "Female work or study"
    },
    BELONGS_TO_TRIBE: {
      AR: "Belongs to a tribe",
      ENG: "Belongs to a tribe",
      TR: "Belongs to a tribe",
      FR: "Belongs to a tribe"
    },
    RELOCATION: {
      AR: "Relocation",
      ENG: "Relocation",
      TR: "Relocation",
      FR: "Relocation"
    },
    REGULAR: {
      AR: "Regular",
      ENG: "Regular",
      TR: "Regular",
      FR: "Regular"
    },
    POLY: {
      AR: "Poly",
      ENG: "Poly",
      TR: "Poly",
      FR: "Poly"
    },
    MISYAR: {
      AR: "Misyar",
      ENG: "Misyar",
      TR: "Misyar",
      FR: "Misyar"
    },
    LEAD: {
      AR: "Lead",
      ENG: "Lead",
      TR: "Lead",
      FR: "Lead"
    },
    IGNORE: {
      AR: "Ignore",
      ENG: "Ignore",
      TR: "Ignore",
      FR: "Ignore"
    },
    MOVE_TO: {
      AR: "Move To",
      ENG: "Move To",
      TR: "Move To",
      FR: "Move To"
    },
    SELECT_ALL: {
      AR: "Select All",
      ENG: "Select All",
      TR: "Select All",
      FR: "Select All"
    },
    USER_HAS_NO_RECEIPTS: {
      AR: "User Has No Receipts",
      FR: "User Has No Receipts",
      ENG: "User Has No Receipts",
      TR: "User Has No Receipts"
    },
    ARE_YOU_SURE_YOU_WANT_TO_CANCEL_WEB_PAYMENT: {
      AR: " Are you sure you want to cancel web payment",
      ENG: " Are you sure you want to cancel web payment",
      FR: " Are you sure you want to cancel web payment",
      TR: " Are you sure you want to cancel web payment"
    },
    ARE_YOU_SURE_YOU_WANT_TO_REFUND_WEB_PAYMENT: {
      AR: " Are you sure you want to refund web payment",
      ENG: " Are you sure you want to refund web payment",
      FR: " Are you sure you want to refund web payment",
      TR: " Are you sure you want to refund web payment"
    },
    WEB_REFUND_ATTENTION: {
      AR: "Attention: This user has previously received a refund.",
      ENG: "Attention: This user has previously received a refund.",
      TR: "Attention: This user has previously received a refund.",
      FR: "Attention: This user has previously received a refund."
    },
    ARE_YOU_SURE_YOU_WANT_TO_CONTINUE: {
      AR: "Are you sure you want to continue?",
      TR: "Are you sure you want to continue?",
      ENG: "Are you sure you want to continue?",
      FR: "Are you sure you want to continue?"
    },
    COUNT_SELECTED: {
      AR: "Count Selected",
      ENG: "Count Selected",
      TR: "Count Selected",
      FR: "Count Selected"
    },
    COUNT: {
      AR: "Count",
      ENG: "Count",
      TR: "Count",
      FR: "Count"
    },
    FILTERS: {
      AR: "Filters",
      ENG: "Filters",
      TR: "Filters",
      FR: "Filters"
    },
    MIN_AGE: {
      AR: "Min Age",
      ENG: "Min Age",
      TR: "Min Age",
      FR: "Min Age"
    },
    MAX_AGE: {
      AR: "Max Age",
      ENG: "Max Age",
      TR: "Max Age",
      FR: "Max Age"
    },
    UNDEFINED: {
      AR: "Undefined",
      ENG: "Undefined",
      TR: "Undefined",
      FR: "Undefined"
    },
    APPLY: {
      AR: "Apply",
      ENG: "Apply",
      TR: "Apply",
      FR: "Apply"
    },
    MAX_AGE_HAS_TO_BE_BIGGER_MIN_AGE: {
      AR: "Max age should be bigger than Min age! There Values will be switched",
      ENG: "Max age should be bigger than Min age! There Values will be switched",
      TR: "Max age should be bigger than Min age! There Values will be switched",
      FR: "Max age should be bigger than Min age! There Values will be switched"
    },
    FILTERS_RESET: {
      AR: "Reset Filters",
      ENG: "Reset Filters",
      TR: "Reset Filters",
      FR: "Reset Filters"
    },
    AI_MESSAGES_BOX: {
      AR: "AI Messages Box",
      ENG: "AI Messages Box",
      TR: "AI Messages Box",
      FR: "AI Messages Box"
    },
    PLEASE_AT_LEAST_ONE_USER: {
      AR: "Please select at least one user",
      ENG: "Please select at least one user",
      TR: "Please select at least one user",
      FR: "Please select at least one user"
    },
    SENDING: {
      AR: "Sending...",
      ENG: "Sending...",
      TR: "Sending...",
      FR: "Sending..."
    },
    MARK_AS_READ: {
      AR: "Mark as read",
      ENG: "Mark as read",
      TR: "Mark as read",
      FR: "Mark as read"
    },
    UNREAD_MESSAGES: {
      AR: "Unread Messages",
      ENG: "Unread Messages",
      TR: "Unread Messages",
      FR: "Unread Messages"
    },
    NO_PAID_USERS_FOUND: {
      AR: "No Paid users has been found!",
      ENG: "No Paid users has been found!",
      TR: "No Paid users has been found!",
      FR: "No Paid users has been found!"
    },
    PAID_USERS: {
      AR: "Paid Users",
      ENG: "Paid Users",
      TR: "Paid Users",
      FR: "Paid Users"
    },
    RESULTS_NUMBER: {
      AR: "Results number",
      ENG: "Results number",
      TR: "Results number",
      FR: "Results number"
    },
    CLEAR_RESULTS: {
      AR: "Clear Results",
      ENG: "Clear Results",
      TR: "Clear Results",
      FR: "Clear Results"
    },
    NO_MATCHES_FOUND: {
      AR: "NO Matches has been found",
      ENG: "NO Matches has been found",
      TR: "NO Matches has been found",
      FR: "NO Matches has been found"
    },
    CREATE_ONE_O_ONE_M: {
      AR: "Create 101M",
      ENG: "Create 101M",
      TR: "Create 101M",
      FR: "Create 101M"
    },
    SEND_ONE_O_ONE_M_MESSAGE_PLACE_HOLDER: {
      AR: "Write the custom message to send in the 101M",
      ENG: "Write the custom message to send in the 101M",
      TR: "Write the custom message to send in the 101M",
      FR: "Write the custom message to send in the 101M"
    },
    CITY_OF_RESIDENCE: {
      ENG: "City of residence",
      AR: "City of residence",
      FR: "City of residence",
      TR: "City of residence"
    },
    GET_CITIES: {
      ENG: "Get Cities",
      AR: "Get Cities",
      FR: "Get Cities",
      TR: "Get Cities"
    },
    NO_CITIES_FOUND: {
      ENG: "NO Cities has been found",
      AR: "NO Cities has been found",
      FR: "NO Cities has been found",
      TR: "NO Cities has been found"
    },
    GET_CONVESATIONS: {
      ENG: "Get Conversations",
      AR: "Get Conversations",
      FR: "Get Conversations",
      TR: "Get Conversations"
    },
    NO_APPROVED_MATCHES_FOUND: {
      AR: "NO Approved Matches has been found",
      ENG: "NO Approved Matches has been found",
      TR: "NO Approved Matches has been found",
      FR: "NO Approved Matches has been found"
    },
    CONTACTED: {
      ENG: "Contacted",
      AR: "Contacted",
      FR: "Contacted",
      TR: "Contacted"
    },
    MATCH_APP_LANGUAGE: {
      ENG: "Match Application Language",
      AR: "Match Application Language",
      FR: "Match Application Language",
      TR: "Match Application Language"
    },

    SUPERVISOR_RECEIPT_COMPENSATION: {
      AR: "Supervisor Receipt Compensation",
      ENG: "Supervisor Receipt Compensation",
      TR: "Supervisor Receipt Compensation",
      FR: "Supervisor Receipt Compensation"
    },
    SUPERVISOR_RECEIPT_COMPENSATION_DATA_INPUT: {
      AR: "Data Input",
      ENG: "Data Input",
      FR: "Data Input",
      TR: "Data Input"
    },
    SUPERVISOR_RECEIPT_COMPENSATION_ISSUES_ADDED_SUCCESSFULLY: {
      AR: "Supervisor Issues Added successfully",
      ENG: "Supervisor Issues Added successfully",
      FR: "Supervisor Issues Added successfully",
      TR: "Supervisor Issues Added successfully"
    },
    RECEIPT_FOUND_FOR_THIS_MONTH: {
      AR: "Receipt Found For This Month",
      ENG: "Receipt Found For This Month",
      FR: "Receipt Found For This Month",
      TR: "Receipt Found For This Month"
    },
    SUBMIT_DATE_IS_SPECIFIC: {
      AR: "Submit Button Has Specific Date Between 26 and 28",
      ENG: "Submit Button Has Specific Date Between 26 and 28",
      FR: "Submit Button Has Specific Date Between 26 and 28",
      TR: "Submit Button Has Specific Date Between 26 and 28"
    },
    SUPERVISOR_RECEIPT_CONFIGURATION: {
      ENG: "Supervisor Receipt Configuration",
      AR: "Supervisor Receipt Configuration",
      FR: "Supervisor Receipt Configuration",
      TR: "Supervisor Receipt Configuration"
    },
    DESCRIPTION_THRESHOLD: {
      AR: "Description Threshold",
      FR: "Description Threshold",
      ENG: "Description Threshold",
      TR: "Description Threshold"
    },
    DESCRIPTION_DISCOUNT: {
      AR: "Description Discount",
      FR: "Description Discount",
      ENG: "Description Discount",
      TR: "Description Discount"
    },
    DESCRIPTION_PRICING: {
      AR: "Description Pricing",
      FR: "Description Pricing",
      ENG: "Description Pricing",
      TR: "Description Pricing"
    },
    REPORT_THRESHOLD: {
      AR: "Report Threshold",
      FR: "Report Threshold",
      ENG: "Report Threshold",
      TR: "Report Threshold"
    },
    REPORT_DISCOUNT: {
      AR: "Report Discount",
      FR: "Report Discount",
      ENG: "Report Discount",
      TR: "Report Discount"
    },
    REPORT_PRICING: {
      AR: "Report Pricing",
      FR: "Report Pricing",
      ENG: "Report Pricing",
      TR: "Report Pricing"
    },
    INVESTIGATION_CASES_THRESHOLD: {
      AR: "Investigation Cases Threshold",
      FR: "Investigation Cases Threshold",
      ENG: "Investigation Cases Threshold",
      TR: "Investigation Cases Threshold"
    },
    INVESTIGATION_CASES_DISCOUNT: {
      AR: "Investigation Cases Discount",
      FR: "Investigation Cases Discount",
      ENG: "Investigation Cases Discount",
      TR: "Investigation Cases Discount"
    },
    INVESTIGATION_CASES_PRICING: {
      AR: "Investigation Cases Pricing",
      FR: "Investigation Cases Pricing",
      ENG: "Investigation Cases Pricing",
      TR: "Investigation Cases Pricing"
    },
    PICTURE_THRESHOLD: {
      AR: "Picture Threshold",
      FR: "Picture Threshold",
      ENG: "Picture Threshold",
      TR: "Picture Threshold"
    },
    PICTURE_PRICING: {
      AR: "Picture Pricing",
      FR: "Picture Pricing",
      ENG: "Picture Pricing",
      TR: "Picture Pricing"
    },
    PICTURE_DISCOUNT: {
      AR: "Picture Discount",
      FR: "Picture Discount",
      ENG: "Picture Discount",
      TR: "Picture Discount"
    },
    RECEIPT_CONFIGURATION_INSERTED_SUCCESSFULLY: {
      AR: "Receipt Configuration Inserted successfully",
      ENG: "Receipt Configuration Inserted successfully",
      FR: "Receipt Configuration Inserted successfully",
      TR: "Receipt Configuration Inserted successfully"
    },
    NO_RECEIPT_CONFIGURATION_DATA_YET: {
      AR: "No Receipt Configuration Dashboard Yet",
      ENG: "No Receipt Configuration Dashboard Yet",
      FR: "No Receipt Configuration Dashboard Yet",
      TR: "No Receipt Configuration Dashboard Yet"
    },
    PREVIOUS_RECEIPT_MONTH: {
      AR: "Previous Receipts Months",
      ENG: "Previous Receipts Months",
      FR: " Previous Receipts Months",
      TR: "Previous Receipts Months"
    },
    CURRENT_RECEIPT_MONTH: {
      AR: "Current Receipt Month",
      ENG: "Current Receipt Month",
      FR: " Current Receipt Month",
      TR: "Current Receipt Month"
    },
    CSR_MY_RECEIPT_EVENT_COUNT: {
      AR: "My CSR Receipt Events Count",
      ENG: "My CSR Receipt Events Count",
      FR: "My CSR Receipt Events Count",
      TR: "My CSR Receipt Events Count"
    },
    IMAGE_STATUS_DELETED: {
      AR: "Image is deleted by user on App, please press 'Get'",
      ENG: "Image is deleted by user on App, please press 'Get'",
      FR: "Image is deleted by user on App, please press 'Get'",
      TR: "Image is deleted by user on App, please press 'Get'"
    },
    CSR_TIME_ACCESS: {
      AR: "CSR time Access",
      ENG: "CSR time Access",
      TR: "CSR time Access",
      FR: "CSR time Access"
    },
    SLOT: {
      AR: "Slot %EXTRA_DATA%",
      ENG: "Slot %EXTRA_DATA%",
      TR: "Slot %EXTRA_DATA%",
      FR: "Slot %EXTRA_DATA%"
    },
    ALL_DAYS: {
      AR: "All Days",
      ENG: "All Days",
      TR: "All Days",
      FR: "All Days"
    },
    MONDAY: {
      AR: "Monday",
      ENG: "Monday",
      TR: "Monday",
      FR: "Monday"
    },
    TUESDAY: {
      AR: "Tuesday",
      ENG: "Tuesday",
      TR: "Tuesday",
      FR: "Tuesday"
    },
    WEDNESDAY: {
      AR: "Wednesday",
      ENG: "Wednesday",
      TR: "Wednesday",
      FR: "Wednesday"
    },
    THURSDAY: {
      AR: "Thursday",
      ENG: "Thursday",
      TR: "Thursday",
      FR: "Thursday"
    },
    FRIDAY: {
      AR: "Friday",
      ENG: "Friday",
      TR: "Friday",
      FR: "Friday"
    },
    SATURDAY: {
      AR: "Saturday",
      ENG: "Saturday",
      TR: "Saturday",
      FR: "Saturday"
    },
    SUNDAY: {
      AR: "Sunday",
      ENG: "Sunday",
      TR: "Sunday",
      FR: "Sunday"
    },
    CHOOSE_PROPER_TIME_RANGE: {
      AR: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells",
      ENG: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells",
      TR: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells",
      FR: "Please Choose Proper Time Range! 'To' Cell should be equal or greater from 'From' cell! Follow the red text cells"
    },
    NO_LONGER_ACTIVE_POOL: {
      AR: "No longer active pool, Please refresh the page!",
      ENG: "No longer active pool, Please refresh the page!",
      TR: "No longer active pool, Please refresh the page!",
      FR: "No longer active pool, Please refresh the page!"
    },
    DISABLE: {
      AR: "Disabled",
      ENG: "Disable",
      TR: "Disable",
      FR: "Disable"
    },
    ENABLE: {
      AR: "Enable",
      ENG: "Enable",
      TR: "Enable",
      FR: "Enable"
    },
    ENABLE_SELECTED_1O1M: {
      AR: "Enable Selected 101M",
      ENG: "Enable Selected 101M",
      TR: "Enable Selected 101M",
      FR: "Enable Selected 101M"
    },
    DISABLE_SELECTED_1O1M: {
      AR: "Disable Selected 101M",
      ENG: "Disable Selected 101M",
      TR: "Disable Selected 101M",
      FR: "Disable Selected 101M"
    },
    NO_SHARED_HOLDER_DATA: {
      AR: "No ShareHolder Data",
      ENG: "No ShareHolder Data",
      TR: "No ShareHolder Data",
      FR: "No ShareHolder Data"
    },
    PROFILE_ID: {
      AR: "Profile ID",
      ENG: "Profile ID",
      FR: "Profile ID",
      TR: "Profile ID"
    },
    WRONG_PROFILE_ID: {
      AR: "Wrong Profile ID",
      ENG: "Wrong Profile ID",
      TR: "Wrong Profile ID",
      FR: "Wrong Profile ID"
    },
    PROFILE_ID_NOT_FOUND: {
      AR: "Profile ID Not Found",
      ENG: "Profile ID Not Found",
      TR: "Profile ID Not Found",
      FR: "Profile ID Not Found"
    },
    VIP_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free VIP to this user? ",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free VIP to this user? ",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free VIP to this user? ",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free VIP to this user? "
    },
    RESET_PASSWORD_CONFIRMATION_POPUP: {
      ENG: "Are you sure you want to reset the password for %EXTRA_DATA%?",
      AR: "Are you sure you want to reset the password for %EXTRA_DATA%?",
      TR: "Are you sure you want to reset the password for %EXTRA_DATA%?",
      FR: "Are you sure you want to reset the password for %EXTRA_DATA%?"
    },
    CLEAN_POOL_CONFIRMATION_POPUP: {
      ENG: "You already have an active pool. Do you want to clean your pool and take this one instead?",
      AR: "You already have an active pool. Do you want to clean your pool and take this one instead?",
      TR: "You already have an active pool. Do you want to clean your pool and take this one instead?",
      FR: "You already have an active pool. Do you want to clean your pool and take this one instead?"
    },
    USER_DATA: {
      ENG: "User Data",
      AR: "User Data",
      TR: "User Data",
      FR: "User Data"
    },
    USER_PROFILE: {
      ENG: "User Profile",
      AR: "User Profile",
      TR: "User Profile",
      FR: "User Profile"
    },
    THERE_IS_ANOTHER_AVAILABLE_KHATTABA: {
      AR: "Feature is already being used. Try again later",
      ENG: "Feature is already being used. Try again later",
      TR: "Feature is already being used. Try again later",
      FR: "Feature is already being used. Try again later"
    },
    KHATTABAT_REMUNERATION: {
      AR: "Khattabat Remuneration",
      ENG: "Khattabat Remuneration",
      TR: "Khattabat Remuneration",
      FR: "Khattabat Remuneration"
    },
    PER_CYCLE: {
      AR: "Per Cycle",
      ENG: "Per Cycle",
      TR: "Per Cycle",
      FR: "Per Cycle"
    },
    KHATTABAT_ADMIN: {
      AR: "Khattabat Admin",
      ENG: "Khattabat Admin",
      TR: "Khattabat Admin",
      FR: "Khattabat Admin"
    },
    NO_KHATTABAT_ADMIN: {
      AR: "There is no Khattabat Admin",
      ENG: "There is no Khattabat Admin",
      TR: "There is no Khattabat Admin",
      FR: "There is no Khattabat Admin"
    },
    ADMIN_KHATTABAT_REMUNERATIONS: {
      AR: "Khattabat admin remunerations per cycle",
      ENG: "Khattabat admin remunerations per cycle",
      TR: "Khattabat admin remunerations per cycle",
      FR: "Khattabat admin remunerations per cycle"
    },
    VIP: {
      AR: "VIP",
      ENG: "VIP",
      TR: "VIP",
      FR: "VIP"
    },
    PLUS: {
      AR: "PLUS",
      ENG: "PLUS",
      TR: "PLUS",
      FR: "PLUS"
    },
    KHATTABAT_TAG: {
      AR: "KHATTABAT",
      ENG: "KHATTABAT",
      TR: "KHATTABAT",
      FR: "KHATTABAT"
    },
    BOOST: {
      AR: "BOOST",
      ENG: "BOOST",
      TR: "BOOST",
      FR: "BOOST"
    },
    REWIND: {
      AR: "REWIND",
      ENG: "REWIND",
      TR: "REWIND",
      FR: "REWIND"
    },
    READ: {
      AR: "READ",
      ENG: "READ",
      TR: "READ",
      FR: "READ"
    },
    SCSR: {
      AR: "SCSR",
      ENG: "SCSR",
      TR: "SCSR",
      FR: "SCSR"
    },
    GIVE_SUBSCRIPTIONS: {
      AR: "Give Subscriptions",
      ENG: "Give Subscriptions",
      FR: "Give Subscriptions",
      TR: "Give Subscriptions"
    },
    PLUS_DAYS: {
      AR: "PLUS Days",
      ENG: "PLUS Days",
      FR: "PLUS Days",
      TR: "PLUS Days"
    },
    PLUS_HOURS: {
      AR: "PLUS Hours",
      ENG: "PLUS Hours",
      FR: "PLUS Hours",
      TR: "PLUS Hours"
    },
    PLUS_MIN: {
      AR: "PLUS Min",
      ENG: "PLUS Min",
      FR: "PLUS Min",
      TR: "PLUS Min"
    },
    KHATTABAT_DAYS: {
      AR: "Khattabat Days",
      ENG: "Khattabat Days",
      FR: "Khattabat Days",
      TR: "Khattabat Days"
    },
    KHATTABAT_HOURS: {
      AR: "Khattabat Hours",
      ENG: "Khattabat Hours",
      FR: "Khattabat Hours",
      TR: "Khattabat Hours"
    },
    KHATTABAT_MIN: {
      AR: "Khattabat Min",
      ENG: "Khattabat Min",
      FR: "Khattabat Min",
      TR: "Khattabat Min"
    },
    MAKE_PLUS: {
      AR: "Make PLUS",
      ENG: "Make PLUS",
      FR: "Make PLUS",
      TR: "Make PLUS"
    },
    MAKE_KHATTABAT: {
      AR: "Make Khattabat",
      ENG: "Make Khattabat",
      FR: "Make Khattabat",
      TR: "Make Khattabat"
    },
    VIP_IN_HOURS: {
      ENG: `VIP in hours should be maximum ${MAX_GIVE_VIP_IN_HOURS}`,
      AR: `VIP in hours should be maximum ${MAX_GIVE_VIP_IN_HOURS}`,
      FR: `VIP in hours should be maximum ${MAX_GIVE_VIP_IN_HOURS}`,
      TR: `VIP in hours should be maximum ${MAX_GIVE_VIP_IN_HOURS}`
    },
    VIP_IN_MIN: {
      ENG: `VIP in min should be maximum ${MAX_GIVE_VIP_IN_MIN}`,
      AR: `VIP in min should be maximum ${MAX_GIVE_VIP_IN_MIN}`,
      FR: `VIP in min should be maximum ${MAX_GIVE_VIP_IN_MIN}`,
      TR: `VIP in min should be maximum ${MAX_GIVE_VIP_IN_MIN}`
    },
    VIP_IN_DAYS: {
      ENG: `VIP in days should be maximum ${MAX_GIVE_VIP_IN_DAYS}`,
      AR: `VIP in days should be maximum ${MAX_GIVE_VIP_IN_DAYS}`,
      FR: `VIP in days should be maximum ${MAX_GIVE_VIP_IN_DAYS}`,
      TR: `VIP in days should be maximum ${MAX_GIVE_VIP_IN_DAYS}`
    },
    PLUS_IN_HOURS: {
      AR: `PLUS in hours should be maximum ${MAX_GIVE_PLUS_IN_HOURS}`,
      ENG: `PLUS in hours should be maximum ${MAX_GIVE_PLUS_IN_HOURS}`,
      FR: `PLUS in hours should be maximum ${MAX_GIVE_PLUS_IN_HOURS}`,
      TR: `PLUS in hours should be maximum ${MAX_GIVE_PLUS_IN_HOURS}`
    },
    PLUS_IN_MIN: {
      AR: `PLUS in min should be maximum ${MAX_GIVE_PLUS_IN_MIN}`,
      ENG: `PLUS in min should be maximum ${MAX_GIVE_PLUS_IN_MIN}`,
      FR: `PLUS in min should be maximum ${MAX_GIVE_PLUS_IN_MIN}`,
      TR: `PLUS in min should be maximum ${MAX_GIVE_PLUS_IN_MIN}`
    },
    PLUS_IN_DAYS: {
      AR: `PLUS in days should be maximum ${MAX_GIVE_PLUS_IN_DAYS}`,
      ENG: `PLUS in days should be maximum ${MAX_GIVE_PLUS_IN_DAYS}`,
      FR: `PLUS in days should be maximum ${MAX_GIVE_PLUS_IN_DAYS}`,
      TR: `PLUS in days should be maximum ${MAX_GIVE_PLUS_IN_DAYS}`
    },
    KHATTABAT_IN_HOURS: {
      AR: `Khattabat in hours should be maximum ${MAX_GIVE_ALKHATTABAT_IN_HOURS}`,
      ENG: `Khattabat in hours should be maximum ${MAX_GIVE_ALKHATTABAT_IN_HOURS}`,
      FR: `Khattabat in hours should be maximum ${MAX_GIVE_ALKHATTABAT_IN_HOURS}`,
      TR: `Khattabat in hours should be maximum ${MAX_GIVE_ALKHATTABAT_IN_HOURS}`
    },
    KHATTABAT_IN_MIN: {
      AR: `Khattabat in min should be maximum ${MAX_GIVE_ALKHATTABAT_IN_MIN}`,
      ENG: `Khattabat in min should be maximum ${MAX_GIVE_ALKHATTABAT_IN_MIN}`,
      FR: `Khattabat in min should be maximum ${MAX_GIVE_ALKHATTABAT_IN_MIN}`,
      TR: `Khattabat in min should be maximum ${MAX_GIVE_ALKHATTABAT_IN_MIN}`
    },
    KHATTABAT_IN_DAYS: {
      AR: `Khattabat in days should be maximum ${MAX_GIVE_ALKHATTABAT_IN_DAYS}`,
      ENG: `Khattabat in days should be maximum ${MAX_GIVE_ALKHATTABAT_IN_DAYS}`,
      FR: `Khattabat in days should be maximum ${MAX_GIVE_ALKHATTABAT_IN_DAYS}`,
      TR: `Khattabat in days should be maximum ${MAX_GIVE_ALKHATTABAT_IN_DAYS}`
    },
    PLUS_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free PLUS to this user? ",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free PLUS to this user? ",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free PLUS to this user? ",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free PLUS to this user? "
    },
    KHATTABAT_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free Khattabat to this user? ",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free Khattabat to this user? ",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free Khattabat to this user? ",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free Khattabat to this user? "
    },
    ONE_O_TWO_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to reactivate this 1O2 conversation? ",
      TR: "Are you sure you want to reactivate this 1O2 conversation? ",
      FR: "Are you sure you want to reactivate this 1O2 conversation? ",
      ENG: "Are you sure you want to reactivate this 1O2 conversation? "
    },
    USER_IS_NOT_MALE_USER: {
      AR: "User is not a Male user",
      TR: "User is not a Male user",
      FR: "User is not a Male user",
      ENG: "User is not a Male user"
    },
    USER_NEVER_PAYING_KHATTABAT: {
      AR: "User was never a paying Khattabat Client",
      ENG: "User was never a paying Khattabat Client",
      FR: "User was never a paying Khattabat Client",
      TR: "User was never a paying Khattabat Client"
    },
    INCORRECT_PLUS_DAYS_HOURS: {
      ENG: "Cannot give less than one day plus and less than one hour to a user",
      AR: "Cannot give less than one day plus and less than one hour to a user",
      FR: "Cannot give less than one day plus and less than one hour to a user",
      TR: "Cannot give less than one day plus and less than one hour to a user"
    },
    USER_PLUS_ADDED_SUCCESSFULLY: {
      ENG: "User PLUS added successfully",
      AR: "User PLUS added successfully",
      FR: "User PLUS added successfully",
      TR: "User PLUS added successfully"
    },
    INCORRECT_KHATTABAT_DAYS_HOURS: {
      ENG: "Cannot give less than one day khattabat and less than one hour to a user",
      AR: "Cannot give less than one day khattabat and less than one hour to a user",
      FR: "Cannot give less than one day khattabat and less than one hour to a user",
      TR: "Cannot give less than one day khattabat and less than one hour to a user"
    },
    USER_KHATTABAT_ADDED_SUCCESSFULLY: {
      ENG: "User KHATTABAT added successfully",
      AR: "User KHATTABAT added successfully",
      FR: "User KHATTABAT added successfully",
      TR: "User KHATTABAT added successfully"
    },
    REASSIGN_KHATTABA: {
      ENG: "Reassign Khattaba",
      AR: "Reassign Khattaba",
      FR: "Reassign Khattaba",
      TR: "Reassign Khattaba"
    },
    USER_IS_NOT_MATCHED_TO_THIS_KHATTABA: {
      ENG: "User Is Not Matched To This old Khattaba",
      AR: "User Is Not Matched To This old Khattaba",
      FR: "User Is Not Matched To This old Khattaba",
      TR: "User Is Not Matched To This old Khattaba"
    },
    REASSIGNMENT_IS_COMPLETED: {
      ENG: "Reassignment is completed!",
      AR: "Reassignment is completed!",
      FR: "Reassignment is completed!",
      TR: "Reassignment is completed!"
    },
    BAN_UNTIL: {
      ENG: "Ban Until:",
      AR: "Ban Until:",
      FR: "Ban Until:",
      TR: "Ban Until:"
    },
    NUMBER_OF_DAYS: {
      ENG: "Number of Days:",
      AR: "Number of Days:",
      FR: "Number of Days:",
      TR: "Number of Days:"
    },
    INVESTIGATION_ID: {
      ENG: "Investigation ID:",
      AR: "Investigation ID:",
      FR: "Investigation ID:",
      TR: "Investigation ID:"
    },
    REPORT_ID: {
      ENG: "Report ID:",
      AR: "Report ID:",
      FR: "Report ID:",
      TR: "Report ID:"
    },
    SUBSCRIPTION: {
      ENG: "Subscription",
      AR: "Subscription",
      FR: "Subscription",
      TR: "Subscription"
    },
    AUDITOR_EVENTS_DATA: {
      AR: "Auditors Events Data",
      ENG: "Auditors Events Data",
      FR: "Auditors Events Data",
      TR: "Auditors Events Data"
    },
    AUDITORS_EFFICIENCY: {
      AR: "Auditors Efficiency",
      ENG: "Auditors Efficiency",
      FR: "Auditors Efficiency",
      TR: "Auditors Efficiency"
    },
    TURN_KHATTABAT_ON_OFF: {
      ENG: "Turn Khattabat on/off",
      AR: "Turn Khattabat on/off",
      FR: "Turn Khattabat on/off",
      TR: "Turn Khattabat on/off"
    },
    UPDATE: {
      ENG: "Update",
      AR: "Update",
      FR: "Update",
      TR: "Update"
    },
    RC_CAPACITY: {
      ENG: "RC Capacity",
      AR: "RC Capacity",
      FR: "RC Capacity",
      TR: "RC Capacity"
    },
    REACTIVATE: {
      ENG: "Reactivate",
      AR: "Reactivate",
      FR: "Reactivate",
      TR: "Reactivate"
    },
    ACCOUNT_CREATED_ON: {
      AR: "Account Created on",
      ENG: "Account Created on",
      FR: "Account Created on",
      TR: "Account Created on"
    },
    DELETED_BY_MATCH: {
      AR: "Deleted By Match",
      ENG: "Deleted By Match",
      FR: "Deleted By Match",
      TR: "Deleted By Match"
    },
    AMOUNT: {
      AR: "Amount",
      ENG: "Amount",
      FR: "Amount",
      TR: "Amount"
    },
    FREE_PAID_IN_HOURS_DAYS: {
      AR: "(Free in hours, Paid in Days)",
      ENG: "(Free in hours, Paid in Days)",
      FR: "(Free in hours, Paid in Days)",
      TR: "(Free in hours, Paid in Days)"
    },
    MESSAGE_ERA: {
      AR: "Message Era",
      ENG: "Message Era",
      FR: "Message Era",
      TR: "Message Era"
    },
    KHATTABAT_DATA: {
      AR: "Khattabat Data",
      ENG: "Khattabat Data",
      FR: "Khattabat Data",
      TR: "Khattabat Data"
    },
    GET_LATEST: {
      AR: "Get Latest",
      ENG: "Get Latest",
      FR: "Get Latest",
      TR: "Get Latest"
    },
    DATA_COLLECTION: {
      AR: "Data Collection",
      ENG: "Data Collection",
      FR: "Data Collection",
      TR: "Data Collection"
    },
    NEW_CLIENTS: {
      AR: "New Clients",
      ENG: "New Clients",
      FR: "New Clients",
      TR: "New Clients"
    },
    CAPACITY: {
      AR: "Capacity",
      ENG: "Capacity",
      FR: "Capacity",
      TR: "Capacity"
    },
    ASSIGN_CLIENT_TO_ME: {
      AR: "Assign Client To Me",
      ENG: "Assign Client To Me",
      FR: "Assign Client To Me",
      TR: "Assign Client To Me"
    },
    LIMIT_REACHED_KHATTABA_CLIENTS: {
      AR: "You have reached the limit of number of clients, contact your supervisor",
      ENG: "You have reached the limit of number of clients, contact your supervisor",
      FR: "You have reached the limit of number of clients, contact your supervisor",
      TR: "You have reached the limit of number of clients, contact your supervisor"
    },
    NO_NEW_CLIENTS_AVAILABLE: {
      AR: "There are no new clients right now",
      ENG: "There are no new clients right now",
      FR: "There are no new clients right now",
      TR: "There are no new clients right now"
    },
    ASSIGN_NEW_CLIENT_CONFIRMATION_POP_UP: {
      AR: "Are you sure you want to assign a new client to your account?",
      ENG: "Are you sure you want to assign a new client to your account?",
      FR: "Are you sure you want to assign a new client to your account?",
      TR: "Are you sure you want to assign a new client to your account?"
    },
    DEBUG_IMAGE_AI: {
      AR: "Debug Image AI",
      ENG: "Debug Image AI",
      TR: "Debug Image AI",
      FR: "Debug Image AI"
    },
    DOWNLOAD_CSV: {
      AR: "Download CSV",
      ENG: "Download CSV",
      FR: "Download CSV",
      TR: "Download CSV"
    },
    WAS_STRIPE_USER: {
      AR: "Was Stripe User",
      ENG: "Was Stripe User",
      FR: "Was Stripe User",
      TR: "Was Stripe User"
    },
    KHATTABA_102_COUNTER: {
      AR: "K:%EXTRA_DATA%",
      ENG: "K:%EXTRA_DATA%",
      FR: "K:%EXTRA_DATA%",
      TR: "K:%EXTRA_DATA%"
    },
    CLIENT_102_COUNTER: {
      AR: "C:%EXTRA_DATA%",
      ENG: "C:%EXTRA_DATA%",
      FR: "C:%EXTRA_DATA%",
      TR: "C:%EXTRA_DATA%"
    },
    MATCH_102_COUNTER: {
      AR: "M:%EXTRA_DATA%",
      ENG: "M:%EXTRA_DATA%",
      FR: "M:%EXTRA_DATA%",
      TR: "M:%EXTRA_DATA%"
    },
    QUALITY: {
      AR: "Quality",
      ENG: "Quality",
      FR: "Quality",
      TR: "Quality"
    },
    NOTICE_EMAIL: {
      AR: "Notice Email",
      ENG: "Notice Email",
      FR: "Notice Email",
      TR: "Notice Email"
    },
    REACTIVATE_KHATTABA_CLIENT_CONFIRMATION_POP_UP: {
      AR: "Are you sure you want to send a notice email to this client?",
      ENG: "Are you sure you want to send a notice email to this client?",
      FR: "Are you sure you want to send a notice email to this client?",
      TR: "Are you sure you want to send a notice email to this client?"
    },
    CANNOT_REACTIVATE_KHATTABA_CLIENT_POPUP: {
      AR: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive",
      ENG: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive",
      FR: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive",
      TR: "Notice email cannot be sent at this stage because the subscription of the user is either not active and or is still responsive"
    },
    SILVER_SUBSCRIPTION_HISTORY_FOR: {
      AR: "SILVER Subscription History For",
      ENG: "SILVER Subscription History For",
      FR: "SILVER Subscription History For",
      TR: "SILVER Subscription History For"
    },
    GOLD_SUBSCRIPTION_HISTORY_FOR: {
      AR: "GOLD Subscription History For",
      ENG: "GOLD Subscription History For",
      FR: "GOLD Subscription History For",
      TR: "GOLD Subscription History For"
    },
    BLACK_SUBSCRIPTION_HISTORY_FOR: {
      AR: "BLACK Subscription History For",
      ENG: "BLACK Subscription History For",
      FR: "BLACK Subscription History For",
      TR: "BLACK Subscription History For"
    },
    PLATINUM_SUBSCRIPTION_HISTORY_FOR: {
      AR: "PLATINUM Subscription History For",
      ENG: "PLATINUM Subscription History For",
      FR: "PLATINUM Subscription History For",
      TR: "PLATINUM Subscription History For"
    },
    POWER_BUNDLE_SUBSCRIPTION_HISTORY_FOR: {
      AR: "POWER BUNDLE Subscription History For",
      ENG: "POWER BUNDLE Subscription History For",
      FR: "POWER BUNDLE Subscription History For",
      TR: "POWER BUNDLE Subscription History For"
    },
    READ_SUBSCRIPTION_HISTORY_FOR: {
      AR: "READ Subscription History For",
      ENG: "READ Subscription History For",
      FR: "READ Subscription History For",
      TR: "READ Subscription History For"
    },
    VIP_SUBSCRIPTION_HISTORY_FOR: {
      AR: "VIP Subscription History For",
      ENG: "VIP Subscription History For",
      FR: "VIP Subscription History For",
      TR: "VIP Subscription History For"
    },
    PLUS_SUBSCRIPTION_HISTORY_FOR: {
      AR: "PLUS Subscription History For",
      ENG: "PLUS Subscription History For",
      FR: "PLUS Subscription History For",
      TR: "PLUS Subscription History For"
    },
    KHATTABAT_SUBSCRIPTION_HISTORY_FOR: {
      AR: "KHATTABAT Subscription History For",
      ENG: "KHATTABAT Subscription History For",
      FR: "KHATTABAT Subscription History For",
      TR: "KHATTABAT Subscription History For"
    },
    BOOST_SUBSCRIPTION_HISTORY_FOR: {
      AR: "BOOST Subscription History For",
      ENG: "BOOST Subscription History For",
      FR: "BOOST Subscription History For",
      TR: "BOOST Subscription History For"
    },
    COUNT_HINT_SUBTEXT: {
      AR: "(Count)",
      ENG: "(Count)",
      FR: "(Count)",
      TR: "(Count)"
    },
    REWIND_SUBSCRIPTION_HISTORY_FOR: {
      AR: "REWIND Subscription History For",
      ENG: "REWIND Subscription History For",
      FR: "REWIND Subscription History For",
      TR: "REWIND Subscription History For"
    },
    SELFIE_VERIFICATION_PHOTOS: {
      AR: "Selfie Verification Photos",
      ENG: "Selfie Verification Photos",
      FR: "Selfie Verification Photos",
      TR: "Selfie Verification Photos"
    },
    AI_DESCRIPTIONS: {
      AR: "AI Descriptions",
      ENG: "AI Descriptions",
      FR: "AI Descriptions",
      TR: "AI Descriptions"
    },
    AI_GENERATED_DESCRIPTION_ALL: {
      AR: "AI Generated Description All",
      ENG: "AI Generated Description All",
      FR: "AI Generated Description All",
      TR: "AI Generated Description All"
    },
    ID: {
      AR: "ID",
      ENG: "ID",
      FR: "ID",
      TR: "ID"
    },
    USAGE: {
      AR: "Usage",
      ENG: "Usage",
      FR: "Usage",
      TR: "Usage"
    },
    GPT_MODEL: {
      AR: "GPT Model",
      ENG: "GPT Model",
      FR: "GPT Model",
      TR: "GPT Model"
    },
    CLAUDE_MODEL: {
      AR: "Claude Model",
      ENG: "Claude Model",
      FR: "Claude Model",
      TR: "Claude Model"
    },
    GPT_DESCRIPTION: {
      AR: "GPT Description",
      ENG: "GPT Description",
      FR: "GPT Description",
      TR: "GPT Description"
    },
    CLAUDE_DESCRIPTION: {
      AR: "Claude Description",
      ENG: "Claude Description",
      FR: "Claude Description",
      TR: "Claude Description"
    },
    FINAL_DESCRIPTION: {
      AR: "Final Description",
      ENG: "Final Description",
      FR: "Final Description",
      TR: "Final Description"
    },
    MATCH_PERCENTAGE_GPT: {
      AR: "Match % (GPT)",
      ENG: "Match % (GPT)",
      FR: "Match % (GPT)",
      TR: "Match % (GPT)"
    },
    MATCH_PERCENTAGE_CLAUDE: {
      AR: "Match % (Claude)",
      ENG: "Match % (Claude)",
      FR: "Match % (Claude)",
      TR: "Match % (Claude)"
    },
    KHATTABA_V3_IS_ALREADY_TURNED_OFF: {
      AR: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required",
      ENG: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required",
      FR: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required",
      TR: "This Khattabat MCQ Services feature has already been turned off automatically by the system. No further action is required"
    },
    KHATTABA_V3_CANNOT_TURN_ON_COUNTRY_NONE: {
      AR: "Khattabat Service cannot be turned on if it is set to None for any country.",
      ENG: "Khattabat Service cannot be turned on if it is set to None for any country.",
      FR: "Khattabat Service cannot be turned on if it is set to None for any country.",
      TR: "Khattabat Service cannot be turned on if it is set to None for any country."
    },
    SUPERVISOR_KHATTABAT_FUNNEL_STATS: {
      AR: "Khattabat Funnel Stats",
      ENG: "Khattabat Funnel Stats",
      FR: "Khattabat Funnel Stats",
      TR: "Khattabat Funnel Stats"
    },
    SUPERVISOR_KHATTABAT_FUNNEL_STATS_DATA: {
      AR: "Funnel Stats Data",
      ENG: "Funnel Stats Data",
      FR: "Funnel Stats Data",
      TR: "Funnel Stats Data"
    },
    MATCHMAKING_AUDIT: {
      AR: "Matchmaking Audit",
      ENG: "Matchmaking Audit",
      FR: "Matchmaking Audit",
      TR: "Matchmaking Audit"
    },
    MATCHMAKING_AUDIT_DATA: {
      AR: "Matchmaking Audit Data",
      ENG: "Matchmaking Audit Data",
      FR: "Matchmaking Audit Data",
      TR: "Matchmaking Audit Data"
    },
    INCOME: {
      AR: "Income",
      ENG: "Income",
      FR: "Income",
      TR: "Income"
    },
    BP_USERS: {
      AR: "BP Users",
      ENG: "BP Users",
      TR: "BP Users",
      FR: "BP Users"
    },
    ADMIN_USAGE_DATA: {
      AR: "Admin Usage Data",
      ENG: "Admin Usage Data",
      TR: "Admin Usage Data",
      FR: "Admin Usage Data"
    },
    SUB_TAB_ACCESS_SUMMARY: {
      AR: "Sub Tab Access Summary",
      ENG: "Sub Tab Access Summary",
      TR: "Sub Tab Access Summary",
      FR: "Sub Tab Access Summary"
    },
    GENERATED_TABLES_SUMMARY: {
      AR: "Generated Tables Summary",
      ENG: "Generated Tables Summary",
      TR: "Generated Tables Summary",
      FR: "Generated Tables Summary"
    },
    USER_UNDER_CSR_INVESTIGATION_BUT_WILL_APPEAR_SOON: {
      AR: "User is currently under investigation and will appear when the time is right",
      ENG: "User is currently under investigation and will appear when the time is right",
      TR: "User is currently under investigation and will appear when the time is right",
      FR: "User is currently under investigation and will appear when the time is right"
    },
    MIN_HEIGHT: {
      AR: "Min Height",
      ENG: "Min Height",
      TR: "Min Height",
      FR: "Min Height"
    },
    MAX_HEIGHT: {
      AR: "Max Height",
      ENG: "Max Height",
      TR: "Max Height",
      FR: "Max Height"
    },
    MIN_WEIGHT: {
      AR: "Min Weight",
      ENG: "Min Weight",
      TR: "Min Weight",
      FR: "Min Weight"
    },
    MAX_WEIGHT: {
      AR: "Max Weight",
      ENG: "Max Weight",
      TR: "Max Weight",
      FR: "Max Weight"
    },
    MIN_AGE_LESS_THAN_MAX_AGE: {
      AR: "Minimum age should be less than maximum age",
      ENG: "Minimum age should be less than maximum age",
      TR: "Minimum age should be less than maximum age",
      FR: "Minimum age should be less than maximum age"
    },

    MIN_WEIGHT_LESS_THAN_MAX_WEIGHT: {
      AR: "Minimum weight should be less than maximum weight",
      ENG: "Minimum weight should be less than maximum weight",
      TR: "Minimum weight should be less than maximum weight",
      FR: "Minimum weight should be less than maximum weight"
    },

    MIN_HEIGHT_LESS_THAN_MAX_HEIGHT: {
      AR: "Minimum height should be less than maximum height",
      ENG: "Minimum height should be less than maximum height",
      TR: "Minimum height should be less than maximum height",
      FR: "Minimum height should be less than maximum height"
    },

    FEATURE_ROLLOUT_PERCENTAGE: {
      ENG: "Feature RO %",
      AR: "Feature RO %",
      FR: "Feature RO %",
      TR: "Feature RO %"
    },
    EXCLUDE: {
      AR: "Exclude",
      FR: "Exclude",
      TR: "Exclude",
      ENG: "Exclude"
    },
    ALL_CLIENTS: {
      AR: "All Clients",
      FR: "All Clients",
      TR: "All Clients",
      ENG: "All Clients"
    },
    REQUIRES_ATTENTION: {
      AR: "Requires Attention",
      FR: "Requires Attention",
      TR: "Requires Attention",
      ENG: "Requires Attention"
    },
    OTHER_AUDITORS_PERFORMANCE: {
      AR: "Other Auditors Performance",
      FR: "Other Auditors Performance",
      TR: "Other Auditors Performance",
      ENG: "Other Auditors Performance"
    },
    BAN_SCAMMER: {
      AR: "Ban - Scammer",
      FR: "Ban - Scammer",
      TR: "Ban - Scammer",
      ENG: "Ban - Scammer"
    },
    WARN_SOCIAL_MEDIA_ACCOUNT: {
      AR: "Warn - Social Media Account",
      FR: "Warn - Social Media Account",
      TR: "Warn - Social Media Account",
      ENG: "Warn - Social Media Account"
    },
    WARN_BAD_LANGUAGE: {
      AR: "Warn - Bad Language",
      FR: "Warn - Bad Language",
      TR: "Warn - Bad Language",
      ENG: "Warn - Bad Language"
    },
    REPORT_ACTIONS_ANALYTICS: {
      AR: "Report Actions Analytics",
      FR: "Report Actions Analytics",
      TR: "Report Actions Analytics",
      ENG: "Report Actions Analytics"
    },
    REPORT_ACTIONS: {
      AR: "Report Actions",
      FR: "Report Actions",
      TR: "Report Actions",
      ENG: "Report Actions"
    },
    REPORT_ACTION_REASONS: {
      AR: "Report Action Reasons",
      FR: "Report Action Reasons",
      TR: "Report Action Reasons",
      ENG: "Report Action Reasons"
    },
    KHATTABA_QUIZ_STATUS: {
      AR: "status",
      FR: "status",
      TR: "status",
      ENG: "status"
    },
    KHATTABA_QUIZ_STATS: {
      AR: "stats",
      FR: "stats",
      TR: "stats",
      ENG: "stats"
    },
    NO_AI_APPLICATIONS_FOUND: {
      AR: "No results found, users might have valid applications during a different time period",
      FR: "No results found, users might have valid applications during a different time period",
      TR: "No results found, users might have valid applications during a different time period",
      ENG: "No results found, users might have valid applications during a different time period"
    },
    AI_FILTER_USER_ID_DOMINANCE: {
      AR: "UserID search criteria cannot be combined with other search criteria",
      FR: "UserID search criteria cannot be combined with other search criteria",
      TR: "UserID search criteria cannot be combined with other search criteria",
      ENG: "UserID search criteria cannot be combined with other search criteria"
    },
    INVALID_AGE: {
      AR: "Invalid Age",
      FR: "Invalid Age",
      TR: "Invalid Age",
      ENG: "Invalid Age"
    },
    KHATTABA_V3_AI_IS_ALREADY_TURNED_OFF: {
      AR: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required",
      ENG: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required",
      FR: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required",
      TR: "This Khattabat AI Services feature has already been turned off automatically by the system. No further action is required"
    },
    PLATINUM: {
      AR: "Platinum",
      ENG: "Platinum",
      FR: "Platinum",
      TR: "Platinum"
    },
    SILVER: {
      AR: "Silver",
      ENG: "Silver",
      FR: "Silver",
      TR: "Silver"
    },
    GOLD: {
      AR: "Gold",
      ENG: "Gold",
      FR: "Gold",
      TR: "Gold"
    },
    SILVER_DAYS: {
      AR: "Silver Days",
      ENG: "Silver Days",
      FR: "Silver Days",
      TR: "Silver Days"
    },
    GOLD_DAYS: {
      AR: "Gold Days",
      ENG: "Gold Days",
      FR: "Gold Days",
      TR: "Gold Days"
    },
    PLATINUM_DAYS: {
      AR: "Platinum Days",
      ENG: "Platinum Days",
      FR: "Platinum Days",
      TR: "Platinum Days"
    },
    ADVANCED_DAYS: {
      AR: "Advanced Days",
      ENG: "Advanced Days",
      FR: "Advanced Days",
      TR: "Advanced Days"
    },
    SILVER_HOURS: {
      AR: "Silver Hours",
      ENG: "Silver Hours",
      FR: "Silver Hours",
      TR: "Silver Hours"
    },
    GOLD_HOURS: {
      AR: "Gold Hours",
      ENG: "Gold Hours",
      FR: "Gold Hours",
      TR: "Gold Hours"
    },
    PLATINUM_HOURS: {
      AR: "Platinum Hours",
      ENG: "Platinum Hours",
      FR: "Platinum Hours",
      TR: "Platinum Hours"
    },
    ADVANCED_HOURS: {
      AR: "Advanced Hours",
      ENG: "Advanced Hours",
      FR: "Advanced Hours",
      TR: "Advanced Hours"
    },
    SILVER_MIN: {
      AR: "Silver Min",
      ENG: "Silver Min",
      FR: "Silver Min",
      TR: "Silver Min"
    },
    ADVANCED_MIN: {
      AR: "Advanced Min",
      ENG: "Advanced Min",
      FR: "Advanced Min",
      TR: "Advanced Min"
    },
    GOLD_MIN: {
      AR: "Gold Min",
      ENG: "Gold Min",
      FR: "Gold Min",
      TR: "Gold Min"
    },
    PLATINUM_MIN: {
      AR: "Platinum Min",
      ENG: "Platinum Min",
      FR: "Platinum Min",
      TR: "Platinum Min"
    },
    MAKE_SILVER: {
      AR: "Make Silver",
      ENG: "Make Silver",
      FR: "Make Silver",
      TR: "Make Silver"
    },
    MAKE_GOLD: {
      AR: "Make Gold",
      ENG: "Make Gold",
      FR: "Make Gold",
      TR: "Make Gold"
    },
    MAKE_PLATINUM: {
      AR: "Make Platinum",
      ENG: "Make Platinum",
      FR: "Make Platinum",
      TR: "Make Platinum"
    },
    SILVER_IN_DAYS: {
      AR: `Silver in days should be maximum ${MAX_GIVE_SILVER_IN_DAYS}`,
      ENG: `Silver in days should be maximum ${MAX_GIVE_SILVER_IN_DAYS}`,
      FR: `Silver in days should be maximum ${MAX_GIVE_SILVER_IN_DAYS}`,
      TR: `Silver in days should be maximum ${MAX_GIVE_SILVER_IN_DAYS}`
    },
    SILVER_IN_DAYS_MIN: {
      AR: `Silver in days should be minimum ${MIN_GIVE_SILVER_IN_DAYS}`,
      ENG: `Silver in days should be minimum ${MIN_GIVE_SILVER_IN_DAYS}`,
      FR: `Silver in days should be minimum ${MIN_GIVE_SILVER_IN_DAYS}`,
      TR: `Silver in days should be minimum ${MIN_GIVE_SILVER_IN_DAYS}`
    },
    SILVER_IN_HOURS: {
      AR: `Silver in hours should be maximum ${MAX_GIVE_SILVER_IN_HOURS}`,
      ENG: `Silver in hours should be maximum ${MAX_GIVE_SILVER_IN_HOURS}`,
      FR: `Silver in hours should be maximum ${MAX_GIVE_SILVER_IN_HOURS}`,
      TR: `Silver in hours should be maximum ${MAX_GIVE_SILVER_IN_HOURS}`
    },
    SILVER_IN_MIN: {
      AR: `Silver in min should be maximum ${MAX_GIVE_SILVER_IN_MIN}`,
      ENG: `Silver in min should be maximum ${MAX_GIVE_SILVER_IN_MIN}`,
      FR: `Silver in min should be maximum ${MAX_GIVE_SILVER_IN_MIN}`,
      TR: `Silver in min should be maximum ${MAX_GIVE_SILVER_IN_MIN}`
    },
    GOLD_IN_DAYS: {
      AR: `Gold in days should be maximum ${MAX_GIVE_GOLD_IN_DAYS}`,
      ENG: `Gold in days should be maximum ${MAX_GIVE_GOLD_IN_DAYS}`,
      FR: `Gold in days should be maximum ${MAX_GIVE_GOLD_IN_DAYS}`,
      TR: `Gold in days should be maximum ${MAX_GIVE_GOLD_IN_DAYS}`
    },
    GOLD_IN_DAYS_MIN: {
      AR: `Gold in days should be minimum ${MIN_GIVE_GOLD_IN_DAYS}`,
      ENG: `Gold in days should be minimum ${MIN_GIVE_GOLD_IN_DAYS}`,
      FR: `Gold in days should be minimum ${MIN_GIVE_GOLD_IN_DAYS}`,
      TR: `Gold in days should be minimum ${MIN_GIVE_GOLD_IN_DAYS}`
    },
    GOLD_IN_HOURS: {
      AR: `Gold in hours should be maximum ${MAX_GIVE_GOLD_IN_HOURS}`,
      ENG: `Gold in hours should be maximum ${MAX_GIVE_GOLD_IN_HOURS}`,
      FR: `Gold in hours should be maximum ${MAX_GIVE_GOLD_IN_HOURS}`,
      TR: `Gold in hours should be maximum ${MAX_GIVE_GOLD_IN_HOURS}`
    },
    GOLD_IN_MIN: {
      AR: `Gold in min should be maximum ${MAX_GIVE_GOLD_IN_MIN}`,
      ENG: `Gold in min should be maximum ${MAX_GIVE_GOLD_IN_MIN}`,
      FR: `Gold in min should be maximum ${MAX_GIVE_GOLD_IN_MIN}`,
      TR: `Gold in min should be maximum ${MAX_GIVE_GOLD_IN_MIN}`
    },
    PLATINUM_IN_DAYS: {
      AR: `Platinum in days should be maximum ${MAX_GIVE_PLATINUM_IN_DAYS}`,
      ENG: `Platinum in days should be maximum ${MAX_GIVE_PLATINUM_IN_DAYS}`,
      FR: `Platinum in days should be maximum ${MAX_GIVE_PLATINUM_IN_DAYS}`,
      TR: `Platinum in days should be maximum ${MAX_GIVE_PLATINUM_IN_DAYS}`
    },
    PLATINUM_IN_DAYS_MIN: {
      AR: `Platinum in days should be minimum ${MIN_GIVE_PLATINUM_IN_DAYS}`,
      ENG: `Platinum in days should be minimum ${MIN_GIVE_PLATINUM_IN_DAYS}`,
      FR: `Platinum in days should be minimum ${MIN_GIVE_PLATINUM_IN_DAYS}`,
      TR: `Platinum in days should be minimum ${MIN_GIVE_PLATINUM_IN_DAYS}`
    },
    PLATINUM_IN_HOURS: {
      AR: `Platinum in hours should be maximum ${MAX_GIVE_PLATINUM_IN_HOURS}`,
      ENG: `Platinum in hours should be maximum ${MAX_GIVE_PLATINUM_IN_HOURS}`,
      FR: `Platinum in hours should be maximum ${MAX_GIVE_PLATINUM_IN_HOURS}`,
      TR: `Platinum in hours should be maximum ${MAX_GIVE_PLATINUM_IN_HOURS}`
    },
    PLATINUM_IN_MIN: {
      AR: `Platinum in min should be maximum ${MAX_GIVE_PLATINUM_IN_MIN}`,
      ENG: `Platinum in min should be maximum ${MAX_GIVE_PLATINUM_IN_MIN}`,
      FR: `Platinum in min should be maximum ${MAX_GIVE_PLATINUM_IN_MIN}`,
      TR: `Platinum in min should be maximum ${MAX_GIVE_PLATINUM_IN_MIN}`
    },
    USER_SILVER_ADDED_SUCCESSFULLY: {
      ENG: "User SILVER added successfully",
      AR: "User SILVER added successfully",
      FR: "User SILVER added successfully",
      TR: "User SILVER added successfully"
    },
    USER_GOLD_ADDED_SUCCESSFULLY: {
      ENG: "User GOLD added successfully",
      AR: "User GOLD added successfully",
      FR: "User GOLD added successfully",
      TR: "User GOLD added successfully"
    },
    USER_PLATINUM_ADDED_SUCCESSFULLY: {
      ENG: "User PLATINUM added successfully",
      AR: "User PLATINUM added successfully",
      FR: "User PLATINUM added successfully",
      TR: "User PLATINUM added successfully"
    },
    USER_ADVANCED_ADDED_SUCCESSFULLY: {
      ENG: "User ADVANCED added successfully",
      AR: "User ADVANCED added successfully",
      FR: "User ADVANCED added successfully",
      TR: "User ADVANCED added successfully"
    },
    SILVER_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free Silver to this user?",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free Silver to this user?",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free Silver to this user?",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free Silver to this user?"
    },
    GOLD_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free Gold to this user?",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free Gold to this user?",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free Gold to this user?",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free Gold to this user?"
    },
    BLACK: {
      AR: "BLACK",
      ENG: "BLACK",
      FR: "BLACK",
      TR: "BLACK"
    },
    BLACK_DAYS: {
      AR: "Black Days",
      ENG: "Black Days",
      FR: "Black Days",
      TR: "Black Days"
    },
    BLACK_HOURS: {
      AR: "Black Hours",
      ENG: "Black Hours",
      FR: "Black Hours",
      TR: "Black Hours"
    },
    BLACK_MIN: {
      AR: "Black Min",
      ENG: "Black Min",
      FR: "Black Min",
      TR: "Black Min"
    },
    MAKE_BLACK: {
      AR: "Make Black",
      ENG: "Make Black",
      FR: "Make Black",
      TR: "Make Black"
    },
    BLACK_IN_DAYS: {
      AR: `Black in days should be maximum ${MAX_GIVE_BLACK_IN_DAYS}`,
      ENG: `Black in days should be maximum ${MAX_GIVE_BLACK_IN_DAYS}`,
      FR: `Black in days should be maximum ${MAX_GIVE_BLACK_IN_DAYS}`,
      TR: `Black in days should be maximum ${MAX_GIVE_BLACK_IN_DAYS}`
    },
    BLACK_IN_HOURS: {
      AR: `Black in hours should be maximum ${MAX_GIVE_BLACK_IN_HOURS}`,
      ENG: `Black in hours should be maximum ${MAX_GIVE_BLACK_IN_HOURS}`,
      FR: `Black in hours should be maximum ${MAX_GIVE_BLACK_IN_HOURS}`,
      TR: `Black in hours should be maximum ${MAX_GIVE_BLACK_IN_HOURS}`
    },
    BLACK_IN_MIN: {
      AR: `Black in min should be maximum ${MAX_GIVE_BLACK_IN_MIN}`,
      ENG: `Black in min should be maximum ${MAX_GIVE_BLACK_IN_MIN}`,
      FR: `Black in min should be maximum ${MAX_GIVE_BLACK_IN_MIN}`,
      TR: `Black in min should be maximum ${MAX_GIVE_BLACK_IN_MIN}`
    },
    BLACK_IN_DAYS_MIN: {
      AR: `Black in days should be minimum ${MIN_GIVE_BLACK_IN_DAYS}`,
      ENG: `Black in days should be minimum ${MIN_GIVE_BLACK_IN_DAYS}`,
      FR: `Black in days should be minimum ${MIN_GIVE_BLACK_IN_DAYS}`,
      TR: `Black in days should be minimum ${MIN_GIVE_BLACK_IN_DAYS}`
    },
    USER_BLACK_ADDED_SUCCESSFULLY: {
      ENG: "User BLACK added successfully",
      AR: "User BLACK added successfully",
      FR: "User BLACK added successfully",
      TR: "User BLACK added successfully"
    },
    BLACK_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free Black to this user?",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free Black to this user?",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free Black to this user?",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free Black to this user?"
    },
    SUBSCRIPTION_SECTION_LEGACY_TITLE: {
      AR: "Legacy plans",
      ENG: "Legacy plans",
      FR: "Legacy plans",
      TR: "Legacy plans"
    },
    SUBSCRIPTION_SECTION_LEGACY_SUBTITLE: {
      AR: "For apps before v9.5.0",
      ENG: "For apps before v9.5.0",
      FR: "For apps before v9.5.0",
      TR: "For apps before v9.5.0"
    },
    SUBSCRIPTION_SECTION_TIERS_TITLE: {
      AR: "Subscription tiers",
      ENG: "Subscription tiers",
      FR: "Subscription tiers",
      TR: "Subscription tiers"
    },
    SUBSCRIPTION_SECTION_TIERS_SUBTITLE: {
      AR: "For apps v9.5.0 and later",
      ENG: "For apps v9.5.0 and later",
      FR: "For apps v9.5.0 and later",
      TR: "For apps v9.5.0 and later"
    },
    SUBSCRIPTION_SECTION_REFERRAL_TITLE: {
      AR: "Referral",
      ENG: "Referral",
      FR: "Referral",
      TR: "Referral"
    },
    SUBSCRIPTION_SECTION_REFERRAL_SUBTITLE: {
      AR: "iOS referral cases only",
      ENG: "iOS referral cases only",
      FR: "iOS referral cases only",
      TR: "iOS referral cases only"
    },
    SUBSCRIPTION_SECTION_KHATTABAT_TITLE: {
      AR: "Khattabat",
      ENG: "Khattabat",
      FR: "Khattabat",
      TR: "Khattabat"
    },
    SUBSCRIPTION_SECTION_KHATTABAT_SUBTITLE: {
      AR: "Standalone",
      ENG: "Standalone",
      FR: "Standalone",
      TR: "Standalone"
    },
    PLATINUM_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free Platinum to this user?",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free Platinum to this user?",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free Platinum to this user?",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free Platinum to this user?"
    },
    APP_VERSION_BELOW_NINE_POINT_FIVE: {
      AR: "User’s app version doesnt support this subscription plan",
      ENG: "User’s app version doesnt support this subscription plan",
      FR: "User’s app version doesnt support this subscription plan",
      TR: "User’s app version doesnt support this subscription plan"
    },
    SUBSCRIPTION_TIME_CONFIRMATION: {
      ENG: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)",
      AR: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)",
      FR: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)",
      TR: "%EXTRA_DATA_0% (Day/s), %EXTRA_DATA_1% (Hour/s) and %EXTRA_DATA_2% (Minute/s)"
    },
    PROMO_CODE_REWARD_TYPE: {
      ENG: "Reward Type",
      AR: "Reward Type",
      FR: "Reward Type",
      TR: "Reward Type"
    },
    MAKE_ADVANCED: {
      AR: "Make Advanced",
      ENG: "Make Advanced",
      FR: "Make Advanced",
      TR: "Make Advanced"
    },
    ADVANCED_CONFIRMATION_POPUP: {
      AR: "Are you sure you want to give '%EXTRA_DATA%' of free Advanced to this user?",
      ENG: "Are you sure you want to give '%EXTRA_DATA%' of free Advanced to this user?",
      FR: "Are you sure you want to give '%EXTRA_DATA%' of free Advanced to this user?",
      TR: "Are you sure you want to give '%EXTRA_DATA%' of free Advanced to this user?"
    },
    ADVANCED_IN_DAYS: {
      AR: `Advanced in days should be maximum ${MAX_GIVE_ADVANCED_IN_DAYS}`,
      ENG: `Advanced in days should be maximum ${MAX_GIVE_ADVANCED_IN_DAYS}`,
      FR: `Advanced in days should be maximum ${MAX_GIVE_ADVANCED_IN_DAYS}`,
      TR: `Advanced in days should be maximum ${MAX_GIVE_ADVANCED_IN_DAYS}`
    },
    ADVANCED_IN_HOURS: {
      AR: `Advanced in hours should be maximum ${MAX_GIVE_ADVANCED_IN_HOURS}`,
      ENG: `Advanced in hours should be maximum ${MAX_GIVE_ADVANCED_IN_HOURS}`,
      FR: `Advanced in hours should be maximum ${MAX_GIVE_ADVANCED_IN_HOURS}`,
      TR: `Advanced in hours should be maximum ${MAX_GIVE_ADVANCED_IN_HOURS}`
    },
    ADVANCED_IN_MIN: {
      AR: `Advanced in min should be maximum ${MAX_GIVE_ADVANCED_IN_MIN}`,
      ENG: `Advanced in min should be maximum ${MAX_GIVE_ADVANCED_IN_MIN}`,
      FR: `Advanced in min should be maximum ${MAX_GIVE_ADVANCED_IN_MIN}`,
      TR: `Advanced in min should be maximum ${MAX_GIVE_ADVANCED_IN_MIN}`
    },
    MAX_GIVE_ADVANCED_IN_DAYS: {
      AR: "Max give advanced in days",
      ENG: "Max give advanced in days",
      FR: "Max give advanced in days",
      TR: "Max give advanced in days"
    },
    MAX_GIVE_ADVANCED_IN_HOURS: {
      AR: "Max give advanced in hours",
      ENG: "Max give advanced in hours",
      FR: "Max give advanced in hours",
      TR: "Max give advanced in hours"
    },
    MAX_GIVE_ADVANCED_IN_MIN: {
      AR: "Max give advanced in min",
      ENG: "Max give advanced in min",
      FR: "Max give advanced in min",
      TR: "Max give advanced in min"
    },
    ADVANCED_IOS: {
      AR: "Advanced(IOS Refferal)",
      ENG: "Advanced(IOS Refferal)",
      FR: "Advanced(IOS Refferal)",
      TR: "Advanced(IOS Refferal)"
    },
    BUNDLE: {
      AR: "BUNDLE",
      ENG: "BUNDLE",
      FR: "BUNDLE",
      TR: "BUNDLE"
    },
    SILVER_TAG: {
      AR: "SILVER",
      ENG: "SILVER",
      FR: "SILVER",
      TR: "SILVER"
    },
    GOLD_TAG: {
      AR: "GOLD",
      ENG: "GOLD",
      FR: "GOLD",
      TR: "GOLD"
    },
    BLACK_TAG: {
      AR: "BLACK",
      ENG: "BLACK",
      FR: "BLACK",
      TR: "BLACK"
    },
    PLATINUM_TAG: {
      AR: "PLATINUM",
      ENG: "PLATINUM",
      FR: "PLATINUM",
      TR: "PLATINUM"
    },
    ACTIVE_FEATURE_SETS: {
      AR: "Active Feature Sets:",
      ENG: "Active Feature Sets:",
      FR: "Active Feature Sets:",
      TR: "Active Feature Sets:"
    },
    ACTIVE_FEATURES: {
      AR: "Active Features (Consumables):",
      ENG: "Active Features (Consumables):",
      FR: "Active Features (Consumables):",
      TR: "Active Features (Consumables):"
    },
    FEATURE_SET_ACTIVE_FEATURES: {
      AR: "Features Active via Paid Feature Sets:",
      ENG: "Features Active via Paid Feature Sets:",
      FR: "Features Active via Paid Feature Sets:",
      TR: "Features Active via Paid Feature Sets:"
    },
    CONVERSATION_BADGE: {
      AR: "CONVERSATION",
      ENG: "CONVERSATION",
      FR: "CONVERSATION",
      TR: "CONVERSATION"
    },
    LIKES: {
      AR: "LIKES",
      ENG: "LIKES",
      FR: "LIKES",
      TR: "LIKES"
    },
    CONSUMABLES: {
      AR: "Consumables",
      ENG: "Consumables",
      FR: "Consumables",
      TR: "Consumables"
    },
    OTHER_SUBSCRIPTION_HISTORY_FOR: {
      AR: "Other Subscription History For",
      ENG: "Other Subscription History For",
      FR: "Other Subscription History For",
      TR: "Other Subscription History For"
    },
    TRIAL: {
      AR: "Trial",
      ENG: "Trial",
      FR: "Trial",
      TR: "Trial"
    },
    TRANSFER_USER_PACKAGE: {
      AR: "Transfer paid package",
      ENG: "Transfer paid package",
      FR: "Transfer paid package",
      TR: "Transfer paid package"
    },
    TRANSFER_USER_PACKAGE_SUB_TITLE: {
      AR: "Move an active paid package from one user to another. This cannot be undone.",
      ENG: "Move an active paid package from one user to another. This cannot be undone.",
      FR: "Move an active paid package from one user to another. This cannot be undone.",
      TR: "Move an active paid package from one user to another. This cannot be undone."
    },
    // Each %EXTRA_DATA_N% must appear at most once: getWithArrayExtraData uses
    // replace(), not replaceAll(), so a repeated slot would render literally.
    TRANSFER_USER_PACKAGE_CONFIRMATION_POPUP: {
      AR: "Transfer %EXTRA_DATA_2% from user %EXTRA_DATA_0% to user %EXTRA_DATA_1%? The source user loses it immediately and this cannot be undone.",
      ENG: "Transfer %EXTRA_DATA_2% from user %EXTRA_DATA_0% to user %EXTRA_DATA_1%? The source user loses it immediately and this cannot be undone.",
      FR: "Transfer %EXTRA_DATA_2% from user %EXTRA_DATA_0% to user %EXTRA_DATA_1%? The source user loses it immediately and this cannot be undone.",
      TR: "Transfer %EXTRA_DATA_2% from user %EXTRA_DATA_0% to user %EXTRA_DATA_1%? The source user loses it immediately and this cannot be undone."
    },
    TRANSFER_USER_PACKAGE_SUCCESS: {
      AR: "%EXTRA_DATA_0% transferred from user %EXTRA_DATA_1% to user %EXTRA_DATA_2%. New expiry: %EXTRA_DATA_3%",
      ENG: "%EXTRA_DATA_0% transferred from user %EXTRA_DATA_1% to user %EXTRA_DATA_2%. New expiry: %EXTRA_DATA_3%",
      FR: "%EXTRA_DATA_0% transferred from user %EXTRA_DATA_1% to user %EXTRA_DATA_2%. New expiry: %EXTRA_DATA_3%",
      TR: "%EXTRA_DATA_0% transferred from user %EXTRA_DATA_1% to user %EXTRA_DATA_2%. New expiry: %EXTRA_DATA_3%"
    },
    TRANSFER_PACKAGE_SAME_USER: {
      AR: "Source and target users must be different.",
      ENG: "Source and target users must be different.",
      FR: "Source and target users must be different.",
      TR: "Source and target users must be different."
    },
    TRANSFER_PACKAGE_NOT_TRANSFERABLE: {
      AR: "This package cannot be transferred between these two users.",
      ENG: "This package cannot be transferred between these two users.",
      FR: "This package cannot be transferred between these two users.",
      TR: "This package cannot be transferred between these two users."
    },
    TRANSFER_PACKAGE_SOURCE_NO_ACTIVE: {
      AR: "The source user has no active %EXTRA_DATA% to transfer.",
      ENG: "The source user has no active %EXTRA_DATA% to transfer.",
      FR: "The source user has no active %EXTRA_DATA% to transfer.",
      TR: "The source user has no active %EXTRA_DATA% to transfer."
    },
    TRANSFER_PACKAGE_TARGET_ALREADY_ACTIVE: {
      AR: "The target user already has an active %EXTRA_DATA%.",
      ENG: "The target user already has an active %EXTRA_DATA%.",
      FR: "The target user already has an active %EXTRA_DATA%.",
      TR: "The target user already has an active %EXTRA_DATA%."
    },
    TRANSFER_PACKAGE_GENDER_MISMATCH: {
      AR: "This package can only be transferred between users of the same gender.",
      ENG: "This package can only be transferred between users of the same gender.",
      FR: "This package can only be transferred between users of the same gender.",
      TR: "This package can only be transferred between users of the same gender."
    },
    TRANSFER_PACKAGE_UNKNOWN_GENDER: {
      AR: "This package is gendered, but the gender of one of these users is unknown.",
      ENG: "This package is gendered, but the gender of one of these users is unknown.",
      FR: "This package is gendered, but the gender of one of these users is unknown.",
      TR: "This package is gendered, but the gender of one of these users is unknown."
    },
    TRANSFER_PACKAGE_CURRENT_EXPIRY: {
      AR: "Current expiry date",
      ENG: "Current expiry date",
      FR: "Current expiry date",
      TR: "Current expiry date"
    },
    TRANSFER_PACKAGE_NEW_EXPIRY: {
      AR: "New expiry date",
      ENG: "New expiry date",
      FR: "New expiry date",
      TR: "New expiry date"
    },
    TRANSFER_PACKAGE_REMAINING_QUOTAS: {
      AR: "Remaining quotas (used / total)",
      ENG: "Remaining quotas (used / total)",
      FR: "Remaining quotas (used / total)",
      TR: "Remaining quotas (used / total)"
    },
    TRANSFER_PACKAGE_REMAINING_BALANCES: {
      AR: "Remaining balances (used / total)",
      ENG: "Remaining balances (used / total)",
      FR: "Remaining balances (used / total)",
      TR: "Remaining balances (used / total)"
    },
    TRANSFER_PACKAGE_NO_CONSUMABLES: {
      AR: "None",
      ENG: "None",
      FR: "None",
      TR: "None"
    },
    FROM_USER_ID: {
      AR: "From user ID",
      ENG: "From user ID",
      FR: "From user ID",
      TR: "From user ID"
    },
    TO_USER_ID: {
      AR: "To user ID",
      ENG: "To user ID",
      FR: "To user ID",
      TR: "To user ID"
    },
    PACKAGE_TYPE: {
      AR: "Package type",
      ENG: "Package type",
      FR: "Package type",
      TR: "Package type"
    },
    NOT_APPLICABLE: {
      AR: "N/A",
      ENG: "N/A",
      FR: "N/A",
      TR: "N/A"
    },
    CRITERIA_DESCRIPTION: {
      AR: "Description",
      ENG: "Description",
      FR: "Description",
      TR: "Description"
    },
    CRITERIA_PEER_DESCRIPTION: {
      AR: "Peer Description",
      ENG: "Peer Description",
      FR: "Peer Description",
      TR: "Peer Description"
    },
    PICTURES: {
      ENG: "Pictures",
      AR: "Pictures",
      FR: "Pictures",
      TR: "Pictures"
    },
    PENDING: {
      ENG: "Pending",
      AR: "Pending",
      FR: "Pending",
      TR: "Pending"
    },
    DELETED: {
      ENG: "Deleted",
      AR: "Deleted",
      FR: "Deleted",
      TR: "Deleted"
    },
    APPROVAL_NOTHING_TO_REVIEW: {
      ENG: "Nothing to review",
      AR: "Nothing to review",
      FR: "Nothing to review",
      TR: "Nothing to review"
    },
    NO_PICTURES_UPLOADED: {
      ENG: "No pictures uploaded",
      AR: "No pictures uploaded",
      FR: "No pictures uploaded",
      TR: "No pictures uploaded"
    },
    APPROVAL_ITEMS_PENDING: {
      ENG: "items pending",
      AR: "items pending",
      FR: "items pending",
      TR: "items pending"
    },
    APPROVAL_USERS_WITH_WORK: {
      ENG: "Users with work",
      AR: "Users with work",
      FR: "Users with work",
      TR: "Users with work"
    },
    APPROVAL_TO_REVIEW_COUNT: {
      ENG: "%EXTRA_DATA% to review",
      AR: "%EXTRA_DATA% to review",
      FR: "%EXTRA_DATA% to review",
      TR: "%EXTRA_DATA% to review"
    },
    APPROVAL_TOTAL_COUNT: {
      ENG: "%EXTRA_DATA% total",
      AR: "%EXTRA_DATA% total",
      FR: "%EXTRA_DATA% total",
      TR: "%EXTRA_DATA% total"
    },
    APPROVAL_OF_POOL: {
      ENG: "of %EXTRA_DATA%",
      AR: "of %EXTRA_DATA%",
      FR: "of %EXTRA_DATA%",
      TR: "of %EXTRA_DATA%"
    },
    APPROVAL_DECIDED_THIS_SESSION: {
      ENG: "decided this session",
      AR: "decided this session",
      FR: "decided this session",
      TR: "decided this session"
    },
    APPROVAL_NOT_LOADED_TITLE: {
      ENG: "Press Get to load the approval pool",
      AR: "Press Get to load the approval pool",
      FR: "Press Get to load the approval pool",
      TR: "Press Get to load the approval pool"
    },
    APPROVAL_NOT_LOADED_BODY: {
      ENG: "Choose a country and a limit, then press Get to fetch the users waiting for approval.",
      AR: "Choose a country and a limit, then press Get to fetch the users waiting for approval.",
      FR: "Choose a country and a limit, then press Get to fetch the users waiting for approval.",
      TR: "Choose a country and a limit, then press Get to fetch the users waiting for approval."
    },
    APPROVE_PICTURE: {
      ENG: "Approve picture",
      AR: "Approve picture",
      FR: "Approve picture",
      TR: "Approve picture"
    },
    ENLARGE_PICTURE: {
      ENG: "Enlarge picture",
      AR: "Enlarge picture",
      FR: "Enlarge picture",
      TR: "Enlarge picture"
    },
    CLOSE_PICTURE: {
      ENG: "Close picture",
      AR: "Close picture",
      FR: "Close picture",
      TR: "Close picture"
    },
    DEPRECATED: {
      AR: "Deprecated",
      ENG: "Deprecated",
      FR: "Deprecated",
      TR: "Deprecated"
    }
  },

  get(message) {
    const language = this.language.get();
    return this.LG[message] === undefined ||
      this.LG[message][language] === undefined
      ? message
      : this.LG[message][language];
  },
  getWithExtraData(message, extraData) {
    const language = this.language.get();
    const newMessage =
      !this.LG[message] || this.LG[message][language] === undefined
        ? message
        : this.LG[message][language];
    if (newMessage.indexOf("%EXTRA_DATA%") >= 0) {
      const parsedMessage = newMessage.replace(`%EXTRA_DATA%`, extraData);
      return parsedMessage;
    }
    return newMessage;
  },
  getWithArrayExtraData(message, extraData) {
    const language = this.language.get();
    const newMessage =
      !this.LG[message] || this.LG[message][language] === undefined
        ? message
        : this.LG[message][language];
    let parsedMessage = newMessage;
    for (let i = 0; i < extraData.length; i++) {
      if (newMessage.indexOf(`%EXTRA_DATA_${i}%`) >= 0) {
        parsedMessage = parsedMessage.replace(
          `%EXTRA_DATA_${i}%`,
          extraData[i]
        );
      }
    }
    return parsedMessage;
  }
};

export default i18n;
